// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-25T19:52:25.046Z
// Property: 1001 Tyvola (ID: 6767906449166947)
// Collections: 23 amenities, 10 floorplans (live), 144 photos, 82 POIs, 2 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166947",
  "property_external_id": "lclwzke",
  "property_zillow_url": "https://www.zillow.com/homedetails/1001-Tyvola-Rd-Charlotte-NC-28217/338424044_zpid/",
  "property_apartments_url": "https://www.apartments.com/tapestry-tyvola-charlotte-nc/lclwzke/",
  "property_google_business_url": "https://www.google.com/maps/place/1001+Tyvola/data=!4m2!3m1!1s0x0:0x63fe08697b6e92f6?sa=X&ved=2ahUKEwj4g6CL6aeSAxWySEEAHd5tBRoQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "48561424543",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "1134TYVO",
  "property_status": null,
  "property_slug": "1001-tyvola",
  "property_name": "1001 Tyvola",
  "property_website_url": "https://www.1001tyvola.com/",
  "property_domain": "https://www.1001tyvola.com/",
  "property_address": "2051 Establishment Way",
  "property_full_address": "2051 Establishment Wy, Charlotte, NC 28217, USA",
  "property_address_1": "2051 Establishment Way",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": null,
  "property_address_zip": "28217",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "Montclaire South",
  "property_address_latitude": "35.1660946",
  "property_address_longitude": "-80.8793608",
  "property_email": null,
  "property_phone": "980-427-9919",
  "property_call_tracking_phone": "(888) 595-4058",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At 1001 Tyvola in vibrant Charlotte, NC, modern living meets unmatched comfort. Choose from our varied floor plans, each equipped with high-end amenities like a sparkling pool, fitness center, and pet-friendly spaces. Experience a community that prioritizes your lifestyle—your ideal sanctuary awaits! Check availability and book a tour today!",
  "property_long_description": "Welcome to 1001 Tyvola, your premier destination for stylish apartment living in the heart of Charlotte, NC. Offering an array of versatile floor plans, including cozy studios, spacious one, two, and three-bedroom apartments, you’re sure to find the perfect home that fits your lifestyle. \n\nAt 1001 Tyvola, we believe in enhancing your living experience. Dive into our refreshing pool, or break a sweat in our state-of-the-art fitness center. Enjoy the convenience of on-site amenities such as a concierge service, business center, and package service, all designed for your busy lifestyle. Gather with friends in our inviting clubhouse or take advantage of our planned social activities that foster a sense of community.\n\nYour furry friends are welcome too! Our dog park and pet play area make it easy for your pets to enjoy the outdoors. Plus, with modern upgrades like stainless steel appliances, quartz countertops, and spacious walk-in closets, your apartment will feel like a sanctuary.\n\nSafety and convenience are also top priorities with features such as controlled access, 24-hour on-site maintenance, and key fob entry. For those who value eco-friendly living, we offer recycling and EV charging stations.\n\nDon’t miss the chance to call 1001 Tyvola home! Explore our availability or schedule a personal tour today to experience all the incredible amenities our community has to offer. Make your move to Charlotte’s finest apartment community and enjoy the lifestyle you deserve! ",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
    "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
    "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
    "width": 2048,
    "height": 1235
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "297",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "88.88888888888889",
  "property_admin_fee": "175",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Varies",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "No aggressive breeds (restricted: Pit Bulls and Staffordshire Terriers, Doberman Pinschers, Chow Chows, Rottweilers, Presa Canarios, German Shepherds). Large pets over 50 lbs must be in a first‑floor home.",
  "property_pet_policy_description": "3 Pets Per Home Max. $300 Fee for 1st pet; $100 Fee for each additional pet. $25 Pet Rent per pet monthly. Large pets over 50 lbs must be in a first‑floor home. No aggressive breeds (restricted: Pit Bulls and Staffordshire Terriers, Doberman Pinschers, Chow Chows, Rottweilers, Presa Canarios, German Shepherds). Other restrictions may apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://1001tyvola.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.on-site.com/apply/property/715125",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-faf1-73fa-a46c-4cc25996c16a.webp",
  "property_primary_logo_media": {
    "alt_text": "1001 TYVOLA logo",
    "public_id": "019d02d8-faf1-73fa-a46c-4cc25996c16a",
    "storage_key": "property/6767906449166947/019d02d8-faf1-73fa-a46c-4cc25996c16a.webp",
    "width": 640,
    "height": 358
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d9-05d9-774a-9e18-4c0272b1ce65.webp",
  "property_secondary_logo_media": {
    "alt_text": "1001 Tyvola logo",
    "public_id": "019d02d9-05d9-774a-9e18-4c0272b1ce65",
    "storage_key": "property/6767906449166947/019d02d9-05d9-774a-9e18-4c0272b1ce65.webp",
    "width": 640,
    "height": 358
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d9-0e49-71ef-b3cd-361632d29a85.webp",
  "property_mono_white_logo_media": {
    "alt_text": "1001 TYVOLA logo",
    "public_id": "019d02d9-0e49-71ef-b3cd-361632d29a85",
    "storage_key": "property/6767906449166947/019d02d9-0e49-71ef-b3cd-361632d29a85.webp",
    "width": 640,
    "height": 358
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d9-1690-7566-8827-f6dc109f0172.webp",
  "property_mono_black_logo_media": {
    "alt_text": "1001 TYVOLA logo",
    "public_id": "019d02d9-1690-7566-8827-f6dc109f0172",
    "storage_key": "property/6767906449166947/019d02d9-1690-7566-8827-f6dc109f0172.webp",
    "width": 640,
    "height": 358
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#222222",
  "property_secondary_color": "#3f7e9e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 3",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "457 - 1027",
  "property_sqft_min": "457",
  "property_sqft_max": "1027",
  "property_price_range": "$1223 - $1864",
  "property_price_min": "1223",
  "property_price_max": "1864",
  "property_available_units": 33,
  "property_facebook_url": "https://www.facebook.com/people/Tapestry-Tyvola-Apartments/100086596770511/#",
  "property_instagram_url": "https://www.instagram.com/tapestrytyvola/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJN-UginSfVogR9pJue2kI_mM",
  "property_youtube_url": "https://www.youtube.com/shorts/helQIGIhDfU",
  "property_yelp_url": "https://www.yelp.com/biz/1001-tyvola-charlotte",
  "property_tiktok_url": "https://www.tiktok.com/@tapestrytyvola",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 1001 Tyvola",
  "property_home_romance_title": "Embrace Life and Love in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "Welcome to 1001 Tyvola, where modern living meets comfort in the heart of Charlotte, NC. Choose from a variety of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments. Enjoy a lifestyle enriched by luxurious amenities, including a sparkling pool, fitness center, and dog park—perfect for pets and residents alike!",
  "property_home_floorplans_blurb": "At 1001 Tyvola in vibrant Charlotte, NC, your ideal living space awaits. Choose from stylish studios, spacious one to three-bedroom apartments, each designed with modern comfort in mind. Browse our diverse floor plans to find the perfect home that fits your lifestyle and elevates your everyday living experience.",
  "property_home_gallery_blurb": "At 1001 Tyvola in Charlotte, NC, your ideal lifestyle awaits. Choose from thoughtfully designed studio to three-bedroom floor plans. Indulge in resort-style amenities like a refreshing pool, fitness center, and dog park. With 24-hour concierge service and social activities, your perfect home is just a heartbeat away. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At 1001 Tyvola in Charlotte, NC, your ideal living space awaits—choose from studios to spacious three-bedroom apartments. Enjoy vibrant community life with nearby gems like the U.S. National Whitewater Center, Freedom Park, and top-tier educational institutions. Embrace convenience and excitement right at your doorstep!",
  "property_home_reviews_blurb": "Nestled in the heart of Charlotte, 1001 Tyvola offers a warm community where residents instantly feel at home. With brand-new amenities and a prime location near South Park Mall, you’ll love the convenience and hospitality. As one resident notes, \"Imani was so kind and helpful,\" making every visit a delight! Join us today!",
  "property_neighborhood_blurb": "Nestled in the heart of Charlotte, 1001 Tyvola offers more than just stylish studio, one, two, and three-bedroom apartments. Enjoy the vibrant community with close proximity to educational institutions like Central Piedmont Community College, green spaces like Freedom Park, and cultural attractions, ensuring there's never a dull moment at your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to 1001 Tyvola in vibrant Charlotte, NC! Our thoughtfully designed studio to three-bedroom apartments feature sleek quartz countertops and spacious walk-in closets. Enjoy exclusive amenities like a refreshing pool, fitness center, and pet play area, all paired with top-notch concierge service. Experience convenient living at its finest.",
  "property_applynow_blurb": "At 1001 Tyvola in Charlotte, NC, find your perfect match among our stylish studios to spacious three-bedroom apartments. Enjoy resort-style amenities like a sparkling pool, state-of-the-art fitness center, and a relaxing spa. Dive into a vibrant community with social activities and conveniences that elevate modern living. Lease online today!",
  "property_contactus_blurb": "At 1001 Tyvola in vibrant Charlotte, NC, our diverse floor plans offer something for everyone—from cozy studios to spacious three-bedroom apartments. Each layout is thoughtfully designed to elevate your living experience. Have questions? Reach out to our leasing team today and find your perfect home!",
  "property_faqs_blurb": "At 1001 Tyvola in vibrant Charlotte, NC, our diverse floor plans—from cozy studios to spacious three-bedrooms—cater to every lifestyle. Have questions? Our FAQs page is your go-to resource for insights into our community. Enhance your living experience by getting the answers you need today!",
  "property_floorplans_blurb": "Welcome to 1001 Tyvola in vibrant Charlotte, NC, where comfort meets style. Choose from thoughtfully designed studio, one, two, or three-bedroom apartments, each crafted to elevate your living experience. Browse our available apartment homes and find your perfect floor plan today, tailored just for you!",
  "property_gallery_blurb": "At 1001 Tyvola in vibrant Charlotte, NC, embrace a lifestyle of luxury and convenience. Our stunning photo gallery showcases modern studio to three-bedroom apartments, where high ceilings meet elegant finishes. With amenities like a sparkling pool, fitness center, and dog park, visualize your perfect home here—let creativity flourish!",
  "property_interactivemap_blurb": "At 1001 Tyvola in vibrant Charlotte, NC, choose from spacious studio to three-bedroom layouts that fit your lifestyle. Enjoy premium amenities—from a refreshing pool and fitness center to a pet play area and business center. Use our interactive community map to find the perfect apartment that meets your needs!",
  "property_pets_blurb": "At 1001 Tyvola in vibrant Charlotte, NC, your furry friends will feel right at home! With a pet-friendly policy accommodating up to three pets, you can enjoy spacious living while embracing the joys of pet companionship. Just note our breed restrictions and let the tail-wagging adventures begin!",
  "property_referafriend_blurb": "At 1001 Tyvola in vibrant Charlotte, NC, we offer a variety of floor plans—from cozy studios to spacious three-bedrooms—designed to fit your lifestyle. Share the experience! Great friends make great neighbors, so refer a friend to our welcoming community today and embrace the joys of living together.",
  "property_residentaccess_blurb": "At 1001 Tyvola in vibrant Charlotte, NC, our diverse floor plans—ranging from cozy studios to spacious three-bedroom apartments—cater to every lifestyle. Unlock your resident portal for hassle-free rent payments, maintenance requests, and community updates, ensuring you enjoy all the comforts of home with just a click.",
  "property_reviews_blurb": "At 1001 Tyvola in Charlotte, NC, residents rave about the “brand new construction” and “amazing amenities.” With a prime location near South Park Mall and exceptional staff like Imani Higgs, your move into this welcoming community will feel effortless. See what our residents have to say about living at our community!",
  "property_created_at": "1764869239214",
  "property_scheduletour_blurb": "At 1001 Tyvola in Charlotte, NC, our thoughtfully designed studio, one, two, and three-bedroom apartments cater to diverse lifestyles. Schedule a tour to experience the vibrant community and spacious floor plans that await you. Curious about life here? Check out our residents' heartfelt testimonials!",
  "property_thankyou_blurb": "Thank you for reaching out to 1001 Tyvola in vibrant Charlotte, NC! With an array of thoughtfully designed floor plans from cozy studios to spacious three-bedroom homes, your ideal sanctuary awaits. A team member will connect soon to help you embark on your journey to exceptional apartment living!",
  "property_virtualtours_blurb": "Welcome to 1001 Tyvola, Charlotte's vibrant apartment community offering an array of thoughtfully designed floor plans, including studios to spacious three-bedroom layouts. Experience your new home through our virtual tour and envision the lifestyle waiting for you. Dive in and see what makes our apartments truly special!",
  "property_copyright": "2026 All Rights Reserved. 1001 Tyvola",
  "property_seo_title_home": "1001 Tyvola |  Apartments in Charlotte, NC",
  "property_seo_description_home": "Experience modern living at 1001 Tyvola, Charlotte's premier apartment community. Choose from stylish studios to spacious three-bedrooms with luxury amenities.",
  "property_seo_title_floorplans": "Floor Plans | Charlotte, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at 1001 Tyvola in Charlotte, NC! Choose from studios to three-bedroom layouts designed for comfort. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Experience life at 1001 Tyvola in Charlotte, NC, with great amenities like a pool, fitness center, and pet-friendly spaces for elevated living!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Discover luxury living at 1001 Tyvola, Charlotte, NC! Enjoy vibrant amenities, from poolside relaxation to fitness fun. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | 1001 Tyvola Apartments",
  "property_seo_description_virtualtours": "Step inside 1001 Tyvola in Charlotte, NC! From cozy studios to spacious three-bedroom apartments, take a virtual tour and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | 1001 Tyvola Apartments",
  "property_seo_description_interactivemap": "Live your best life at 1001 Tyvola in Charlotte, NC! Use our interactive map to find your perfect studio, one, two, or three-bedroom home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood of 1001 Tyvola in Charlotte, NC. Dive into local favorites and nearby hotspots near your future home—join the adventure!",
  "property_seo_title_contact": "Contact Us | 1001 Tyvola",
  "property_seo_description_contact": "Connect with 1001 Tyvola in Charlotte, NC! From studio to three-bedroom layouts, our leasing team is ready to answer your questions. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Find answers to your burning questions at 1001 Tyvola in Charlotte, NC. From amenities to floor plans, discover everything you need to know!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Experience life at 1001 Tyvola in Charlotte, NC! Dive into resident insights and find your perfect space with top-notch amenities and vibrant community vibes.",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Discover modern living at 1001 Tyvola in Charlotte, NC. Choose stylish floor plans, enjoy great amenities, and lease your perfect home online!",
  "property_seo_title_residentaccess": "Resident Access | 1001 Tyvola",
  "property_seo_description_residentaccess": "Unlock the convenience of 1001 Tyvola! Log in to your resident portal for easy rent payments, maintenance requests, and staying connected in Charlotte, NC.",
  "property_seo_title_referafriend": "Refer A Friend | 1001 Tyvola",
  "property_seo_description_referafriend": "Refer a friend to 1001 Tyvola in Charlotte, NC! Great friendships start here—share the joy of our vibrant community and enjoy exclusive rewards together!",
  "property_seo_title_scheduletour": "Schedule a Tour | 1001 Tyvola",
  "property_seo_description_scheduletour": "Experience life at 1001 Tyvola, where modern living meets Southern charm. Schedule your tour today and envision your new home in vibrant Charlotte!",
  "property_seo_title_privacy": "Privacy Policy | 1001 Tyvola",
  "property_seo_description_privacy": "At 1001 Tyvola in Charlotte, NC, your privacy matters. Learn how we protect your information and ensure a secure living experience. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | 1001 Tyvola",
  "property_seo_description_accessibility": "At 1001 Tyvola in Charlotte, NC, we prioritize accessibility for everyone. Join us in fostering a community where digital inclusion thrives.",
  "property_seo_title_sitemap": "Sitemap | 1001 Tyvola",
  "property_seo_description_sitemap": "Uncover every corner of 1001 Tyvola in Charlotte, NC. Navigate our sitemap for a seamless experience and find your perfect apartment today!",
  "property_seo_title_thankyou": "Thank You | 1001 Tyvola",
  "property_seo_description_thankyou": "Thanks for reaching out to 1001 Tyvola in Charlotte, NC! We're excited to assist you in finding your perfect home. Expect to hear from us soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Charlotte, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787159961874",
  "amenities": [
    {
      "id": "ec_b9d56935c4670404891e1a55",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Resort‑style pool",
      "amount": "false",
      "description": "Found exactly on site: “resort‑style pool.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75986d5878ba468502c23917",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Fully‑equipped fitness center",
      "amount": "false",
      "description": "Matches “fully‑equipped fitness center.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb5247f63c35e6b40f5cd2fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "Listed as “clubhouse” in inviting context. ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f99fc8d0f0e3658010ab839d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Concierge service",
      "amount": "false",
      "description": "Present as “concierge service.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcbba445716a8a3d70e63155",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Controlled access",
      "amount": "false",
      "description": "Includes “controlled access.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b854dfe51606e1d04b8c95ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Business center",
      "amount": "false",
      "description": "Shown as “business center.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88907160bdf5a18a1d2800db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Package service",
      "amount": "false",
      "description": "Found as “package service.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a101d5a0616e63497db4f843",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "24‑hour maintenance",
      "amount": "false",
      "description": "Expressed as “24‑hour maintenance.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b36a09a9839503a13f82d93",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Dog park",
      "amount": "false",
      "description": "Appears as “dog park.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25e12ac8e7d9b42f801e2ce4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Pet play area",
      "amount": "false",
      "description": "Listed as “pet play area.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a65a2cc25c0f9d99ab5b6391",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Pet washing station",
      "amount": "false",
      "description": "Found as “pet washing station.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2877e93aebb9b229775ce4d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Recycling program",
      "amount": "false",
      "description": "Described as “recycling program.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14ba743e8e6719ea678e75aa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "EV charging station",
      "amount": "false",
      "description": "Shown as “EV charging station.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_365db973726001f6deebef9c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Planned social activities",
      "amount": "false",
      "description": "Present as “planned social activities.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b80dd647ca5262c80119917",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "Listed as “sundeck.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cab839b8bc36da497e6795c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor grilling area",
      "amount": "false",
      "description": "Found as “outdoor grilling area.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c0f8282ad7cda592c8ab9d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic space",
      "amount": "false",
      "description": "Appears as “picnic space.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0abaecfd9e5ef75a844d03e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed internet access",
      "amount": "false",
      "description": "Matches “high‑speed internet access.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98d2922bc24416eb110251cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "In‑unit washer/dryer",
      "amount": "false",
      "description": "Listed as “in‑unit washer/dryer.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4812c942c09ed7fc5c98be2d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless steel appliances",
      "amount": "false",
      "description": "Showed “stainless steel appliances.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d7fd4d4ba20b09b382de8e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious walk‑in closets",
      "amount": "false",
      "description": "Refers to “spacious walk‑in closets.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_935e333dcdf53d6a0dbc8ff6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Quartz countertops",
      "amount": "false",
      "description": "Included as “quartz countertops.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4b2a149bf818358edb00434",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "external_id": "false",
      "title": "Private balcony or patio",
      "amount": "false",
      "description": "Matches “private balconies or patios.” ([1001tyvola.com](https://www.1001tyvola.com/))",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4cd23770-93bd-4820-a1b2-0fdbdc16264d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-43a1-742f-b801-9bb384a7d13b.webp",
      "image_media": {
        "alt_text": "Small fluffy puppy being held over a pet washing station by a person.",
        "public_id": "019d02d7-43a1-742f-b801-9bb384a7d13b",
        "storage_key": "property/6767906449166947/019d02d7-43a1-742f-b801-9bb384a7d13b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "A resident handles a small fluffy puppy at an on-site pet washing/grooming station.",
      "link": "",
      "alt_text": "Small fluffy puppy being held over a pet washing station by a person.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/S9F7ikZ7f7-nbkOafzJ6KJW9Om-UrH5aVt_EWz-dJB4/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_5ced869a-1377-40a6-a857-9a5ee75c33d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multi-story apartment building with balconies.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Exterior view of a modern multi-story apartment building with balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NoGT0_xGhWhO5JfrunP-UbTY3ZExdGVAFrU_jJGRArw/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_9e1419d4-af8d-4d21-bd22-fdaa07b38d4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-44e9-7693-9868-659220acfff3.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and surrounding trees.",
        "public_id": "019d02d7-44e9-7693-9868-659220acfff3",
        "storage_key": "property/6767906449166947/019d02d7-44e9-7693-9868-659220acfff3.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building with stacked balconies and lush trees.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vLKNfyk4kNLIZ7A7x-cU1StYUi2mB6tNd3hdZfzb6gw/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_a8814cbf-6ae9-43f7-ba17-d3252c1ffb59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-44bf-723c-9a9e-aeb6064275ff.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with stacked balconies and trees.",
        "public_id": "019d02d7-44bf-723c-9a9e-aeb6064275ff",
        "storage_key": "property/6767906449166947/019d02d7-44bf-723c-9a9e-aeb6064275ff.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Contemporary multifamily building with large windows, stacked balconies, and landscaped surroundings.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with stacked balconies and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/oeDxuXRg638co8iOi_vztAgUaa35VtDOR2vmcotSQNM/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_7da80312-28c5-438d-a3a3-c61b60b78cc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-45cb-775d-a5f9-413410a18cf5.webp",
      "image_media": {
        "alt_text": "Blue electric car charging at a station in a landscaped apartment community parking lot.",
        "public_id": "019d02d7-45cb-775d-a5f9-413410a18cf5",
        "storage_key": "property/6767906449166947/019d02d7-45cb-775d-a5f9-413410a18cf5.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Exterior view of a multifamily property parking area with a blue electric car charging.",
      "link": "",
      "alt_text": "Blue electric car charging at a station in a landscaped apartment community parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/GojDbaL1xBjd1oRZc8E746D5GWE2k5UdV78vCFQViKQ/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_04ecc716-c5e5-4be7-9814-607a8ee35793",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-55ba-700f-971d-a8e9f4f04055.webp",
      "image_media": {
        "alt_text": "Modern apartment lobby with reception desk, mail lockers, and double entry doors.",
        "public_id": "019d02d7-55ba-700f-971d-a8e9f4f04055",
        "storage_key": "property/6767906449166947/019d02d7-55ba-700f-971d-a8e9f4f04055.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "A modern multifamily community lobby featuring a central reception desk, mail lockers, and secure entry doors.",
      "link": "",
      "alt_text": "Modern apartment lobby with reception desk, mail lockers, and double entry doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DS205JCNeS04OC9mFa52yHLIhvC4JtmEuJnOZDqde0U/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_be06bca1-8c42-4e23-a5ca-b2a64dc92579",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-557a-7076-960b-c64371e2ef31.webp",
      "image_media": {
        "alt_text": "Modern apartment lobby with a reception desk, mail lockers, and glass entry doors.",
        "public_id": "019d02d7-557a-7076-960b-c64371e2ef31",
        "storage_key": "property/6767906449166947/019d02d7-557a-7076-960b-c64371e2ef31.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "A modern multifamily lobby featuring a central reception desk, mail lockers, dark blue cabinetry, and bright glass entry doors.",
      "link": "",
      "alt_text": "Modern apartment lobby with a reception desk, mail lockers, and glass entry doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MvcYuGeVCfiQM-kUUefURreGYwH3bWsdHoC-0-8vR0A/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_dd9a6414-49f6-4815-9096-6a3d7e712f31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-60e1-75f0-9f1d-4176dcdb37e4.webp",
      "image_media": {
        "alt_text": "Bright community lounge with modern seating, wall art, and glass doors.",
        "public_id": "019d02d7-60e1-75f0-9f1d-4176dcdb37e4",
        "storage_key": "property/6767906449166947/019d02d7-60e1-75f0-9f1d-4176dcdb37e4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Spacious community lounge with contemporary seating, artwork, and a glass-entry door.",
      "link": "",
      "alt_text": "Bright community lounge with modern seating, wall art, and glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5G5SEtDzDezryHupS8Sz4cbjPwclJ92pMhUkJwfynj0/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_26501175-b64b-4c71-904e-79dccfa9cdd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-6bb7-772f-8acb-a86a04b55fb9.webp",
      "image_media": {
        "alt_text": "Interior community lounge with seating, a round table, and abstract wall art.",
        "public_id": "019d02d7-6bb7-772f-8acb-a86a04b55fb9",
        "storage_key": "property/6767906449166947/019d02d7-6bb7-772f-8acb-a86a04b55fb9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Modern resident lounge in the multifamily community with comfortable seating and artwork.",
      "link": "",
      "alt_text": "Interior community lounge with seating, a round table, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NAO9Z96AcwDHjmOrhAFLr3v8L6kad0zzxK4-QfFvFnk/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_0dd2bddc-812f-4bdf-a327-3cec1d69c01b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-6cd1-75fd-be1f-e4971d3c3a8b.webp",
      "image_media": {
        "alt_text": "Indoor community lounge with an orange banquette, round tables, and wall art.",
        "public_id": "019d02d7-6cd1-75fd-be1f-e4971d3c3a8b",
        "storage_key": "property/6767906449166947/019d02d7-6cd1-75fd-be1f-e4971d3c3a8b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Spacious resident lounge with modern seating, artwork, and a stone-accent wall for relaxed gatherings.",
      "link": "",
      "alt_text": "Indoor community lounge with an orange banquette, round tables, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dBFQjSe1j0r9EGEnvNuwDtM_Ieuh5PPo-iKgH7nB9q8/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_c9d48998-8aca-4a3f-8ced-b6aebf8f1e1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-d4b4-705f-8043-6d30c9899de5.webp",
      "image_media": {
        "alt_text": "Indoor community lounge with blue wainscoting, orange seating, round black tables, and wall art.",
        "public_id": "019d02d6-d4b4-705f-8043-6d30c9899de5",
        "storage_key": "property/6767906449166947/019d02d6-d4b4-705f-8043-6d30c9899de5.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "A modern residential lounge featuring artwork, plants, and cozy seating for residents.",
      "link": "",
      "alt_text": "Indoor community lounge with blue wainscoting, orange seating, round black tables, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XaZCxW8wg-r_BCGcfbJjTE9bUQal5YaT8r7GFq2tBJY/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_bd0a99f8-3d8a-47c9-841f-39cf501628bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-6ec8-775d-a9e4-12565ff6fcb4.webp",
      "image_media": {
        "alt_text": "Interior community lounge with green curved chairs, a wooden coffee table, and a long orange sofa.",
        "public_id": "019d02d7-6ec8-775d-a9e4-12565ff6fcb4",
        "storage_key": "property/6767906449166947/019d02d7-6ec8-775d-a9e4-12565ff6fcb4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Spacious resident lounge with modern seating, greenery, and a TV area for socializing and relaxation.",
      "link": "",
      "alt_text": "Interior community lounge with green curved chairs, a wooden coffee table, and a long orange sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Edh2A6fdbcF_a9WJoDBX3u3ymi6VSt-_dHJ-PGIfy-0/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_48985e39-6ac4-4a3c-a91a-7cfe7cebc6a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-6ec7-74ac-b2b4-caea2578e4cf.webp",
      "image_media": {
        "alt_text": "Modern community lounge with curved green sofa, wood coffee table, wall art, and a stone fireplace.",
        "public_id": "019d02d7-6ec7-74ac-b2b4-caea2578e4cf",
        "storage_key": "property/6767906449166947/019d02d7-6ec7-74ac-b2b4-caea2578e4cf.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "A stylish resident lounge featuring modern seating, artwork, and a stone fireplace.",
      "link": "",
      "alt_text": "Modern community lounge with curved green sofa, wood coffee table, wall art, and a stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XOiemeKivKGrDqSIhY-QS4JDMmySw7QIu19tpY_DgGk/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_4de561ac-f9ed-45fb-ba1c-64c3fb052599",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-74b9-7252-b1b5-474c2f38ee8c.webp",
      "image_media": {
        "alt_text": "Clubhouse kitchenette with a long island, orange bar stools, and a wall-mounted TV.",
        "public_id": "019d02d7-74b9-7252-b1b5-474c2f38ee8c",
        "storage_key": "property/6767906449166947/019d02d7-74b9-7252-b1b5-474c2f38ee8c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Modern community clubhouse lounge with a long kitchen island, orange bar stools, and a wall-mounted TV for residents to enjoy gatherings.",
      "link": "",
      "alt_text": "Clubhouse kitchenette with a long island, orange bar stools, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sYwOrLpii81E51sczG5Yrmtl-ZuW0XPmOHFCa5Q8td8/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_5c74e9d1-ea21-4057-9c3f-c061b12ff615",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-7641-7335-b66a-63d740b6a468.webp",
      "image_media": {
        "alt_text": "Bright modern community lounge with a large central island, chairs, and floor-to-ceiling windows.",
        "public_id": "019d02d7-7641-7335-b66a-63d740b6a468",
        "storage_key": "property/6767906449166947/019d02d7-7641-7335-b66a-63d740b6a468.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Bright community lounge with a large kitchen island, seating areas, and TV displays for residents.",
      "link": "",
      "alt_text": "Bright modern community lounge with a large central island, chairs, and floor-to-ceiling windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/t79yUCkunAPOlV-pjF_OCY3LvaWq9l0wfhhbdV497KI/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_aed69d07-3e6a-468e-a94a-e26c267bd0a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-776d-718c-994a-ad1968ea686b.webp",
      "image_media": {
        "alt_text": "Leasing lounge kitchenette with coffee machine, TV, and wooden shelves",
        "public_id": "019d02d7-776d-718c-994a-ad1968ea686b",
        "storage_key": "property/6767906449166947/019d02d7-776d-718c-994a-ad1968ea686b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Modern community leasing lounge with a coffee station, TV, and decorative shelves for residents.",
      "link": "",
      "alt_text": "Leasing lounge kitchenette with coffee machine, TV, and wooden shelves",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eUxoc-s3dg2wipKNIpeeMIcCZASYXrTa5qdmGv_T8ZI/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_fcf3e48c-d9ab-4153-bade-bc9b60f820f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-7821-7193-ab89-91dc01a266a4.webp",
      "image_media": {
        "alt_text": "Bright, modern residential gym with cardio machines and weight machines along large windows.",
        "public_id": "019d02d7-7821-7193-ab89-91dc01a266a4",
        "storage_key": "property/6767906449166947/019d02d7-7821-7193-ab89-91dc01a266a4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Spacious on-site fitness center in a multifamily community with cardio equipment and strength machines.",
      "link": "",
      "alt_text": "Bright, modern residential gym with cardio machines and weight machines along large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WBpyXFNvYPm92LL3DELl1_jiCeilC5FvrS3HwQ5Gk7E/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_ff100e59-f90c-4ab3-b510-57d060ddcd42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-ba1e-71fe-997c-1274323b6ca7.webp",
      "image_media": {
        "alt_text": "Small community gym with free weights, kettlebells, and a mirror.",
        "public_id": "019d02d6-ba1e-71fe-997c-1274323b6ca7",
        "storage_key": "property/6767906449166947/019d02d6-ba1e-71fe-997c-1274323b6ca7.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Well-equipped resident fitness room with a variety of weights and a mirror for workouts.",
      "link": "",
      "alt_text": "Small community gym with free weights, kettlebells, and a mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MFXuIkTZd6P6e2xNI4GOwhzqTYcCyAfQeiELZD3zAsI/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_6ad54ed4-a201-4420-a21a-85f2b79f91bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-b6a1-7649-9d40-31972d90afc8.webp",
      "image_media": {
        "alt_text": "Bright community gym with cardio machines, mirrors along the wall, and wood-look flooring.",
        "public_id": "019d02d6-b6a1-7649-9d40-31972d90afc8",
        "storage_key": "property/6767906449166947/019d02d6-b6a1-7649-9d40-31972d90afc8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Modern on-site fitness center featuring cardio equipment and mirrored walls for convenient resident workouts.",
      "link": "",
      "alt_text": "Bright community gym with cardio machines, mirrors along the wall, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OhScyPUtvj3oSas3lJASF3YD_GE7XFyeCiySmKEJDgQ/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_d3a881b9-cffe-4f28-870b-44d81f8140dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-7fff-71d4-af9a-e014ef47723b.webp",
      "image_media": {
        "alt_text": "Indoor fitness center with three stationary bikes and floor-to-ceiling windows.",
        "public_id": "019d02d7-7fff-71d4-af9a-e014ef47723b",
        "storage_key": "property/6767906449166947/019d02d7-7fff-71d4-af9a-e014ef47723b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Bright on-site gym with cardio bikes and mirrors, providing a comfortable workout space with natural light and outdoors views.",
      "link": "",
      "alt_text": "Indoor fitness center with three stationary bikes and floor-to-ceiling windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rj6uDESgkPWALSQx-EUz4xzaevNT9nsa53urbw4AvnE/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_226f3fb6-0edc-4fcc-97bd-3e9edb57e39f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-8085-707b-8380-63f8dc7a53dc.webp",
      "image_media": {
        "alt_text": "Interior of a modern communal gym with cardio machines and weight equipment.",
        "public_id": "019d02d7-8085-707b-8380-63f8dc7a53dc",
        "storage_key": "property/6767906449166947/019d02d7-8085-707b-8380-63f8dc7a53dc.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Spacious community fitness center featuring cardio and strength equipment, mirrors, and a water station.",
      "link": "",
      "alt_text": "Interior of a modern communal gym with cardio machines and weight equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EAYsHpCMX9SScd8pbKWWTVDX3oDbzYfgf_TsKWtEbj0/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_40cd1444-99f9-4f23-a2a2-1f7fb40c55a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-a9c0-746f-8b5f-8c58d9642dc8.webp",
      "image_media": {
        "alt_text": "Bright apartment gym with cardio machines and free weights.",
        "public_id": "019d02d6-a9c0-746f-8b5f-8c58d9642dc8",
        "storage_key": "property/6767906449166947/019d02d6-a9c0-746f-8b5f-8c58d9642dc8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "Bright on-site fitness center at the community with cardio and strength equipment.",
      "link": "",
      "alt_text": "Bright apartment gym with cardio machines and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/msxWUoGJWEc4gkzLgOZj11nE06m7j10mZWPk6OJevuU/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_597cd4a2-eea8-4683-82f5-989b0d3dbcb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-815f-719b-abfa-3499162c38e1.webp",
      "image_media": {
        "alt_text": "Exterior amenity courtyard with seating, umbrellas, and string lights.",
        "public_id": "019d02d7-815f-719b-abfa-3499162c38e1",
        "storage_key": "property/6767906449166947/019d02d7-815f-719b-abfa-3499162c38e1.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Outdoor community courtyard featuring grilling stations, tables, umbrellas, and string lights for residents.",
      "link": "",
      "alt_text": "Exterior amenity courtyard with seating, umbrellas, and string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/AlDiekhZNGBkEkX7GCf-lj94MUkEeRjg13XPmnU-6BY/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_a797ce04-3046-403a-b6ab-0e468e7e6421",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-a407-7501-a41a-c4a4351d3bb0.webp",
      "image_media": {
        "alt_text": "A woman in a pink bikini lounges on a pool float in a bright pool area.",
        "public_id": "019d02d6-a407-7501-a41a-c4a4351d3bb0",
        "storage_key": "property/6767906449166947/019d02d6-a407-7501-a41a-c4a4351d3bb0.webp",
        "width": 1024,
        "height": 575
      },
      "title": "Lifestyle",
      "description": "Relax by a resort-style pool with a sunny lounge area and a guest enjoying a pool float.",
      "link": "",
      "alt_text": "A woman in a pink bikini lounges on a pool float in a bright pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/9K-hw_n_aafx2q0es3sHM6xnkGOqAIh4eXwfKGJByok/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_9da25223-109f-437e-877d-5b829a45c03a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-8463-7198-b3c8-e96173ecf4bd.webp",
      "image_media": {
        "alt_text": "Aerial view of a bright blue pool with lounge chairs at a multifamily community.",
        "public_id": "019d02d7-8463-7198-b3c8-e96173ecf4bd",
        "storage_key": "property/6767906449166947/019d02d7-8463-7198-b3c8-e96173ecf4bd.webp",
        "width": 1024,
        "height": 575
      },
      "title": "Lifestyle",
      "description": "Aerial photo of the pool deck at a multifamily property, highlighting sun loungers and clear blue water.",
      "link": "",
      "alt_text": "Aerial view of a bright blue pool with lounge chairs at a multifamily community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cUjbY7X0bxofsjHL1d0O0t0Pixrv2fMB49k2oSpJpAE/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_8eb97480-2637-498f-a9c4-49e267fa9a69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-88c0-7164-bde1-ea34b6087ab8.webp",
      "image_media": {
        "alt_text": "Aerial view of a rectangular outdoor pool with white lounge chairs and a person sunbathing.",
        "public_id": "019d02d7-88c0-7164-bde1-ea34b6087ab8",
        "storage_key": "property/6767906449166947/019d02d7-88c0-7164-bde1-ea34b6087ab8.webp",
        "width": 1024,
        "height": 575
      },
      "title": "Lifestyle",
      "description": "Sun-drenched pool area at the apartment community with lounge chairs and seating.",
      "link": "",
      "alt_text": "Aerial view of a rectangular outdoor pool with white lounge chairs and a person sunbathing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Y__lq4XvyPNJtMif-avgw_LMXnc80tg4FBrKVDQlVxA/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_74d89cac-1a0c-4365-94b5-096a33f09ac4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-891c-7329-9dba-03afbc825624.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with lounge chairs and a shaded seating area.",
        "public_id": "019d02d7-891c-7329-9dba-03afbc825624",
        "storage_key": "property/6767906449166947/019d02d7-891c-7329-9dba-03afbc825624.webp",
        "width": 1024,
        "height": 575
      },
      "title": "Community",
      "description": "Outdoor pool at the apartment community with sun loungers, a shaded cabana, and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with lounge chairs and a shaded seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nO3hTmIIkXrtcHHa3AlGxlOYw0gkWSXuWifIODA1nMQ/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_3402546d-6009-4e2c-b29c-19300f8d26ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-894f-75ec-9cb8-9d091a02900f.webp",
      "image_media": {
        "alt_text": "Aerial view of a rectangular pool with lounge chairs and a person sitting at the edge.",
        "public_id": "019d02d7-894f-75ec-9cb8-9d091a02900f",
        "storage_key": "property/6767906449166947/019d02d7-894f-75ec-9cb8-9d091a02900f.webp",
        "width": 1024,
        "height": 575
      },
      "title": "Lifestyle",
      "description": "Aerial view of a residential pool area with loungers and bright blue water.",
      "link": "",
      "alt_text": "Aerial view of a rectangular pool with lounge chairs and a person sitting at the edge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mmoyn5Oyu1ar1HMUCJBvtwsvf12YyNwfMcoj0VyNP-4/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_f417eaeb-8d91-43a2-8de7-f2ffe064ad4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-8d68-704a-85f1-d3d07da4fd8c.webp",
      "image_media": {
        "alt_text": "Outdoor pool area at an apartment community with lounge chairs and umbrellas.",
        "public_id": "019d02d7-8d68-704a-85f1-d3d07da4fd8c",
        "storage_key": "property/6767906449166947/019d02d7-8d68-704a-85f1-d3d07da4fd8c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Modern apartment community featuring an outdoor pool, sun loungers, and umbrellas set against multi-story residences.",
      "link": "",
      "alt_text": "Outdoor pool area at an apartment community with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ACo30FSiT0nUMN___v1PwsTWHeUrpaOmKy-2JI7OLNM/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_162b9f95-2682-40a3-877d-8d1eb2ebe1a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-9234-768f-bdb4-14c68cc99e25.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with white lounge chairs, a shaded seating structure, and a person sunbathing.",
        "public_id": "019d02d7-9234-768f-bdb4-14c68cc99e25",
        "storage_key": "property/6767906449166947/019d02d7-9234-768f-bdb4-14c68cc99e25.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "Bright resort-style pool at a modern apartment community with ample lounge seating and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor pool area with white lounge chairs, a shaded seating structure, and a person sunbathing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qgJyYrbWjd1Ipevwmc_YQWBSrixCnnXme_WXpmBJs8g/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_30bffdcb-fb28-4b8c-b770-49de4dfaf13d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-9263-715f-be8c-04b4b140d55b.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelves and beige walls.",
        "public_id": "019d02d7-9263-715f-be8c-04b4b140d55b",
        "storage_key": "property/6767906449166947/019d02d7-9263-715f-be8c-04b4b140d55b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "An empty walk-in closet in a modern apartment with white wire shelving, beige walls, and carpeted flooring.",
      "link": "",
      "alt_text": "Empty walk-in closet with white wire shelves and beige walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lZS7Yjv5SSaUHwrSL7nz7qTgxkCiBsncaSNN3sKxNmg/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_2c4068be-8458-4e28-9af8-d97ca232d565",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-85ab-742d-819b-d1724f9baebb.webp",
      "image_media": {
        "alt_text": "Glass shower enclosure with marble tile walls in a modern bathroom.",
        "public_id": "019d02d6-85ab-742d-819b-d1724f9baebb",
        "storage_key": "property/6767906449166947/019d02d6-85ab-742d-819b-d1724f9baebb.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Contemporary apartment bathroom with a glass shower enclosure and marble-look tile, offering a clean, upscale feel.",
      "link": "",
      "alt_text": "Glass shower enclosure with marble tile walls in a modern bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sj9cc2qwQJ_cJ4MKux0rr19y3JSFl7JNWnW-Lb4ab88/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_c791c060-7e06-4d1a-af17-f2711db03379",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-951f-732f-95f5-7b56c6be6963.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with a double-sink vanity, mirror, toilet, and glass shower.",
        "public_id": "019d02d7-951f-732f-95f5-7b56c6be6963",
        "storage_key": "property/6767906449166947/019d02d7-951f-732f-95f5-7b56c6be6963.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, contemporary bathroom in a leasing home featuring a double vanity, clean white countertops, and a glass shower.",
      "link": "",
      "alt_text": "Modern apartment bathroom with a double-sink vanity, mirror, toilet, and glass shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QQwlJPbAXFNJkPVCxvcEGHNwUBu8k7dZ1ZwTOCIbePk/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_d5310e8d-fa2b-453d-9642-f2416baba81c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-967b-7034-9004-69201ca22198.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with a white vanity, large mirror, toilet, and glass shower.",
        "public_id": "019d02d7-967b-7034-9004-69201ca22198",
        "storage_key": "property/6767906449166947/019d02d7-967b-7034-9004-69201ca22198.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a white vanity, expansive mirror, glass shower, and contemporary fixtures.",
      "link": "",
      "alt_text": "Modern apartment bathroom with a white vanity, large mirror, toilet, and glass shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qI7y2lI-ZLKj8c6BJTOhTrlbASvyYBEBhmeROlrqRQ0/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_7fcb1cea-704c-45b5-8ebe-73164f04ec8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-9b45-709d-80d6-4a760c3db6be.webp",
      "image_media": {
        "alt_text": "Bathroom with white vanity, sink, mirror, and toilet.",
        "public_id": "019d02d7-9b45-709d-80d6-4a760c3db6be",
        "storage_key": "property/6767906449166947/019d02d7-9b45-709d-80d6-4a760c3db6be.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a white vanity, mirror, towel rack, and toilet.",
      "link": "",
      "alt_text": "Bathroom with white vanity, sink, mirror, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5LbIj76nJ-1aOzj229fY35iPEixs_JRLXUL4icPFnOw/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_4159d688-aa6e-41d9-a813-e3de32ac7b9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-78b3-7018-97af-2ddd725b30ab.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a blue upholstered queen-size bed, pillows, and a dresser.",
        "public_id": "019d02d6-78b3-7018-97af-2ddd725b30ab",
        "storage_key": "property/6767906449166947/019d02d6-78b3-7018-97af-2ddd725b30ab.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "A stylish apartment bedroom featuring a queen bed with blue bedding, a dresser, and geometric wall art.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a blue upholstered queen-size bed, pillows, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cTZ8PrTi5sx4R5K2fCYpV5GvS82qQFh7jxdvKNJYYEI/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_e27abfed-d834-4f8e-bef6-bb0fb0111f88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-9d4d-745f-8443-708fc139c011.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, blue-gray bedding, decorative pillows, and a dresser by a window.",
        "public_id": "019d02d7-9d4d-745f-8443-708fc139c011",
        "storage_key": "property/6767906449166947/019d02d7-9d4d-745f-8443-708fc139c011.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Cozy modern bedroom in a multifamily unit featuring a large bed, blue-gray bedding, and natural light from a window.",
      "link": "",
      "alt_text": "Bedroom with a large bed, blue-gray bedding, decorative pillows, and a dresser by a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/PYbi8Ac2AdbSAPRbrJdovLDCfUmYvhSph6d_itNYXV8/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_9256e0c9-8a06-4c72-9a2b-cc73e678191a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-9df1-700b-bb42-51d89933fd60.webp",
      "image_media": {
        "alt_text": "Bedroom interior with a queen bed, pillows, a dresser, and burgundy curtains.",
        "public_id": "019d02d7-9df1-700b-bb42-51d89933fd60",
        "storage_key": "property/6767906449166947/019d02d7-9df1-700b-bb42-51d89933fd60.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright bedroom in a modern apartment featuring a queen bed, decorative pillows, and a dresser with natural light from a window.",
      "link": "",
      "alt_text": "Bedroom interior with a queen bed, pillows, a dresser, and burgundy curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/S_HhQidYZpnfb0WvLwGi73CZB3lL9q24O0JnKmxNbx0/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_be4f3b25-baa8-4ba0-93cf-13c8562a8227",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-9f75-76ed-9e9f-cc12d74e7d3d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, three brown bar stools, stainless steel fridge and oven, pendant lights.",
        "public_id": "019d02d7-9f75-76ed-9e9f-cc12d74e7d3d",
        "storage_key": "property/6767906449166947/019d02d7-9f75-76ed-9e9f-cc12d74e7d3d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen featuring an island, casual seating, and stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with island, three brown bar stools, stainless steel fridge and oven, pendant lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/L-d_5F2TTkAoIsICa3noPUWH9iDFsEDiZEaGpvIEVGY/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_d7770f40-f09d-42e6-a4dc-402d14739b4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-a651-700f-b521-63dce37cd130.webp",
      "image_media": {
        "alt_text": "Open-concept living space with a sofa, shelving unit, and a kitchen island with brown bar stools.",
        "public_id": "019d02d7-a651-700f-b521-63dce37cd130",
        "storage_key": "property/6767906449166947/019d02d7-a651-700f-b521-63dce37cd130.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, modern apartment interior featuring a cozy living area, stylish shelving, and a welcoming kitchen island with seating.",
      "link": "",
      "alt_text": "Open-concept living space with a sofa, shelving unit, and a kitchen island with brown bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/T-8xJlgMrdSw5gi-uLf7-1-_Y7nxgf0rSFqOI63sp2c/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_763efe19-3939-4cb7-9be2-1b07b2931cf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-6677-76f9-8915-3e2a2a28fa9d.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with island and bar seating, stainless-steel appliances.",
        "public_id": "019d02d6-6677-76f9-8915-3e2a2a28fa9d",
        "storage_key": "property/6767906449166947/019d02d6-6677-76f9-8915-3e2a2a28fa9d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright contemporary apartment kitchen with an island, stainless-steel appliances, and adjacent living area.",
      "link": "",
      "alt_text": "Open-concept kitchen with island and bar seating, stainless-steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/g-FoQsjpbEUdb5MOO-B7LTZPnxDwS6-UcXpnwRy56Q4/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_e4a26568-e95d-484c-9d36-b38b191bea0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-61d3-72a2-b323-9f0f1a90c7c4.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with island, sink, and visible living area.",
        "public_id": "019d02d6-61d3-72a2-b323-9f0f1a90c7c4",
        "storage_key": "property/6767906449166947/019d02d6-61d3-72a2-b323-9f0f1a90c7c4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment featuring a spacious kitchen island, modern appliances, and an open living area.",
      "link": "",
      "alt_text": "Open-concept kitchen with island, sink, and visible living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ee8A7hQhlDAIVkNf25_oQVslK3HifPhzsJJG4jcRTjs/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_2c71c4f7-064f-4209-b7ff-4050a4a00265",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-a866-72dd-8781-32007b7105fe.webp",
      "image_media": {
        "alt_text": "Open-concept living area with a sofa, glass coffee table, and island kitchen in a modern apartment.",
        "public_id": "019d02d7-a866-72dd-8781-32007b7105fe",
        "storage_key": "property/6767906449166947/019d02d7-a866-72dd-8781-32007b7105fe.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, modern apartment with an open living area and island kitchen.",
      "link": "",
      "alt_text": "Open-concept living area with a sofa, glass coffee table, and island kitchen in a modern apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yStn9eWqU0Fa_U9K9giMkmS378iPDgMo4ITAsAGHo4U/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_76ce5c17-1366-4444-9945-d3aa7d526b2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-a9ad-758b-b098-d5b0c790b595.webp",
      "image_media": {
        "alt_text": "Open-concept living room with a light sofa, brown armchair, glass coffee table, and a kitchen island with bar stools.",
        "public_id": "019d02d7-a9ad-758b-b098-d5b0c790b595",
        "storage_key": "property/6767906449166947/019d02d7-a9ad-758b-b098-d5b0c790b595.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, open-concept apartment living area with a kitchen island, bar stools, and contemporary decor.",
      "link": "",
      "alt_text": "Open-concept living room with a light sofa, brown armchair, glass coffee table, and a kitchen island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/-T-cMbwyw4UUsiPn_aKhsQz2TsD3GPN-Su9RtRDJ1yM/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_7d927987-47d6-4049-b1ff-ab2741f28b4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-a9e6-7509-a6e5-53a18accac7c.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a white sectional sofa, glass coffee table, and green curtains.",
        "public_id": "019d02d7-a9e6-7509-a6e5-53a18accac7c",
        "storage_key": "property/6767906449166947/019d02d7-a9e6-7509-a6e5-53a18accac7c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, modern living room in a contemporary apartment with a neutral palette, white sectional, glass coffee table, and green curtains.",
      "link": "",
      "alt_text": "Living room in an apartment with a white sectional sofa, glass coffee table, and green curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/T2BJ4njFJBKCPLIBwzoGQZuqRtuwlgOpgMjJlOg1ZiE/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_9a3d4771-1107-42c9-a0c0-4f3159e9f56a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d6-50ce-73df-9940-4da96ab794cf.webp",
      "image_media": {
        "alt_text": "Living room in a modern apartment with a beige sofa and open kitchen.",
        "public_id": "019d02d6-50ce-73df-9940-4da96ab794cf",
        "storage_key": "property/6767906449166947/019d02d6-50ce-73df-9940-4da96ab794cf.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious contemporary living area with neutral decor and an open kitchen in our apartment homes.",
      "link": "",
      "alt_text": "Living room in a modern apartment with a beige sofa and open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/w9u6exEd3mlUxihJGpx1EL5TxdgXAXjgkeDKzGuI98s/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_cd045340-d871-458e-a29e-6bba8245d839",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-b18c-7099-8400-dea818902f43.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with an island, stainless steel refrigerator, and white cabinets.",
        "public_id": "019d02d7-b18c-7099-8400-dea818902f43",
        "storage_key": "property/6767906449166947/019d02d7-b18c-7099-8400-dea818902f43.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright kitchen area in an apartment featuring an island, stainless-steel appliances, and white cabinetry.",
      "link": "",
      "alt_text": "Modern apartment kitchen with an island, stainless steel refrigerator, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/9lJD1CWLRxaJnB1LqO-XrzIWgFs9upgCz2ezOqjhMPk/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_64f2f149-28d1-4a24-89fd-a3bcb2303c60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-b318-7520-8c75-3df65a0a5525.webp",
      "image_media": {
        "alt_text": "Top-down floor plan of a multi-bedroom apartment showing living area, kitchen, bedrooms, and balcony.",
        "public_id": "019d02d7-b318-7520-8c75-3df65a0a5525",
        "storage_key": "property/6767906449166947/019d02d7-b318-7520-8c75-3df65a0a5525.webp",
        "width": 2048,
        "height": 2008
      },
      "title": "Floorplan",
      "description": "Detailed floor plan of a modern apartment layout with room locations and amenities.",
      "link": "",
      "alt_text": "Top-down floor plan of a multi-bedroom apartment showing living area, kitchen, bedrooms, and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/r7an-tuClR9BjuKV9S1NTJPp7psaqFwOknFeGRUjuAE/116/tapestry-tyvola-charlotte-nc-floorplan.jpg"
    },
    {
      "id": "custom_76733272-5428-47d2-885e-fc16ab37a919",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-b325-718f-be08-5206bd2a0506.webp",
      "image_media": {
        "alt_text": "Bright apartment living room with beige sectional sofa, tall curtains, and a bookshelf.",
        "public_id": "019d02d7-b325-718f-be08-5206bd2a0506",
        "storage_key": "property/6767906449166947/019d02d7-b325-718f-be08-5206bd2a0506.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern apartment living room with neutral tones, a plush sofa, plants, and decorative shelving.",
      "link": "",
      "alt_text": "Bright apartment living room with beige sectional sofa, tall curtains, and a bookshelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/o8ort2BWRsgyt7FlsE4g9_I11HefhwaMsCTa-HhXVr8/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_f32f09b2-2012-412f-ad45-fe4de7cfc60a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-b586-74dd-98ed-685bda77ab03.webp",
      "image_media": {
        "alt_text": "Modern bathroom shower with marble-look tiled walls and two grab bars.",
        "public_id": "019d02d7-b586-74dd-98ed-685bda77ab03",
        "storage_key": "property/6767906449166947/019d02d7-b586-74dd-98ed-685bda77ab03.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a marble-look tiled shower/tub and two grab bars, featuring neutral finishes.",
      "link": "",
      "alt_text": "Modern bathroom shower with marble-look tiled walls and two grab bars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/YgMxh6nUnMfNkArgw2RnrkrXaXytfBfrge-qoXa885Y/116/tapestry-tyvola-charlotte-nc-1br1ba.jpg"
    },
    {
      "id": "custom_7f441b19-b931-4280-b676-3502b85525cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-ba6c-755e-aa29-6f510f0b2231.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, plant, towel bar, and marble-tiled shower in background.",
        "public_id": "019d02d7-ba6c-755e-aa29-6f510f0b2231",
        "storage_key": "property/6767906449166947/019d02d7-ba6c-755e-aa29-6f510f0b2231.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a wide vanity, plant accent, and marble-tiled shower.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, plant, towel bar, and marble-tiled shower in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RNpkFTct6mgBIShvh_GWBpERB4D3fyjnMysKnd86RMU/116/tapestry-tyvola-charlotte-nc-1br1ba.jpg"
    },
    {
      "id": "custom_63b1c928-d5ee-4d4c-94a2-904760623bc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-bd35-77df-aa2f-f915649e4402.webp",
      "image_media": {
        "alt_text": "Bright beige bedroom with multiple windows featuring white horizontal blinds and an open doorway.",
        "public_id": "019d02d7-bd35-77df-aa2f-f915649e4402",
        "storage_key": "property/6767906449166947/019d02d7-bd35-77df-aa2f-f915649e4402.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright beige bedroom in a modern apartment with large windows, white blinds, and a carpeted floor.",
      "link": "",
      "alt_text": "Bright beige bedroom with multiple windows featuring white horizontal blinds and an open doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ti2dCvJQzMng6nPDC8Z6vvC021VV8Bw-qfLMehMPqHE/116/tapestry-tyvola-charlotte-nc-1br1ba.jpg"
    },
    {
      "id": "custom_96873492-6432-4f8b-b6b1-134ce8e8d45e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-be21-7123-898a-f62abcae4edf.webp",
      "image_media": {
        "alt_text": "Bright kitchen with white cabinets, pendant lights, stainless appliances, and an island sink.",
        "public_id": "019d02d7-be21-7123-898a-f62abcae4edf",
        "storage_key": "property/6767906449166947/019d02d7-be21-7123-898a-f62abcae4edf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with an island, stainless appliances, and a clean white backsplash.",
      "link": "",
      "alt_text": "Bright kitchen with white cabinets, pendant lights, stainless appliances, and an island sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/U2-RS9BBz33lpjAamYekiRkzT4NdQ0bZDIwWczz7TF0/116/tapestry-tyvola-charlotte-nc-1br1ba.jpg"
    },
    {
      "id": "custom_2c08c1ec-8727-4302-bd5e-643d0f4b7770",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-bf1b-7110-8cf2-1cf6d03f3ca2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel stove, microwave, and fridge.",
        "public_id": "019d02d7-bf1b-7110-8cf2-1cf6d03f3ca2",
        "storage_key": "property/6767906449166947/019d02d7-bf1b-7110-8cf2-1cf6d03f3ca2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with stainless steel appliances, white cabinetry, and a subway tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel stove, microwave, and fridge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/55IF3S7uJmxRmj9CVMK8e-dyyemW1sGRlDOKVD4Dzt4/116/tapestry-tyvola-charlotte-nc-1br1ba.jpg"
    },
    {
      "id": "custom_a9d412b7-5c02-48c3-bcda-56c298ab64f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-c374-76af-85c4-911360977a2e.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with island, light cabinets, stainless fridge, and wood-look flooring.",
        "public_id": "019d02d7-c374-76af-85c4-911360977a2e",
        "storage_key": "property/6767906449166947/019d02d7-c374-76af-85c4-911360977a2e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment interior featuring an open kitchen with an island, stainless appliances, and light wood flooring.",
      "link": "",
      "alt_text": "Open-concept kitchen with island, light cabinets, stainless fridge, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/432E5InHxPbairQVRo4QUHhqXn_Fu681c-wKUiuPwFQ/116/tapestry-tyvola-charlotte-nc-1br1ba.jpg"
    },
    {
      "id": "custom_3041f23e-a06f-4f5b-9853-8bc9733433d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-c747-71aa-b82b-eef4ec2c5a54.webp",
      "image_media": {
        "alt_text": "Empty beige interior room with large windows and white blinds, wood floor.",
        "public_id": "019d02d7-c747-71aa-b82b-eef4ec2c5a54",
        "storage_key": "property/6767906449166947/019d02d7-c747-71aa-b82b-eef4ec2c5a54.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, empty apartment room with neutral walls, large windows, and wood flooring.",
      "link": "",
      "alt_text": "Empty beige interior room with large windows and white blinds, wood floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/einqM3Aow74EyF0Q209UeGnOA8vPYKwsoiRXT0dth5Y/116/tapestry-tyvola-charlotte-nc-1br1ba.jpg"
    },
    {
      "id": "custom_90cf0c4d-5641-4fd3-85e5-ce2d6d10efc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-c805-7608-ae5a-0e29d814f18a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, large mirror, and open closet visible on the left.",
        "public_id": "019d02d7-c805-7608-ae5a-0e29d814f18a",
        "storage_key": "property/6767906449166947/019d02d7-c805-7608-ae5a-0e29d814f18a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a double-drawer vanity, spacious countertop, and adjacent walk-in closet.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, large mirror, and open closet visible on the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EyJeu2WHve_19ax_EB-MN_H-3xoI0Tr_Ezvg7UAN_Yw/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_cacd3d46-64b1-4b3d-8920-d9e9e2580626",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-c8af-714e-91e1-aa316dcc54a6.webp",
      "image_media": {
        "alt_text": "Double-sink bathroom vanity with white countertop, light wood cabinets, and mirrors.",
        "public_id": "019d02d7-c8af-714e-91e1-aa316dcc54a6",
        "storage_key": "property/6767906449166947/019d02d7-c8af-714e-91e1-aa316dcc54a6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Double-sink bathroom vanity in a modern apartment, featuring white countertop, light wood cabinetry, and large mirrors.",
      "link": "",
      "alt_text": "Double-sink bathroom vanity with white countertop, light wood cabinets, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XKZz-shxCIG1uQNwwO1_cFrVndaB7v73NDBQbzyaNA4/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_87c516d4-6ad5-4312-a167-9030fad8a7c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-cd11-76ba-bf37-0cfec990391b.webp",
      "image_media": {
        "alt_text": "Corner of an empty apartment room with three large windows and white blinds.",
        "public_id": "019d02d7-cd11-76ba-bf37-0cfec990391b",
        "storage_key": "property/6767906449166947/019d02d7-cd11-76ba-bf37-0cfec990391b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright corner room with three tall windows, white blinds, beige walls, and plush carpet—an airy, versatile space.",
      "link": "",
      "alt_text": "Corner of an empty apartment room with three large windows and white blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MNi1nuBYYzcfurkYj12cHpwMsyPQGPGWEFUhKZmytsg/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_d295ea28-19e7-423d-8aee-1c072abfb574",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-d0a2-73cf-b4be-f485a20816d6.webp",
      "image_media": {
        "alt_text": "Open kitchen with island sink, stainless faucet, and light wood cabinets; living area visible.",
        "public_id": "019d02d7-d0a2-73cf-b4be-f485a20816d6",
        "storage_key": "property/6767906449166947/019d02d7-d0a2-73cf-b4be-f485a20816d6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with an island, granite-like counters, and an open view to the living area.",
      "link": "",
      "alt_text": "Open kitchen with island sink, stainless faucet, and light wood cabinets; living area visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3fVRpXwsE8EDRsM_CV-X2M118m5VpC6XVXCwJ-cJPT0/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_2228a4ce-7950-4b42-81ea-79c4d25c2620",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-d229-74d7-afbc-eb8486b8f7e3.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel microwave, stove, and refrigerator beside white cabinets.",
        "public_id": "019d02d7-d229-74d7-afbc-eb8486b8f7e3",
        "storage_key": "property/6767906449166947/019d02d7-d229-74d7-afbc-eb8486b8f7e3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, modern kitchen in a contemporary apartment with stainless appliances and white cabinetry.",
      "link": "",
      "alt_text": "Modern apartment kitchen with stainless steel microwave, stove, and refrigerator beside white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HnqqPEiaYB0XKjVAIGH21SFW-fm3XZ9wsb8rbKxnKBo/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_ea5e89ab-b4da-4eab-8e1a-15b00da72d19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-d415-72ca-b628-eae155b5ad73.webp",
      "image_media": {
        "alt_text": "Open-concept living area with kitchen island, pendant lights, and a TV.",
        "public_id": "019d02d7-d415-72ca-b628-eae155b5ad73",
        "storage_key": "property/6767906449166947/019d02d7-d415-72ca-b628-eae155b5ad73.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, modern apartment living space featuring stainless steel appliances, a kitchen island, and a comfortable seating area.",
      "link": "",
      "alt_text": "Open-concept living area with kitchen island, pendant lights, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QA1898m9LDXwMAmvaVLjA6orp4wRFx6JTRfJWy9Ppog/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_af967ee3-bf5f-4b94-9055-123b9a717cf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-d71b-751f-b2c0-f96852011e9c.webp",
      "image_media": {
        "alt_text": "Bright apartment living room with large windows, a blue sofa, white chairs, and abstract art.",
        "public_id": "019d02d7-d71b-751f-b2c0-f96852011e9c",
        "storage_key": "property/6767906449166947/019d02d7-d71b-751f-b2c0-f96852011e9c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright apartment living room with comfortable seating, natural light, and contemporary artwork.",
      "link": "",
      "alt_text": "Bright apartment living room with large windows, a blue sofa, white chairs, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qnQk6CIDEBPV52xU3D2nf0SaqcxKsxVAFzE7EZG9GXk/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_2bdc41ac-91a5-468c-bd96-f4ab2da109cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-da03-76b9-ad78-3a2dc7a11f37.webp",
      "image_media": {
        "alt_text": "Bathroom with double-sink vanity, large mirror, and beige walls.",
        "public_id": "019d02d7-da03-76b9-ad78-3a2dc7a11f37",
        "storage_key": "property/6767906449166947/019d02d7-da03-76b9-ad78-3a2dc7a11f37.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a double-sink vanity, neutral tones, and ample storage.",
      "link": "",
      "alt_text": "Bathroom with double-sink vanity, large mirror, and beige walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BH1h8KfoUcbfEnIHNuxAP7ycxiT7fnuOQ_DsQnInmsM/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_878a0752-ab64-40fc-a6ca-9386542f1854",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-db4b-7688-9375-24daf8be858d.webp",
      "image_media": {
        "alt_text": "Bathroom with glass-enclosed shower, white vanity, and large mirror.",
        "public_id": "019d02d7-db4b-7688-9375-24daf8be858d",
        "storage_key": "property/6767906449166947/019d02d7-db4b-7688-9375-24daf8be858d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a glass shower enclosure, white vanity, and contemporary fixtures.",
      "link": "",
      "alt_text": "Bathroom with glass-enclosed shower, white vanity, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FsRkURmrnKz4WOzgriU0-gdPUcv99xQAJLDlBLnq7oE/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_349cf737-24a1-47fd-8f66-779a8dd89ead",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-de15-74fa-b7b9-4f83685bf577.webp",
      "image_media": {
        "alt_text": "Empty beige bedroom with carpet and an open doorway to the bathroom vanity.",
        "public_id": "019d02d7-de15-74fa-b7b9-4f83685bf577",
        "storage_key": "property/6767906449166947/019d02d7-de15-74fa-b7b9-4f83685bf577.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Neutral-tone bedroom in a multifamily unit, featuring carpet, pale walls, and an open doorway to the bathroom.",
      "link": "",
      "alt_text": "Empty beige bedroom with carpet and an open doorway to the bathroom vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sQV3WEqclBLv_h3VmBsvNey5woH5Qd61uYjBOqShQyw/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_dcf65cd8-168b-4515-8507-67f24e03d2cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-e14a-7619-aad5-e3c7060c5f10.webp",
      "image_media": {
        "alt_text": "Empty beige apartment room with carpet and two windows with white blinds.",
        "public_id": "019d02d7-e14a-7619-aad5-e3c7060c5f10",
        "storage_key": "property/6767906449166947/019d02d7-e14a-7619-aad5-e3c7060c5f10.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Empty apartment bedroom with beige walls, carpet, and two large windows with white blinds.",
      "link": "",
      "alt_text": "Empty beige apartment room with carpet and two windows with white blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MI7xiPHJ6SlnSNXYvK136GZ4jqbGHsNJWuOVdVzHlsc/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_5b33bf14-dda9-4cc9-be34-438d716f0a9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-e476-759e-be30-c4d665108ad5.webp",
      "image_media": {
        "alt_text": "Empty beige bedroom with four windows and white horizontal blinds, carpeted floor.",
        "public_id": "019d02d7-e476-759e-be30-c4d665108ad5",
        "storage_key": "property/6767906449166947/019d02d7-e476-759e-be30-c4d665108ad5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, empty bedroom in a modern apartment with neutral walls, plush carpet, and large windows with blinds.",
      "link": "",
      "alt_text": "Empty beige bedroom with four windows and white horizontal blinds, carpeted floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/GLofI8fwPblr6ALRAzvNlcvmuKpeYe6SOW55uk5DONs/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_08444de7-24bb-478f-9974-f9a61fdbc386",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-e461-700f-9236-845060d4a7e5.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with an island, sink, and stainless steel appliances.",
        "public_id": "019d02d7-e461-700f-9236-845060d4a7e5",
        "storage_key": "property/6767906449166947/019d02d7-e461-700f-9236-845060d4a7e5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Open-concept kitchen in a contemporary apartment with a large island, stainless steel appliances, and ample storage.",
      "link": "",
      "alt_text": "Modern apartment kitchen with an island, sink, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/afEwzVbvCpfS-GUfodJuJtZwY9JHO895joNSlMBhXBE/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_254eb266-5b11-47fe-b0e1-77d364fa9094",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-e71d-765c-8746-665c996a7f36.webp",
      "image_media": {
        "alt_text": "Bright living area with laminate flooring, three windows with blinds, a glass door, and a ceiling fan.",
        "public_id": "019d02d7-e71d-765c-8746-665c996a7f36",
        "storage_key": "property/6767906449166947/019d02d7-e71d-765c-8746-665c996a7f36.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral walls, wood-look flooring, blinds, a ceiling fan, and a door to the balcony.",
      "link": "",
      "alt_text": "Bright living area with laminate flooring, three windows with blinds, a glass door, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/a9d2614V08mGpGuR9P1BfNBWj0pY8C0QCTgjI9g5ok8/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_5b6248a4-2481-4762-b7fd-19a5cd069cc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-ea19-7600-8216-3bfd93bcba84.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and subway tile backsplash.",
        "public_id": "019d02d7-ea19-7600-8216-3bfd93bcba84",
        "storage_key": "property/6767906449166947/019d02d7-ea19-7600-8216-3bfd93bcba84.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, contemporary kitchen in a stylish apartment with stainless appliances and quartz countertops.",
      "link": "",
      "alt_text": "Modern white kitchen with stainless steel appliances and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Ar3BzGtUSHvG-rHFGzfHUgaphc2WCKVU5cQPuYFSJgI/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_d757eee7-2116-4b3b-9c89-6eae41cd6d42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-ed45-7178-85db-bc5fd384aaea.webp",
      "image_media": {
        "alt_text": "Open-plan kitchen and living area with an island, beige cabinets, stainless steel appliances, and wood-look flooring.",
        "public_id": "019d02d7-ed45-7178-85db-bc5fd384aaea",
        "storage_key": "property/6767906449166947/019d02d7-ed45-7178-85db-bc5fd384aaea.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, modern apartment interior featuring a kitchen island, neutral walls, and ample storage.",
      "link": "",
      "alt_text": "Open-plan kitchen and living area with an island, beige cabinets, stainless steel appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/VJ55Gfe4Uw1BRRUOOxXrX7J1Q5tmbDafWUTWa40pbFk/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_74ff417e-61d7-4bf0-b7b3-7ab0492a5ebd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-eeda-77d1-b794-b5e12264580f.webp",
      "image_media": {
        "alt_text": "Bathroom with tiled shower surround, bathtub, and towel bars.",
        "public_id": "019d02d7-eeda-77d1-b794-b5e12264580f",
        "storage_key": "property/6767906449166947/019d02d7-eeda-77d1-b794-b5e12264580f.webp",
        "width": 2048,
        "height": 1337
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with marble-look tile shower surround and built-in tub.",
      "link": "",
      "alt_text": "Bathroom with tiled shower surround, bathtub, and towel bars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/81u0S21KqJp7OD6fG7dr_gHfFGTUFagw2Ric3IC6yWk/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_9acad2b6-5de8-4d1f-a668-9558f81edd1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-f051-75d9-b30f-80973d058992.webp",
      "image_media": {
        "alt_text": "Empty beige bedroom with carpet and two windows with white blinds.",
        "public_id": "019d02d7-f051-75d9-b30f-80973d058992",
        "storage_key": "property/6767906449166947/019d02d7-f051-75d9-b30f-80973d058992.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, empty bedroom in a modern apartment with carpet flooring and two windows with white blinds.",
      "link": "",
      "alt_text": "Empty beige bedroom with carpet and two windows with white blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2JfM64lRDSdo5NveNcYJf7n2xCIftnHblEHb-L5DTZM/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_1a82b1a7-8645-4872-bdb6-1dfa4a6c05fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-f37c-7249-8495-c39b1075c17c.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with light wood cabinets, white countertop, sink, and large mirror.",
        "public_id": "019d02d7-f37c-7249-8495-c39b1075c17c",
        "storage_key": "property/6767906449166947/019d02d7-f37c-7249-8495-c39b1075c17c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Interior view of an apartment bathroom showing a vanity with multiple drawers and built-in storage.",
      "link": "",
      "alt_text": "Bathroom vanity with light wood cabinets, white countertop, sink, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JrD1yfvuh9oFJE2kNedwTgzXlv8GFZiB8XLE9qkzThU/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_4ea3ee30-7503-487e-8d1d-6d189a204c17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-f716-7196-88c7-f7ff132cd70b.webp",
      "image_media": {
        "alt_text": "Bathroom interior with beige walls and marble-like tile surround around a white bathtub.",
        "public_id": "019d02d7-f716-7196-88c7-f7ff132cd70b",
        "storage_key": "property/6767906449166947/019d02d7-f716-7196-88c7-f7ff132cd70b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A modern apartment bathroom featuring a white bathtub and marble-pattern tile walls.",
      "link": "",
      "alt_text": "Bathroom interior with beige walls and marble-like tile surround around a white bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cYJowYNkSlDbgTZd8jff66RAze5IZpR8dCbFQeWFlEo/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_efc98ff9-ef26-4178-b5af-39575a019123",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-f81e-746d-8b8f-8db467006412.webp",
      "image_media": {
        "alt_text": "Two-sink bathroom vanity with lighted mirror and beige wood cabinets.",
        "public_id": "019d02d7-f81e-746d-8b8f-8db467006412",
        "storage_key": "property/6767906449166947/019d02d7-f81e-746d-8b8f-8db467006412.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring dual sinks, quartz countertop, and light wood cabinetry.",
      "link": "",
      "alt_text": "Two-sink bathroom vanity with lighted mirror and beige wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/H_8poI6SqBZwIGh5Rsf2F5uxYUCAolnA_sBvekVwbcU/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_81cd9bdd-8a04-4115-aefe-b7ea3566cc1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-fa6f-76c0-9787-7bfb06990e93.webp",
      "image_media": {
        "alt_text": "Double-sink bathroom vanity with quartz countertop, sleek faucets, and a large mirror.",
        "public_id": "019d02d7-fa6f-76c0-9787-7bfb06990e93",
        "storage_key": "property/6767906449166947/019d02d7-fa6f-76c0-9787-7bfb06990e93.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a double vanity, sleek fixtures, and neutral tones.",
      "link": "",
      "alt_text": "Double-sink bathroom vanity with quartz countertop, sleek faucets, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jpct0LDXMTJwYe7keZ-V3wbbwpj88xNXry9aZzEirvc/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_5f1b5cfc-9be0-45bb-899d-ff95f3ee70ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-fc74-75e0-8bf1-25fa47e368e6.webp",
      "image_media": {
        "alt_text": "Interior of a beige-walled apartment room with carpet and three doorways to a closet and adjoining spaces.",
        "public_id": "019d02d7-fc74-75e0-8bf1-25fa47e368e6",
        "storage_key": "property/6767906449166947/019d02d7-fc74-75e0-8bf1-25fa47e368e6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Neutral-toned bedroom in a multifamily property showing carpet, closet access, and adjoining rooms.",
      "link": "",
      "alt_text": "Interior of a beige-walled apartment room with carpet and three doorways to a closet and adjoining spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EIXbxFW71ByKfeegfocVgMlGs6eIbOBafGUwO2b9oHo/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_698e4e63-ab30-4172-977c-e3c6886e4b5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-005c-7254-bb94-485499d2c65b.webp",
      "image_media": {
        "alt_text": "Apartment kitchen with light wood cabinets, gray countertop, white tile backsplash, and stainless steel sink.",
        "public_id": "019d02d8-005c-7254-bb94-485499d2c65b",
        "storage_key": "property/6767906449166947/019d02d8-005c-7254-bb94-485499d2c65b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with ample counter space, white subway tile backsplash, and stainless steel appliances.",
      "link": "",
      "alt_text": "Apartment kitchen with light wood cabinets, gray countertop, white tile backsplash, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/x4pg046_29_oebhz8xOMel09In4Ggb65voSqsKHNSaw/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_bbc20fc7-07f6-4d09-a895-3ae23b5b3801",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-015e-71eb-9082-ecdb84c210c7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless-steel microwave and oven, light wood cabinets, and white countertops.",
        "public_id": "019d02d8-015e-71eb-9082-ecdb84c210c7",
        "storage_key": "property/6767906449166947/019d02d8-015e-71eb-9082-ecdb84c210c7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Contemporary apartment kitchen with stainless steel appliances, light wood cabinetry, white countertops, and a subway tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with stainless-steel microwave and oven, light wood cabinets, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/e4I-MNOl4ekNiybGPSHiaP_v0sfuYnZufsGziitc4uo/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_38ac2c83-680e-46d7-ac8b-7018938a7004",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-05a3-76e5-bd73-a4b6c2d0ea6e.webp",
      "image_media": {
        "alt_text": "Interior of an empty apartment with a stainless steel fridge, light cabinets, and an entry doorway.",
        "public_id": "019d02d8-05a3-76e5-bd73-a4b6c2d0ea6e",
        "storage_key": "property/6767906449166947/019d02d8-05a3-76e5-bd73-a4b6c2d0ea6e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Open-concept living area featuring a modern kitchen with stainless fridge and entry doors; perfect for quick apartment tours.",
      "link": "",
      "alt_text": "Interior of an empty apartment with a stainless steel fridge, light cabinets, and an entry doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cE4ahgiB5G0oJyyH6rReztJoz1RhgRNOIfUofcSNhws/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_769d3f27-5043-4958-85d9-a8830c519c12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-05d1-7516-b33a-cae5882b2774.webp",
      "image_media": {
        "alt_text": "Empty apartment living area with windows, wood-style flooring, ceiling fan, and a nearby kitchen counter.",
        "public_id": "019d02d8-05d1-7516-b33a-cae5882b2774",
        "storage_key": "property/6767906449166947/019d02d8-05d1-7516-b33a-cae5882b2774.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, open living area in a modern apartment with neutral walls, wood-style flooring, ceiling fan, and a partial view of the kitchen.",
      "link": "",
      "alt_text": "Empty apartment living area with windows, wood-style flooring, ceiling fan, and a nearby kitchen counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k_A9oGvcGe6eFESivwunBFi24hcyNzUtFXF3OQMGBqU/116/tapestry-tyvola-charlotte-nc-2br2ba---meridian.jpg"
    },
    {
      "id": "custom_87e5a6f1-7ff6-441a-beb1-ac0fcc9165cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-0a2c-701d-a114-a271f7e34f5d.webp",
      "image_media": {
        "alt_text": "Glass shower enclosure with marble tile walls in an apartment bathroom.",
        "public_id": "019d02d8-0a2c-701d-a114-a271f7e34f5d",
        "storage_key": "property/6767906449166947/019d02d8-0a2c-701d-a114-a271f7e34f5d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a glass shower and marble tile walls.",
      "link": "",
      "alt_text": "Glass shower enclosure with marble tile walls in an apartment bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/CJ1yLHcL0QmWx38Sq7wP8Ajhb6a9lBKhMnJocxF_qQg/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_b8efa3ab-4441-4acf-bae8-9074e59992d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-0c90-73bd-933b-ced1f55349f9.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, countertop, and a large mirror; open closet visible to the left.",
        "public_id": "019d02d8-0c90-73bd-933b-ced1f55349f9",
        "storage_key": "property/6767906449166947/019d02d8-0c90-73bd-933b-ced1f55349f9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright bathroom with a single-sink vanity, light countertop, modern faucet, and abundant storage in a neutral palette.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, countertop, and a large mirror; open closet visible to the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6ljhZ4yd8WQAhlG6yCrb8haVtXI6iqsQB0qKCNG7P_U/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_9251ac84-0fbf-40e1-83ce-8fe7332da4fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-0ee2-7273-94ea-db16cdd7adc9.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls, carpet, and an open door to a bathroom vanity.",
        "public_id": "019d02d8-0ee2-7273-94ea-db16cdd7adc9",
        "storage_key": "property/6767906449166947/019d02d8-0ee2-7273-94ea-db16cdd7adc9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Neutral-toned apartment bedroom with carpet, opening to an en-suite bathroom and vanity.",
      "link": "",
      "alt_text": "Empty bedroom with beige walls, carpet, and an open door to a bathroom vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DfCwQMcdcsi4ZB5YstDli2A6yZLeR7Zw1CBKXjA7K48/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_b363dbfe-47c2-4c73-a077-200eb02c5813",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-0f7e-71ad-b43f-491486fb6aee.webp",
      "image_media": {
        "alt_text": "Bathroom with light marble tile walls and a white tub with brushed nickel fixtures.",
        "public_id": "019d02d8-0f7e-71ad-b43f-491486fb6aee",
        "storage_key": "property/6767906449166947/019d02d8-0f7e-71ad-b43f-491486fb6aee.webp",
        "width": 2048,
        "height": 1393
      },
      "title": "Apartment",
      "description": "Modern bathroom with marble tile surround, white tub, and brushed nickel fixtures.",
      "link": "",
      "alt_text": "Bathroom with light marble tile walls and a white tub with brushed nickel fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5hx-NZnvWE0etEkgCJ4IrfmZy_QuxVxypkqtLtyD5tY/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_a79c78f0-3fd9-4ada-a77c-129878145225",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-133f-76f9-9ef6-e703aadaf1da.webp",
      "image_media": {
        "alt_text": "Double-sink bathroom vanity with large mirror and contemporary fixtures.",
        "public_id": "019d02d8-133f-76f9-9ef6-e703aadaf1da",
        "storage_key": "property/6767906449166947/019d02d8-133f-76f9-9ef6-e703aadaf1da.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Apartment bathroom featuring a double vanity, light countertop, and modern fixtures.",
      "link": "",
      "alt_text": "Double-sink bathroom vanity with large mirror and contemporary fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mrmHjmIYflJt_SNi4oFA4OsdnmJEl-4eyOHWZH40T5c/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_048ffe87-79dd-48c3-811d-70ebddb88462",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-15e6-71a5-b049-5be971bcd9fc.webp",
      "image_media": {
        "alt_text": "Empty beige bedroom with four windows covered by white blinds and carpet.",
        "public_id": "019d02d8-15e6-71a5-b049-5be971bcd9fc",
        "storage_key": "property/6767906449166947/019d02d8-15e6-71a5-b049-5be971bcd9fc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, empty bedroom in a modern apartment with four large windows, white blinds, and neutral beige walls.",
      "link": "",
      "alt_text": "Empty beige bedroom with four windows covered by white blinds and carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/GJCtdToLrDeaAlQy2tUaGOjeKr1YG-rMYNp6Xi5XbTo/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_d56eb0a3-301b-47ed-9de4-eacde11cac13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-188e-70f8-9ffd-2bc6f1abc829.webp",
      "image_media": {
        "alt_text": "Kitchen with island, sink, pendant lighting, and a stainless-steel dishwasher in a neutral-toned apartment.",
        "public_id": "019d02d8-188e-70f8-9ffd-2bc6f1abc829",
        "storage_key": "property/6767906449166947/019d02d8-188e-70f8-9ffd-2bc6f1abc829.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, open-concept kitchen with an island, modern faucet, and stainless-steel appliances in a contemporary apartment.",
      "link": "",
      "alt_text": "Kitchen with island, sink, pendant lighting, and a stainless-steel dishwasher in a neutral-toned apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HI1IO5F7kgb5RlmpzYEvC9BBJLvox2yeBsSxl1sqhNU/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_f15505ff-a862-4a12-a6fd-8375eb748797",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-18f5-744c-9d33-f1b0656e13a8.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with an island, sink, pendant lights, and light wood cabinets.",
        "public_id": "019d02d8-18f5-744c-9d33-f1b0656e13a8",
        "storage_key": "property/6767906449166947/019d02d8-18f5-744c-9d33-f1b0656e13a8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Open-concept kitchen in a contemporary apartment with an island, sink, pendant lighting, and light wood cabinets.",
      "link": "",
      "alt_text": "Modern apartment kitchen with an island, sink, pendant lights, and light wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BVZ-eLwtetedtsPO3zrqKj3SLcrORg1R4wkR4DBkEpQ/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_5b7c4a05-a4af-40b0-a229-5e4d148d1088",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-1d1e-713e-91ad-02843b997d61.webp",
      "image_media": {
        "alt_text": "Kitchen in apartment with stainless steel appliances, light wood cabinets, and white tile backsplash.",
        "public_id": "019d02d8-1d1e-713e-91ad-02843b997d61",
        "storage_key": "property/6767906449166947/019d02d8-1d1e-713e-91ad-02843b997d61.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with stainless steel fridge, microwave, and oven, and light wood cabinetry.",
      "link": "",
      "alt_text": "Kitchen in apartment with stainless steel appliances, light wood cabinets, and white tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jk6U4RFe0OWGIemDIpZma-FUbbDWnDT9ahhpIVOdxJc/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_5bb4e026-8503-4e15-8a4d-84ada88d5c08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-1f3d-7476-bd2b-df0b74b71885.webp",
      "image_media": {
        "alt_text": "Open-concept living area with a kitchen island, stainless steel appliances, and wood-look flooring.",
        "public_id": "019d02d8-1f3d-7476-bd2b-df0b74b71885",
        "storage_key": "property/6767906449166947/019d02d8-1f3d-7476-bd2b-df0b74b71885.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment with an open-concept kitchen, island seating, and stainless-steel appliances.",
      "link": "",
      "alt_text": "Open-concept living area with a kitchen island, stainless steel appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WR7KVBfmj8yt7-88WioMQ-h6YPs8RBsdAa1Mf3Ygjuw/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_f09e941a-1174-4bf3-b001-ec4f02f4c9ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-2248-74dd-87c5-f6327d26035a.webp",
      "image_media": {
        "alt_text": "Empty living area with beige walls, wood-look floor, ceiling fan, and three windows with blinds.",
        "public_id": "019d02d8-2248-74dd-87c5-f6327d26035a",
        "storage_key": "property/6767906449166947/019d02d8-2248-74dd-87c5-f6327d26035a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright living space in an apartment with neutral walls, wood-look flooring, a ceiling fan, and multiple windows.",
      "link": "",
      "alt_text": "Empty living area with beige walls, wood-look floor, ceiling fan, and three windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Rty9iUAijKMJiXnhrmrgCILSb_edRXA_EpahhLeKiis/116/tapestry-tyvola-charlotte-nc-2br2ba---aramis.jpg"
    },
    {
      "id": "custom_08fbd60b-fc8a-4877-9c2f-d660da2c1179",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-2346-7027-821a-e44aff34272a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a glass shower enclosure, white vanity, and open closet door.",
        "public_id": "019d02d8-2346-7027-821a-e44aff34272a",
        "storage_key": "property/6767906449166947/019d02d8-2346-7027-821a-e44aff34272a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with marble-look shower tiles, a contemporary vanity, and an open closet",
      "link": "",
      "alt_text": "Modern bathroom with a glass shower enclosure, white vanity, and open closet door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/72dIe-geyrY4IgjQcctlK70P2J-NlsxTBZXgji1G2e4/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_a84d92ae-42db-4bfb-8bd7-cfd4720c4774",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-2645-70be-a3b6-a3f65a709f47.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, plant, and large mirror in an apartment.",
        "public_id": "019d02d8-2645-70be-a3b6-a3f65a709f47",
        "storage_key": "property/6767906449166947/019d02d8-2645-70be-a3b6-a3f65a709f47.webp",
        "width": 2048,
        "height": 1452
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a white vanity, brass faucet, bright mirror, and a potted plant.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, plant, and large mirror in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/afMfv7yVo2esNUSAJMH-XsHbEE40G-E_lVfR130rQcA/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_c95fde80-823c-4bd0-9747-f3ba3570e967",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-29b8-766c-8efc-db3a12186024.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a bed, nightstand, wall art, and an open bathroom doorway.",
        "public_id": "019d02d8-29b8-766c-8efc-db3a12186024",
        "storage_key": "property/6767906449166947/019d02d8-29b8-766c-8efc-db3a12186024.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A modern apartment bedroom with a blue upholstered bed, mustard accent wall, and a visible bathroom doorway.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a bed, nightstand, wall art, and an open bathroom doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MfOSJCl9XMne7oPZ4a_LEJSVMsr6ol3aBCgj-HoKXTQ/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_1e088a96-9c00-4de5-a3d9-8c162b2f1494",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-2b4f-769a-902e-f1886e790983.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment featuring a mustard orange accent wall, blue upholstered headboard, and pendant lights.",
        "public_id": "019d02d8-2b4f-769a-902e-f1886e790983",
        "storage_key": "property/6767906449166947/019d02d8-2b4f-769a-902e-f1886e790983.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A stylish apartment bedroom with bold color accents, cozy bedding, and modern lighting for a welcoming vibe.",
      "link": "",
      "alt_text": "Bedroom in an apartment featuring a mustard orange accent wall, blue upholstered headboard, and pendant lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_y78t1d3QAGvGkzBPL2MBoCe5q9jdGdEd6cvTfowwNI/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_d24d4bf7-5c48-4915-a22d-9333d9b69b1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-2d28-753f-85a7-10ee4370b2b5.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with a modern island and sink, view into the living area.",
        "public_id": "019d02d8-2d28-753f-85a7-10ee4370b2b5",
        "storage_key": "property/6767906449166947/019d02d8-2d28-753f-85a7-10ee4370b2b5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright open-concept kitchen and living space in a stylish apartment unit.",
      "link": "",
      "alt_text": "Open-concept kitchen with a modern island and sink, view into the living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OQ5X11xUBr1i5HQ-X7-1frutpXx2RfjyUFnxTLkkhys/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_e580dde2-0f9c-4e4d-9dc2-094393a0fa5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-2ff6-71a0-b06a-1a53c0b77add.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel fridge, microwave, and oven.",
        "public_id": "019d02d8-2ff6-71a0-b06a-1a53c0b77add",
        "storage_key": "property/6767906449166947/019d02d8-2ff6-71a0-b06a-1a53c0b77add.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Contemporary kitchen in a modern apartment with stainless steel appliances and light cabinetry.",
      "link": "",
      "alt_text": "Modern apartment kitchen with stainless steel fridge, microwave, and oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pdiXTaXfY16TCZGVCkBUyPJbocasUV8rG7I4_kx1CGY/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_3d5eb431-43be-4f8f-a2fd-c6ed3446a382",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-32af-70cd-a004-94da3d32f139.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel fridge, microwave, and bar seating.",
        "public_id": "019d02d8-32af-70cd-a004-94da3d32f139",
        "storage_key": "property/6767906449166947/019d02d8-32af-70cd-a004-94da3d32f139.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright modern apartment kitchen with white cabinetry, stainless steel appliances, and a breakfast island.",
      "link": "",
      "alt_text": "Modern kitchen with island, stainless steel fridge, microwave, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ozfAdviQtpoHHT7CzwttRmc3cyVKiModrlA08jm5Wd8/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_96b348cf-1df9-4498-b081-ba72a7e58bf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-358c-752b-91d6-90385f52c5e1.webp",
      "image_media": {
        "alt_text": "Open-concept apartment interior with a modern kitchen, bar stools, and a cozy living area.",
        "public_id": "019d02d8-358c-752b-91d6-90385f52c5e1",
        "storage_key": "property/6767906449166947/019d02d8-358c-752b-91d6-90385f52c5e1.webp",
        "width": 2048,
        "height": 1440
      },
      "title": "Apartment",
      "description": "Modern open-plan apartment featuring a sleek kitchen, bar seating, and a comfortable living area.",
      "link": "",
      "alt_text": "Open-concept apartment interior with a modern kitchen, bar stools, and a cozy living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/LooiutiNSevsXNvdfQ1tNLziHObsz7AbvF5h75HJKHU/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_d110c419-e75d-437a-bbcb-5c33e1d08096",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-3759-739a-9d4f-3210115bc5cf.webp",
      "image_media": {
        "alt_text": "Bright living room with beige sectional, pink rug, green curtains, and a floor lamp.",
        "public_id": "019d02d8-3759-739a-9d4f-3210115bc5cf",
        "storage_key": "property/6767906449166947/019d02d8-3759-739a-9d4f-3210115bc5cf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment living area with neutral tones, contemporary art, and cozy seating.",
      "link": "",
      "alt_text": "Bright living room with beige sectional, pink rug, green curtains, and a floor lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jY5Mog4p2AEbck9NtiC3SYG-6A2XynjkwHGBG5kiCGw/116/tapestry-tyvola-charlotte-nc-1br1ba---calypso.jpg"
    },
    {
      "id": "custom_83a7600d-5b3c-4af7-a9db-cae6227596dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-38f2-749d-b498-7971cb7094d2.webp",
      "image_media": {
        "alt_text": "Bedroom with large geometric headboard, white bedding, and ceiling fan.",
        "public_id": "019d02d8-38f2-749d-b498-7971cb7094d2",
        "storage_key": "property/6767906449166947/019d02d8-38f2-749d-b498-7971cb7094d2.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Bright modern bedroom showcasing a geometric headboard, plush bedding, and a view of the adjoining bathroom.",
      "link": "",
      "alt_text": "Bedroom with large geometric headboard, white bedding, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8h62gACw55MZqTVrbEYbv2LD85XRxBex2hqQxOTAy0Y/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_fd95ec63-1ed1-4e7f-b488-4f6815441729",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-3c22-764a-9b1f-f7a0f72c3abc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with wide vanity, large mirror, and visible laundry area.",
        "public_id": "019d02d8-3c22-764a-9b1f-f7a0f72c3abc",
        "storage_key": "property/6767906449166947/019d02d8-3c22-764a-9b1f-f7a0f72c3abc.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment bathroom featuring a wide vanity, clean lines, tile shower surround, and nearby laundry area.",
      "link": "",
      "alt_text": "Modern bathroom with wide vanity, large mirror, and visible laundry area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/161XPylno4yxKyLHW5zaDzn_5qXBDwaIk6FX8QWlMYc/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_151ed221-8594-4027-9bdf-861eafd14e59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-3f0d-75da-924c-b6f72768b3fb.webp",
      "image_media": {
        "alt_text": "Open living area with beige sofa, throw pillows, and a kitchen island with bar stools.",
        "public_id": "019d02d8-3f0d-75da-924c-b6f72768b3fb",
        "storage_key": "property/6767906449166947/019d02d8-3f0d-75da-924c-b6f72768b3fb.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Apartment",
      "description": "Bright, modern apartment living space featuring a beige sofa and a stainless steel kitchen with an island.",
      "link": "",
      "alt_text": "Open living area with beige sofa, throw pillows, and a kitchen island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fdd64606f0e643704c10ee0fabf36b3f2.jpg"
    },
    {
      "id": "custom_5642b651-a881-43a6-91b7-4d7a5107fa85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-4168-7418-a0fa-5364d8f47350.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with a single-sink vanity, large mirror, glass shower, and toilet.",
        "public_id": "019d02d8-4168-7418-a0fa-5364d8f47350",
        "storage_key": "property/6767906449166947/019d02d8-4168-7418-a0fa-5364d8f47350.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment bathroom with a quartz countertop, light wood vanity, and a glass shower.",
      "link": "",
      "alt_text": "Modern apartment bathroom with a single-sink vanity, large mirror, glass shower, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fbe5df9eb7406fe776db8bb9edba23bde.webp"
    },
    {
      "id": "custom_9217bf0b-0d66-4e9c-963b-ccf037add8ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-4328-774f-9495-eee2d29ccc7f.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with lounge chairs and multi-story building exteriors.",
        "public_id": "019d02d8-4328-774f-9495-eee2d29ccc7f",
        "storage_key": "property/6767906449166947/019d02d8-4328-774f-9495-eee2d29ccc7f.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Outdoor pool at a modern apartment community with lounge seating and surrounding buildings.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with lounge chairs and multi-story building exteriors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2q1vjLynDUXdMNBM3ElIB7w_czWd93TFt0mCEJnpK5I/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_0e77b88b-d5f4-4aac-9c63-c5b4191449d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-45a2-755a-8d59-8908c894fc24.webp",
      "image_media": {
        "alt_text": "Fenced community play area with a blue tunnel and autumn trees in the background.",
        "public_id": "019d02d8-45a2-755a-8d59-8908c894fc24",
        "storage_key": "property/6767906449166947/019d02d8-45a2-755a-8d59-8908c894fc24.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Outdoor amenity area at a multifamily property featuring a fenced play yard and fall foliage.",
      "link": "",
      "alt_text": "Fenced community play area with a blue tunnel and autumn trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_zrrKeaeO92dWh6ALw_HXyGMxo6eF0wLi5PR8K6_Hqg/116/tapestry-tyvola-charlotte-nc-dog-park.jpg"
    },
    {
      "id": "custom_1327d8d7-20d9-49ac-a5ff-fd8ca014cf0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-483c-76da-9476-2f763d2d5d7c.webp",
      "image_media": {
        "alt_text": "Bright apartment community lobby with tall windows, pendant lights, and modern seating.",
        "public_id": "019d02d8-483c-76da-9476-2f763d2d5d7c",
        "storage_key": "property/6767906449166947/019d02d8-483c-76da-9476-2f763d2d5d7c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Bright contemporary lobby in an apartment community featuring large windows, warm seating, and modern decor.",
      "link": "",
      "alt_text": "Bright apartment community lobby with tall windows, pendant lights, and modern seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Zk2h06nUfioExE7JHcVG5Fc4ht6mISe98aaoGdj5JaM/116/tapestry-tyvola-charlotte-nc-leasing-office.jpg"
    },
    {
      "id": "custom_f9b1d3cb-da8b-4cb8-9709-65e1a23d4c36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-4b3c-70f1-bedc-1822c9781e72.webp",
      "image_media": {
        "alt_text": "Interior of a resident lounge with wall mailboxes and a large table.",
        "public_id": "019d02d8-4b3c-70f1-bedc-1822c9781e72",
        "storage_key": "property/6767906449166947/019d02d8-4b3c-70f1-bedc-1822c9781e72.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern resident lounge with wall-mounted mailboxes and a central wooden table for group meetings.",
      "link": "",
      "alt_text": "Interior of a resident lounge with wall mailboxes and a large table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6D3vU4wpH-ydIfWv09LE9u_ToPBK-oPpG5cvAuCxaoA/116/tapestry-tyvola-charlotte-nc-mail-room.jpg"
    },
    {
      "id": "custom_4d8750fd-641d-440b-94ef-69fd3b6f398c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-4c8f-7197-891c-a3a129155725.webp",
      "image_media": {
        "alt_text": "Outdoor communal seating area with gray couches and a central fire pit in a modern apartment courtyard.",
        "public_id": "019d02d8-4c8f-7197-891c-a3a129155725",
        "storage_key": "property/6767906449166947/019d02d8-4c8f-7197-891c-a3a129155725.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Outdoor lounge at a contemporary apartment community featuring cushioned seating and a fire pit.",
      "link": "",
      "alt_text": "Outdoor communal seating area with gray couches and a central fire pit in a modern apartment courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/msrheW90NG5taIiaq7VVxwrq8fvvy91kZ1MDv-aTmf8/116/tapestry-tyvola-charlotte-nc-fire-pit.jpg"
    },
    {
      "id": "custom_553aaece-7e9c-47bb-9b2c-efe6a747724c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-5161-74fd-8fd0-5153ff320a99.webp",
      "image_media": {
        "alt_text": "Outdoor stainless steel barbecue grill with storage cabinets set in a white brick wall.",
        "public_id": "019d02d8-5161-74fd-8fd0-5153ff320a99",
        "storage_key": "property/6767906449166947/019d02d8-5161-74fd-8fd0-5153ff320a99.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Outdoor community grilling station with a stainless steel grill and double-door cabinets built into a white brick wall.",
      "link": "",
      "alt_text": "Outdoor stainless steel barbecue grill with storage cabinets set in a white brick wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Yzmhfd2Xz_YANE2H1jJNU0CRrVJEjtSSREzvdCjhRxA/116/tapestry-tyvola-charlotte-nc-grilling-area.jpg"
    },
    {
      "id": "custom_9be71d40-5157-4a79-b1b2-f42cb95aaf0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-51c9-758a-9fa8-2058d097a163.webp",
      "image_media": {
        "alt_text": "Exterior sign for Tapestry Tyvola at the property entrance with landscaping.",
        "public_id": "019d02d8-51c9-758a-9fa8-2058d097a163",
        "storage_key": "property/6767906449166947/019d02d8-51c9-758a-9fa8-2058d097a163.webp",
        "width": 2048,
        "height": 1534
      },
      "title": "Community",
      "description": "Exterior view of the Tapestry Tyvola community entrance with landscaped surroundings.",
      "link": "",
      "alt_text": "Exterior sign for Tapestry Tyvola at the property entrance with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/izCWg5Dcxihu7zw70_kTDRAe6fzSSXd7qWcWjZSNNAg/116/tapestry-tyvola-charlotte-nc-signage.jpg"
    },
    {
      "id": "custom_5089e729-b5bf-440c-99ce-579a6e89e281",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-555c-76a2-93e5-c9fe3bb8bc8b.webp",
      "image_media": {
        "alt_text": "Modern multi-building apartment complex exterior with balconies and a street-level entrance.",
        "public_id": "019d02d8-555c-76a2-93e5-c9fe3bb8bc8b",
        "storage_key": "property/6767906449166947/019d02d8-555c-76a2-93e5-c9fe3bb8bc8b.webp",
        "width": 2048,
        "height": 1534
      },
      "title": "Community",
      "description": "Exterior view of a contemporary multifamily community featuring white and gray façades, balconies, and a welcoming ground-floor entrance.",
      "link": "",
      "alt_text": "Modern multi-building apartment complex exterior with balconies and a street-level entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/y_HAi-7iTzB5dTDn2LScJXCN7Q2vudvr_j3N4jI_2w8/116/tapestry-tyvola-charlotte-nc-leasing-office.jpg"
    },
    {
      "id": "custom_1e6375af-43b6-4dd6-af3f-469c37aa9df1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-56ba-710b-9724-dfbef8a6ff2a.webp",
      "image_media": {
        "alt_text": "Cardio fitness area in a resident gym with treadmills and elliptical machines by large windows.",
        "public_id": "019d02d8-56ba-710b-9724-dfbef8a6ff2a",
        "storage_key": "property/6767906449166947/019d02d8-56ba-710b-9724-dfbef8a6ff2a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "A modern, well-lit community gym featuring multiple cardio machines for residents.",
      "link": "",
      "alt_text": "Cardio fitness area in a resident gym with treadmills and elliptical machines by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sKki1l_QeHU9dpP1QX-8JZMwAm05udH604ftm_FQn5Y/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_e94168f2-0621-485d-9f24-f32db31134c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-5ba5-732d-b986-dec82c1ff637.webp",
      "image_media": {
        "alt_text": "Indoor gym with several stationary bikes and large floor-to-ceiling windows.",
        "public_id": "019d02d8-5ba5-732d-b986-dec82c1ff637",
        "storage_key": "property/6767906449166947/019d02d8-5ba5-732d-b986-dec82c1ff637.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Bright resident fitness center featuring cardio bikes and mirrored walls with courtyard views.",
      "link": "",
      "alt_text": "Indoor gym with several stationary bikes and large floor-to-ceiling windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/75xBXiuxrzcjjtyt7wfb8N9c5oxoF6F-Ww-GY0bR3tU/116/tapestry-tyvola-charlotte-nc-fitness-center.jpg"
    },
    {
      "id": "custom_3bb4b416-1acd-4425-a860-b9c2f1d4b683",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-5d8d-7228-998f-b4126d5faba5.webp",
      "image_media": {
        "alt_text": "Gym area with weight machines and a bench against a teal wall.",
        "public_id": "019d02d8-5d8d-7228-998f-b4126d5faba5",
        "storage_key": "property/6767906449166947/019d02d8-5d8d-7228-998f-b4126d5faba5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Well-equipped apartment community gym with weight machines and a bench for residents.",
      "link": "",
      "alt_text": "Gym area with weight machines and a bench against a teal wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ffixUSztH5NWcvIAVYcTVWPrCdCqs_7MTcAGpSF2uD4/116/tapestry-tyvola-charlotte-nc-fitness-center.jpg"
    },
    {
      "id": "custom_013df1a2-235f-4aa9-83dc-de7d7251a03b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-628e-736f-bf04-9c774e6b4a76.webp",
      "image_media": {
        "alt_text": "Pet washing station with a stainless steel tub and steps in a tiled utility room.",
        "public_id": "019d02d8-628e-736f-bf04-9c774e6b4a76",
        "storage_key": "property/6767906449166947/019d02d8-628e-736f-bf04-9c774e6b4a76.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "A community dog-wash area in a multifamily property featuring a stainless steel wash tub, steps, and tiled walls.",
      "link": "",
      "alt_text": "Pet washing station with a stainless steel tub and steps in a tiled utility room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Q54AJiWRO9AhkOCwEBBA3juHWad_yL6z1B7gsabsmiQ/116/tapestry-tyvola-charlotte-nc-pet-spa.jpg"
    },
    {
      "id": "custom_066e1094-4eac-4e38-8071-77d5cf323707",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-6338-71a3-bf53-304bd673bd56.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with white and gray buildings, surrounded by trees and roads.",
        "public_id": "019d02d8-6338-71a3-bf53-304bd673bd56",
        "storage_key": "property/6767906449166947/019d02d8-6338-71a3-bf53-304bd673bd56.webp",
        "width": 2048,
        "height": 1392
      },
      "title": "Community",
      "description": "Bird's-eye view of a multi-building apartment community with parking, greenery, and nearby streets.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with white and gray buildings, surrounded by trees and roads.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KbR8kwe7PnCgVWY09QLGGpJRe_lAuSoNlK27ODyUw2I/116/tapestry-tyvola-charlotte-nc-community-aerial.jpg"
    },
    {
      "id": "custom_379ff5d6-2fc7-45cf-b537-034acf45dcd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-65b8-74ee-a74c-05fcde32735e.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment building with rooftop HVAC units and surrounding parking.",
        "public_id": "019d02d8-65b8-74ee-a74c-05fcde32735e",
        "storage_key": "property/6767906449166947/019d02d8-65b8-74ee-a74c-05fcde32735e.webp",
        "width": 2048,
        "height": 1534
      },
      "title": "Community",
      "description": "Bird’s-eye view of a modern multifamily community showing the building, rooftops, and adjacent parking areas.",
      "link": "",
      "alt_text": "Aerial view of a large apartment building with rooftop HVAC units and surrounding parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JWe9q_elHCds3MVCxwbcmOK_UYRWqWPwzLf-lhT4Wp4/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_44f17cab-60a9-46e8-987a-b183b035b45c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-67f9-715d-a7f4-a2130a960c00.webp",
      "image_media": {
        "alt_text": "Outdoor pool deck with white lounge chairs along a fenced courtyard of a modern apartment building.",
        "public_id": "019d02d8-67f9-715d-a7f4-a2130a960c00",
        "storage_key": "property/6767906449166947/019d02d8-67f9-715d-a7f4-a2130a960c00.webp",
        "width": 2048,
        "height": 1535
      },
      "title": "Community",
      "description": "Outdoor pool area at a modern multifamily community with a row of white lounge chairs.",
      "link": "",
      "alt_text": "Outdoor pool deck with white lounge chairs along a fenced courtyard of a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qNWWAr-X9eR89YeLMoOjaoSfXAa6Ob8xCa1ZLl-kxWU/116/tapestry-tyvola-charlotte-nc-pool.jpg"
    },
    {
      "id": "custom_62c09e3a-c0f0-4350-90e1-781902524dab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-6cc3-7579-a9c9-b5f0b702b394.webp",
      "image_media": {
        "alt_text": "Outdoor apartment pool with lounge chairs and shaded seating area",
        "public_id": "019d02d8-6cc3-7579-a9c9-b5f0b702b394",
        "storage_key": "property/6767906449166947/019d02d8-6cc3-7579-a9c9-b5f0b702b394.webp",
        "width": 2048,
        "height": 1534
      },
      "title": "Community",
      "description": "Outdoor pool at a modern apartment community with cabana seating and surrounding residential buildings.",
      "link": "",
      "alt_text": "Outdoor apartment pool with lounge chairs and shaded seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/G1wS2GNs1Y3uAVXsXMmzUwRRKSMYDv6vYn8oJGjo5FE/116/tapestry-tyvola-charlotte-nc-pool.jpg"
    },
    {
      "id": "custom_427d05f3-9ae8-4bef-a87f-c5d36a95ebf7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-6e5f-754e-a1ab-8009a84e5829.webp",
      "image_media": {
        "alt_text": "Exterior rendering of a modern multi-story apartment building with balconies and surrounding landscaping.",
        "public_id": "019d02d8-6e5f-754e-a1ab-8009a84e5829",
        "storage_key": "property/6767906449166947/019d02d8-6e5f-754e-a1ab-8009a84e5829.webp",
        "width": 1466,
        "height": 673
      },
      "title": "Community",
      "description": "Rendering of a contemporary apartment community exterior, featuring balconies, large windows, and a welcoming entrance.",
      "link": "",
      "alt_text": "Exterior rendering of a modern multi-story apartment building with balconies and surrounding landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/VyuFKeuh0u72xpbL1YV5HYhSqEPtkfwVvRwNC2GPMZE/116/tapestry-tyvola-charlotte-nc-building-photo.jpg"
    },
    {
      "id": "custom_88de8abe-b00a-427b-8ca6-bd460bd313f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-7107-73ce-b201-043523f1a51d.webp",
      "image_media": {
        "alt_text": "Outdoor pool at a modern apartment complex with lounge chairs and surrounding buildings.",
        "public_id": "019d02d8-7107-73ce-b201-043523f1a51d",
        "storage_key": "property/6767906449166947/019d02d8-7107-73ce-b201-043523f1a51d.webp",
        "width": 2048,
        "height": 1534
      },
      "title": "Community",
      "description": "A modern outdoor pool at a residential community, with lounge seating and multi-story apartment buildings in the background.",
      "link": "",
      "alt_text": "Outdoor pool at a modern apartment complex with lounge chairs and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_lW8e_cZh1eHcK41EdKyHaDNq5q3PGvaHqFLbfof1WM/116/tapestry-tyvola-charlotte-nc-pool.jpg"
    },
    {
      "id": "custom_f3947887-7793-43a6-b0f3-27bd113716fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-724f-7673-9ed5-cb341ba92094.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, free weights, and benches by large windows.",
        "public_id": "019d02d8-724f-7673-9ed5-cb341ba92094",
        "storage_key": "property/6767906449166947/019d02d8-724f-7673-9ed5-cb341ba92094.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Bright on-site gym with cardio machines, free weights, and benches for resident workouts.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, free weights, and benches by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fd451776804d10e9fc8442d08e117cc41.webp"
    },
    {
      "id": "custom_263fd767-7b5a-4724-9302-760ec6b483d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-77b4-776a-8154-dd7283a04df4.webp",
      "image_media": {
        "alt_text": "Grey wall with a large white butterfly-wing mural; a brown fluffy dog sits in front.",
        "public_id": "019d02d8-77b4-776a-8154-dd7283a04df4",
        "storage_key": "property/6767906449166947/019d02d8-77b4-776a-8154-dd7283a04df4.webp",
        "width": 3072,
        "height": 2349
      },
      "title": "Community",
      "description": "Exterior shot of a modern building featuring a large white butterfly-wing mural; a small dog sits in front.",
      "link": "",
      "alt_text": "Grey wall with a large white butterfly-wing mural; a brown fluffy dog sits in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fa5a6366f2d8da4f5fd36ea17d4cbe1d4.webp"
    },
    {
      "id": "custom_34939e9c-64a7-4515-a07b-e76236e9292e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-77c7-767d-b6b4-32cbfe9d160e.webp",
      "image_media": {
        "alt_text": "Modern apartment lobby with central island, mailboxes on the left, and a dark slat wall on the right.",
        "public_id": "019d02d8-77c7-767d-b6b4-32cbfe9d160e",
        "storage_key": "property/6767906449166947/019d02d8-77c7-767d-b6b4-32cbfe9d160e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Bright modern community lobby with a central island, mail lockers, and stylish cabinetry.",
      "link": "",
      "alt_text": "Modern apartment lobby with central island, mailboxes on the left, and a dark slat wall on the right.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F29fe901cdcdd141f7f2ef9dafefdb952.webp"
    },
    {
      "id": "custom_47b4bb7f-e129-4712-8d64-40e5e6c9317e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-7c25-725f-95fa-5ecf50429d7a.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with multiple balconies and blue sky.",
        "public_id": "019d02d8-7c25-725f-95fa-5ecf50429d7a",
        "storage_key": "property/6767906449166947/019d02d8-7c25-725f-95fa-5ecf50429d7a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A contemporary apartment community featuring a multi-story building with balconies, large windows, and landscaped surroundings.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with multiple balconies and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F3a8bc2e3e9a31399029130f8f12ff78d.webp"
    },
    {
      "id": "custom_72577664-7333-4c41-b055-e35ec9c0adca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-7d40-7259-b8b4-3ccfe4c8788c.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment complex with a central pool and lounge chairs.",
        "public_id": "019d02d8-7d40-7259-b8b4-3ccfe4c8788c",
        "storage_key": "property/6767906449166947/019d02d8-7d40-7259-b8b4-3ccfe4c8788c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment community with a central pool, lounge chairs, and multi-story buildings around a landscaped courtyard.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment complex with a central pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F3d6abd47aea95713466181d40fbae8aa.webp"
    },
    {
      "id": "custom_ef2610e1-6744-415c-b04c-ea56d5e6f127",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-8240-743c-8fe1-ee83a0b2d379.webp",
      "image_media": {
        "alt_text": "Woman smiling while using her smartphone outdoors.",
        "public_id": "019d02d8-8240-743c-8fe1-ee83a0b2d379",
        "storage_key": "property/6767906449166947/019d02d8-8240-743c-8fe1-ee83a0b2d379.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Lifestyle",
      "description": "Lifestyle photo of a smiling woman using her smartphone outdoors, suitable for property lifestyle pages.",
      "link": "",
      "alt_text": "Woman smiling while using her smartphone outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F284f80c4a15ebf7681f29fa10b898627.jpg"
    },
    {
      "id": "custom_67f541a1-aa20-4504-84cf-5386854f5ffe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-8240-743c-8fe1-ee83a0b2d379.webp",
      "image_media": {
        "alt_text": "Smiling woman with curly hair uses a smartphone outdoors on a sunny day.",
        "public_id": "019d02d8-8240-743c-8fe1-ee83a0b2d379",
        "storage_key": "property/6767906449166947/019d02d8-8240-743c-8fe1-ee83a0b2d379.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Lifestyle",
      "description": "A resident enjoys an outdoor moment, looking at her phone, conveying a relaxed lifestyle at the community.",
      "link": "",
      "alt_text": "Smiling woman with curly hair uses a smartphone outdoors on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/temporary-image-gallery/5742705921490944%2F6767906449166947%2F284f80c4a15ebf7681f29fa10b898627.jpg"
    },
    {
      "id": "custom_8da38531-183a-4265-b314-a4c669147d89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-82d2-757c-8115-99e546762be9.webp",
      "image_media": {
        "alt_text": "Side profile of a woman in a black sports bra practicing yoga indoors.",
        "public_id": "019d02d8-82d2-757c-8115-99e546762be9",
        "storage_key": "property/6767906449166947/019d02d8-82d2-757c-8115-99e546762be9.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Lifestyle",
      "description": "Lifestyle image of a woman in athletic wear practicing yoga indoors.",
      "link": "",
      "alt_text": "Side profile of a woman in a black sports bra practicing yoga indoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F2440154dbaa9561ed9f0d36451a84353.jpg"
    },
    {
      "id": "custom_5b403f3c-d8cb-49ba-a2f2-95875db7b719",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-87b6-7119-a7bc-85dfae6bd03d.webp",
      "image_media": {
        "alt_text": "Outdoor group of adults smiling and talking together.",
        "public_id": "019d02d8-87b6-7119-a7bc-85dfae6bd03d",
        "storage_key": "property/6767906449166947/019d02d8-87b6-7119-a7bc-85dfae6bd03d.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Lifestyle",
      "description": "Residents enjoying an outdoor gathering at a multifamily community, illustrating a welcoming, social atmosphere.",
      "link": "",
      "alt_text": "Outdoor group of adults smiling and talking together.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fddc14f49347a79e0817f955585292fd9.jpg"
    },
    {
      "id": "custom_aa0142f8-7dfd-4e52-898b-09974a538087",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-87fb-7413-878e-a338f6cf0eb7.webp",
      "image_media": {
        "alt_text": "Outdoor apartment pool area with lounge chairs, umbrellas, and modern mid-rise buildings surrounding.",
        "public_id": "019d02d8-87fb-7413-878e-a338f6cf0eb7",
        "storage_key": "property/6767906449166947/019d02d8-87fb-7413-878e-a338f6cf0eb7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A modern apartment community pool scene with sun loungers and umbrellas, framed by multi-story residential buildings.",
      "link": "",
      "alt_text": "Outdoor apartment pool area with lounge chairs, umbrellas, and modern mid-rise buildings surrounding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fafd33aefb02e77fb4ca35acaa478073e.webp"
    },
    {
      "id": "custom_f583c787-ed9a-4e0b-8a6a-3cc68fe45a82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-8ac0-76d1-924e-fd99135ed093.webp",
      "image_media": {
        "alt_text": "Small fluffy dog being groomed at a grooming station.",
        "public_id": "019d02d8-8ac0-76d1-924e-fd99135ed093",
        "storage_key": "property/6767906449166947/019d02d8-8ac0-76d1-924e-fd99135ed093.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Photo of a fluffy dog being groomed at a pet care/grooming area, held by a handler.",
      "link": "",
      "alt_text": "Small fluffy dog being groomed at a grooming station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F97067694c521d4e44ba92ff998c04941.webp"
    },
    {
      "id": "custom_f2dee2bf-fcd3-4e3e-adbf-80c574b73555",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-8bb2-7049-81c9-3094085ad27a.webp",
      "image_media": {
        "alt_text": "Aerial view of a rectangular pool at an apartment community with white lounge chairs around.",
        "public_id": "019d02d8-8bb2-7049-81c9-3094085ad27a",
        "storage_key": "property/6767906449166947/019d02d8-8bb2-7049-81c9-3094085ad27a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Lifestyle",
      "description": "Modern apartment pool area with sun loungers and clear blue water.",
      "link": "",
      "alt_text": "Aerial view of a rectangular pool at an apartment community with white lounge chairs around.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Ff16d8d1928f5d53619beb1603c3463dd.webp"
    },
    {
      "id": "custom_2ee93419-d278-4717-9456-d8048b447e8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-9009-706c-8c89-13ef29ccb117.webp",
      "image_media": {
        "alt_text": "Top-down floor plan of a two-bedroom apartment.",
        "public_id": "019d02d8-9009-706c-8c89-13ef29ccb117",
        "storage_key": "property/6767906449166947/019d02d8-9009-706c-8c89-13ef29ccb117.webp",
        "width": 998,
        "height": 626
      },
      "title": "Floorplan",
      "description": "Illustrated top-down floor plan of a modern two-bedroom apartment with open living space, island kitchen, and two bathrooms.",
      "link": "",
      "alt_text": "Top-down floor plan of a two-bedroom apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F9835c2c645e5fd425a649c0ba3462a47.webp"
    },
    {
      "id": "custom_d84bea26-98b3-4425-b1de-7df8e63b8cc1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-9246-7378-9351-b5a0bd5796a3.webp",
      "image_media": {
        "alt_text": "Top-down floor plan of a one-bedroom apartment with kitchen, bathroom, and living/sleeping area.",
        "public_id": "019d02d8-9246-7378-9351-b5a0bd5796a3",
        "storage_key": "property/6767906449166947/019d02d8-9246-7378-9351-b5a0bd5796a3.webp",
        "width": 925,
        "height": 626
      },
      "title": "Floorplan",
      "description": "A detailed top-down floorplan of a compact one-bedroom apartment with a full kitchen, bathroom, closet spaces, and living/sleeping area.",
      "link": "",
      "alt_text": "Top-down floor plan of a one-bedroom apartment with kitchen, bathroom, and living/sleeping area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fa2ee6a029c8b7a838e3f938c2843dc36.webp"
    },
    {
      "id": "custom_31e89802-699d-414e-92f2-bc0519ce5297",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-94e0-709b-9717-71edcd7e41fc.webp",
      "image_media": {
        "alt_text": "Top-down floor plan of a modern one-bedroom apartment, showing living area, kitchen, bedroom, bathroom, and balcony.",
        "public_id": "019d02d8-94e0-709b-9717-71edcd7e41fc",
        "storage_key": "property/6767906449166947/019d02d8-94e0-709b-9717-71edcd7e41fc.webp",
        "width": 925,
        "height": 626
      },
      "title": "Floorplan",
      "description": "Top-down floor plan of a modern one-bedroom apartment, including living area, kitchen island, bathroom, bedroom, and balcony.",
      "link": "",
      "alt_text": "Top-down floor plan of a modern one-bedroom apartment, showing living area, kitchen, bedroom, bathroom, and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F6d2c0d52f4a0fc3b28dccfc9ee43ee02.webp"
    },
    {
      "id": "custom_1c17ddef-97b9-4273-b763-713886f60296",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-96e4-75aa-836d-048ea9807a3a.webp",
      "image_media": {
        "alt_text": "Top-down 3D floor plan of a one-bedroom apartment with kitchen island, living area, bedroom, bathroom, and balcony.",
        "public_id": "019d02d8-96e4-75aa-836d-048ea9807a3a",
        "storage_key": "property/6767906449166947/019d02d8-96e4-75aa-836d-048ea9807a3a.webp",
        "width": 925,
        "height": 626
      },
      "title": "Floorplan",
      "description": "Detailed top-down floorplan of a one-bedroom apartment, showing the kitchen island, living area, bedroom, bathroom, and balcony.",
      "link": "",
      "alt_text": "Top-down 3D floor plan of a one-bedroom apartment with kitchen island, living area, bedroom, bathroom, and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2F0ca960cca6147009279181245c5d52b4.webp"
    },
    {
      "id": "custom_2cfbb95a-db7d-415d-9a8c-10978887afdd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-9909-721f-8abf-24562cfb2458.webp",
      "image_media": {
        "alt_text": "Top-down floor plan of a two-bedroom apartment with living area, kitchen island, and balcony.",
        "public_id": "019d02d8-9909-721f-8abf-24562cfb2458",
        "storage_key": "property/6767906449166947/019d02d8-9909-721f-8abf-24562cfb2458.webp",
        "width": 998,
        "height": 626
      },
      "title": "Floorplan",
      "description": "Detailed top-down floor plan of a two-bedroom apartment with a spacious living area, kitchen island, two bathrooms, and a balcony.",
      "link": "",
      "alt_text": "Top-down floor plan of a two-bedroom apartment with living area, kitchen island, and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Ff8f58265b30738d3c7dc2c154329e84b.jpg"
    },
    {
      "id": "custom_ce34dff4-e701-465e-a8e0-71ad49018815",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-9a92-71e9-b64b-b4e54669a0df.webp",
      "image_media": {
        "alt_text": "Top-down floor plan of a one-bedroom apartment with living area, kitchen island, bedroom, bath, and balcony.",
        "public_id": "019d02d8-9a92-71e9-b64b-b4e54669a0df",
        "storage_key": "property/6767906449166947/019d02d8-9a92-71e9-b64b-b4e54669a0df.webp",
        "width": 925,
        "height": 626
      },
      "title": "Floorplan",
      "description": "Floorplan of a modern apartment unit with open living area, island kitchen, bedroom, bathroom, laundry, and balcony.",
      "link": "",
      "alt_text": "Top-down floor plan of a one-bedroom apartment with living area, kitchen island, bedroom, bath, and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fec360a829b07d30893ed7b43d048404f.webp"
    },
    {
      "id": "custom_25b9ca08-98aa-44a6-83f5-0cd355e77e97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-9d28-737d-acea-49e145d94412.webp",
      "image_media": {
        "alt_text": "Logo graphic for 50 Arlington multifamily community, featuring a large '50' and 'Arlington' text.",
        "public_id": "019d02d8-9d28-737d-acea-49e145d94412",
        "storage_key": "property/6767906449166947/019d02d8-9d28-737d-acea-49e145d94412.webp",
        "width": 136,
        "height": 100
      },
      "title": "Logo",
      "description": "Brand logo for 50 Arlington, a multifamily apartment community.",
      "link": "",
      "alt_text": "Logo graphic for 50 Arlington multifamily community, featuring a large '50' and 'Arlington' text.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166947%2Fc3123a5bf5823506d153bd2040007615.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_36603b46-0383-4adf-b120-d65615b1ff43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Romeo’s Vegan Burgers",
      "poi_type": "Restaurants",
      "poi_address": "5518 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Food truck turned restaurant serving plant-based burgers, tater tots, shakes, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-c870-715d-84f4-0dabc47169e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c870-715d-84f4-0dabc47169e7",
        "storage_key": "property/6767906449166947/019d02d3-c870-715d-84f4-0dabc47169e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://romeosveganburgers.com/romeosveganburgerscharlotte?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15913186778016277576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "romeos-vegan-burgers",
      "poi_latitude": "35.1604467",
      "poi_longitude": "-80.8764989",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 980-237-7647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBRpjOLifVogRSGQaHBD_1tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vegan_restaurant"
    },
    {
      "id": "custom_23b292f2-d3ed-4628-b779-2e405e811393",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Lempira Restaurant - South Blvd.",
      "poi_type": "Restaurants",
      "poi_address": "5906 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Local chain serving Honduran, Salvadoran & other Central American dishes amid casual atmosphere.",
      "poi_long_description": "Local chain serving Honduran, Salvadoran & other Central American dishes amid casual atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-a68b-77b1-b82d-895bd93eeeea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-a68b-77b1-b82d-895bd93eeeea",
        "storage_key": "property/6767906449166947/019d02d8-a68b-77b1-b82d-895bd93eeeea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lempirarestaurant.com/lempirarestaurantsouthblvd?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3984085105634166450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lempira-restaurant---south-blvd",
      "poi_latitude": "35.15480700000001",
      "poi_longitude": "-80.8765638",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-552-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlR7M4b-eVogRssY_hEtQSjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3a7fa3cc-b9e5-4131-bbe2-fe94e2d1c86e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Punta Cana Dominican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5230 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "High-energy restaurant teaming Dominican grub with drinks, karaoke & more in a simple setting.",
      "poi_long_description": "High-energy restaurant teaming Dominican grub with drinks, karaoke & more in a simple setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-a756-7698-9a72-de969500190b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-a756-7698-9a72-de969500190b",
        "storage_key": "property/6767906449166947/019d02d8-a756-7698-9a72-de969500190b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.puntacanaclt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17770150714604730464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "punta-cana-dominican-restaurant",
      "poi_latitude": "35.1659913",
      "poi_longitude": "-80.8764449",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-529-3599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72-EHeieVogRYDgrtexBnPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3f0b7c2b-b15d-49b7-a0dd-70889be67695",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Maria's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5234 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Humble establishment providing Mexican & Tex-Mex classics, as well as beer & margaritas.",
      "poi_long_description": "Humble establishment providing Mexican & Tex-Mex classics, as well as beer & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-b8cf-71e8-8e98-5ab252d02bb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b8cf-71e8-8e98-5ab252d02bb9",
        "storage_key": "property/6767906449166947/019d02d3-b8cf-71e8-8e98-5ab252d02bb9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://ordermariasmexican.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=497478168991079358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marias-mexican-restaurant",
      "poi_latitude": "35.1656418",
      "poi_longitude": "-80.8762741",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-525-5075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3jTGOieVogRvps5SsJl5wY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_66a2a1c1-52b5-4d18-933f-4725ebbf89b8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Crispy Banh Mi",
      "poi_type": "Restaurants",
      "poi_address": "5100 South Blvd suite c, Charlotte, NC 28217, USA",
      "poi_short_description": "Casual Vietnamese eatery serving banh mi sandwiches & noodle bowls, plus various teas & smoothies.",
      "poi_long_description": "Casual Vietnamese eatery serving banh mi sandwiches & noodle bowls, plus various teas & smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-c179-7647-a636-7503baf04441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c179-7647-a636-7503baf04441",
        "storage_key": "property/6767906449166947/019d02d3-c179-7647-a636-7503baf04441.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.crispybanhmi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18309722383373920508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crispy-banh-mi",
      "poi_latitude": "35.1680625",
      "poi_longitude": "-80.8764806",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 980-859-1580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxhjX92eVogR_GgFpX8zGf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_ef0aa7be-213f-43b9-8097-fdb67e6f10b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Jasmine Grill",
      "poi_type": "Restaurants",
      "poi_address": "5033 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Cozy, casual chain eatery that serves up kabobs, shawarma and other Mediterranean favorites alongside some Middle Eastern dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-a864-7351-afc1-ee75a287288f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-a864-7351-afc1-ee75a287288f",
        "storage_key": "property/6767906449166947/019d02d8-a864-7351-afc1-ee75a287288f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://jasminegrillcharlotte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17071741482474366030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jasmine-grill",
      "poi_latitude": "35.1685269",
      "poi_longitude": "-80.8749529",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 980-207-1859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_mdzd-fVogRTmQvqG0C6-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_20bf0671-3913-405e-94a2-3ecf4e4e606d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Morazan Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5421 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Casual spot offering classic Salvadoran, Honduran & Mexican fare from morning to night, plus a bar.",
      "poi_long_description": "Casual spot offering classic Salvadoran, Honduran & Mexican fare from morning to night, plus a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-b85f-7573-ab04-4d06bb52d919.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b85f-7573-ab04-4d06bb52d919",
        "storage_key": "property/6767906449166947/019d02d3-b85f-7573-ab04-4d06bb52d919.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "http://morazanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4667345559610153555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morazan-restaurant",
      "poi_latitude": "35.160748",
      "poi_longitude": "-80.875748",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-525-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1hNX5-eVogRU1qPzA6-xUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d36ce628-d4f6-40fa-aeb8-4a1e307a4a95",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "500 Degrees New York Style Pizzeria - South Blvd.",
      "poi_type": "Restaurants",
      "poi_address": "6037 South Blvd Suite A, Charlotte, NC 28217, USA",
      "poi_short_description": "Compact, pared-down place whipping up thin-crust pizzas, salads, wings & other familiar eats.",
      "poi_long_description": "Compact, pared-down place whipping up thin-crust pizzas, salads, wings & other familiar eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-aab2-71ff-bcc8-698baa65bebe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-aab2-71ff-bcc8-698baa65bebe",
        "storage_key": "property/6767906449166947/019d02d8-aab2-71ff-bcc8-698baa65bebe.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://500degreespizzeriamenu.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9555471511630866645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "500-degrees-new-york-style-pizzeria---south-blvd",
      "poi_latitude": "35.1533589",
      "poi_longitude": "-80.8755541",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-554-6601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH3DIgJWeVogR1WgfeLbam4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_435ee77f-384e-4d3d-a138-e7ae0d4cc0c4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Doan's Vietnamese Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "5937 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Cozy, family-owned hub in a strip mall with Southern Vietnamese-style pho & other Asian fusion eats.",
      "poi_long_description": "Cozy, family-owned hub in a strip mall with Southern Vietnamese-style pho & other Asian fusion eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ab6e-70d1-b4c1-de2f0b966f45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-ab6e-70d1-b4c1-de2f0b966f45",
        "storage_key": "property/6767906449166947/019d02d8-ab6e-70d1-b4c1-de2f0b966f45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1711114681369890343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doans-vietnamese-cuisine",
      "poi_latitude": "35.1546898",
      "poi_longitude": "-80.8751678",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-733-9077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDyuyapWeVogRJw4CobwZvxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_bf2492b3-f0f9-41a1-a72c-1ed9c2459a43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Saigon Palace Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5215 South Blvd b, Charlotte, NC 28217, USA",
      "poi_short_description": "Simple Vietnamese place with classic fare, bubble teas, lunch specials, Sunday buffet & leafy decor.",
      "poi_long_description": "Simple Vietnamese place with classic fare, bubble teas, lunch specials, Sunday buffet & leafy decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-b8f7-759d-a414-3f6c2123c7cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b8f7-759d-a414-3f6c2123c7cd",
        "storage_key": "property/6767906449166947/019d02d3-b8f7-759d-a414-3f6c2123c7cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://saigonpalacecharlotte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=367602149112603962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saigon-palace-restaurant",
      "poi_latitude": "35.1657948",
      "poi_longitude": "-80.875193",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-529-0098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZRZXbeieVogROuWG_DT8GQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_0f4a3989-8b6c-4564-bb25-10fb1971c118",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "American Deli",
      "poi_type": "Restaurants",
      "poi_address": "5401 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Informal counter-serve chain offering hot wings, cheesesteaks & other comfort foods.",
      "poi_long_description": "Informal counter-serve chain offering hot wings, cheesesteaks & other comfort foods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ad06-709a-b3da-5c1d417d6740.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-ad06-709a-b3da-5c1d417d6740",
        "storage_key": "property/6767906449166947/019d02d8-ad06-709a-b3da-5c1d417d6740.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://americandeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16992269152781861592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-deli",
      "poi_latitude": "35.1620849",
      "poi_longitude": "-80.875151",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-951-7878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnd7-6umeVogR2AJk-8Oq0Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0bc6e8b9-b3d3-4ca6-99d3-a17e9c218946",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Suárez Bakery",
      "poi_type": "Restaurants",
      "poi_address": "4245 Park Rd, Charlotte, NC 28209, USA",
      "poi_short_description": "Bakery specializing in donuts, pastries & desserts, plus custom cakes & Cuban bread on Saturdays.",
      "poi_long_description": "Bakery specializing in donuts, pastries & desserts, plus custom cakes & Cuban bread on Saturdays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ad66-7327-8d9d-010b921a3f3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-ad66-7327-8d9d-010b921a3f3a",
        "storage_key": "property/6767906449166947/019d02d8-ad66-7327-8d9d-010b921a3f3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.suarezbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12377196471898857475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "surez-bakery",
      "poi_latitude": "35.174042",
      "poi_longitude": "-80.8480739",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-525-0145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-epmXVOeVogRA-C_Lp2ixKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_d8a5cd64-2906-4159-8bcd-131cae6754fb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Beef 'N Bottle Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4538 South Blvd, Charlotte, NC 28209, USA",
      "poi_short_description": "This traditional steakhouse serves high-end steaks & seafood in a candlelit, wood-paneled setting.",
      "poi_long_description": "This traditional steakhouse serves high-end steaks & seafood in a candlelit, wood-paneled setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ae39-702b-8862-40a62ab5ca3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-ae39-702b-8862-40a62ab5ca3a",
        "storage_key": "property/6767906449166947/019d02d8-ae39-702b-8862-40a62ab5ca3a.webp",
        "width": 950,
        "height": 350
      },
      "poi_business_url": "https://beefandbottle.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17731531691228494201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beef-n-bottle-steakhouse",
      "poi_latitude": "35.179301",
      "poi_longitude": "-80.87608900000001",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-523-9977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwNnjB-fVogReXlBoyAOE_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_2d99d628-33a4-4875-bfdb-1af3632a94b3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Bird Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "510 E 15th St Ste A, Charlotte, NC 28206, USA",
      "poi_short_description": "Snug pizza spot with limited space specializing in New Haven-style pies with thin crusts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-af5a-735d-96ee-5c9608efcb94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-af5a-735d-96ee-5c9608efcb94",
        "storage_key": "property/6767906449166947/019d02d8-af5a-735d-96ee-5c9608efcb94.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.birdpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8477957287776978611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bird-pizzeria",
      "poi_latitude": "35.2328263",
      "poi_longitude": "-80.82559789999999",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5541-767e-a058-df7d8d42c054",
        "storage_key": "property/6767906449166947/019d02d4-5541-767e-a058-df7d8d42c054.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45uVq9ShVogRs4bhLjzBp3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_7316d4a8-1d15-4ea6-8b70-79c13e3e3eb3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "421 Tyvola Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "Handy store with gas pumps for cars, plus snacks and a car wash.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-b126-749d-85be-5aea54428960.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-b126-749d-85be-5aea54428960",
        "storage_key": "property/6767906449166947/019d02d8-b126-749d-85be-5aea54428960.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/charlotte/421-tyvola-rd/2723928?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4087239540113763620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "35.1637129",
      "poi_longitude": "-80.8868432",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-523-5379",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ea3d-715a-90d1-22e939b2e188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d8-ea3d-715a-90d1-22e939b2e188",
        "storage_key": "property/6767906449166947/019d02d8-ea3d-715a-90d1-22e939b2e188.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJZ8LyksWeVogRJG1p5LTKuDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_0132fc4a-df40-41fd-8912-be1e01c84219",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "127 E Woodlawn Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-b15c-7698-8727-3defe6a2c44d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-b15c-7698-8727-3defe6a2c44d",
        "storage_key": "property/6767906449166947/019d02d8-b15c-7698-8727-3defe6a2c44d.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/nc/charlotte/127-e-woodlawn-rd?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ0ODktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11272866752122524172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "35.1792609",
      "poi_longitude": "-80.8820466",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-525-1008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ea6d-7134-b34e-3b3a12870089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d8-ea6d-7134-b34e-3b3a12870089",
        "storage_key": "property/6767906449166947/019d02d8-ea6d-7134-b34e-3b3a12870089.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJv9zLtCCfVogRDBKTuJVEcZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_f6cd99b3-0ef7-4e53-b3f8-834ab5c40483",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "5615 S Tryon St, Charlotte, NC 28217, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-b239-77c9-a59e-e995da2bc7c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-b239-77c9-a59e-e995da2bc7c0",
        "storage_key": "property/6767906449166947/019d02d8-b239-77c9-a59e-e995da2bc7c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/nc/charlotte/5615-s-tryon-st-38626?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7349241290552191377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "35.1701277",
      "poi_longitude": "-80.90316609999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-620-1243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ea3d-715a-90d1-22e939b2e188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d8-ea3d-715a-90d1-22e939b2e188",
        "storage_key": "property/6767906449166947/019d02d8-ea3d-715a-90d1-22e939b2e188.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJfew4UBeZVogRkSn_CwTA_WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_57aa69fe-90e7-4461-8cf7-780454b47df2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "La Centroamericana",
      "poi_type": "Shopping & Retail",
      "poi_address": "5721 South Blvd C, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-b409-71c4-b274-1d842f6d01cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-b409-71c4-b274-1d842f6d01cd",
        "storage_key": "property/6767906449166947/019d02d8-b409-71c4-b274-1d842f6d01cd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3134250851517432150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-centroamericana",
      "poi_latitude": "35.157618",
      "poi_longitude": "-80.875715",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-557-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf6-746a-a335-2b7912816d8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf6-746a-a335-2b7912816d8e",
        "storage_key": "property/6767906449166947/019d02d4-5cf6-746a-a335-2b7912816d8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYR9meqeVogRVoGpIYsYfys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c86bb5fc-25ac-46ac-bd48-db6dbf4bbae7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Supermercado El Rey",
      "poi_type": "Shopping & Retail",
      "poi_address": "6300 South Blvd #200c, Charlotte, NC 28217, USA",
      "poi_short_description": "Supermarket selling meats, produce, and Latin groceries alongside a taqueria in the rear.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-b536-73e0-ac2c-4f2312c49c39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-b536-73e0-ac2c-4f2312c49c39",
        "storage_key": "property/6767906449166947/019d02d8-b536-73e0-ac2c-4f2312c49c39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.elreymarket.com",
      "poi_directions_map_url": "https://maps.google.com/?cid=14086406552415765550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "supermercado-el-rey",
      "poi_latitude": "35.1495829",
      "poi_longitude": "-80.87734189999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-557-3980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf6-746a-a335-2b7912816d8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf6-746a-a335-2b7912816d8e",
        "storage_key": "property/6767906449166947/019d02d4-5cf6-746a-a335-2b7912816d8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI5Tp7b2eVogRLgR6XiD4fMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_887372a0-b1d4-4b1c-83ae-1f91e6ed4119",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "5831 South Blvd, Charlotte, NC 28210, USA",
      "poi_short_description": "Store featuring a deli, plus a produce section and a selection of beer and wine for sale.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-b5b1-70b6-9c77-11c008e204e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-b5b1-70b6-9c77-11c008e204e1",
        "storage_key": "property/6767906449166947/019d02d8-b5b1-70b6-9c77-11c008e204e1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.foodlion.com/nc/charlotte/5831-south-blvd?y_source=1_NTA0NjY1MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4322451753055595917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.155815",
      "poi_longitude": "-80.8750069",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-554-1748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf6-746a-a335-2b7912816d8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf6-746a-a335-2b7912816d8e",
        "storage_key": "property/6767906449166947/019d02d4-5cf6-746a-a335-2b7912816d8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtYU1NZWeVogRja2k0_du_Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_82a0e59c-7715-4712-b787-c65b0d9ee8f0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "9531 South Blvd, Charlotte, NC 28273, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-b673-7128-9f23-ab7478898eb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-b673-7128-9f23-ab7478898eb5",
        "storage_key": "property/6767906449166947/019d02d8-b673-7128-9f23-ab7478898eb5.webp",
        "width": 949,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/pineville/762",
      "poi_directions_map_url": "https://maps.google.com/?cid=1966273768867638052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.1082257",
      "poi_longitude": "-80.8787684",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-556-7082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf2-72b2-983d-504cc09960e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf2-72b2-983d-504cc09960e2",
        "storage_key": "property/6767906449166947/019d02d4-5cf2-72b2-983d-504cc09960e2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv1TI5GucVogRJCuGNJObSRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4fdb3726-7752-42a2-816f-fdbc1fbb0b8e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "6217 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-b867-775b-8ff4-12d26d54bc36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-b867-775b-8ff4-12d26d54bc36",
        "storage_key": "property/6767906449166947/019d02d8-b867-775b-8ff4-12d26d54bc36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/nc/charlotte/3851",
      "poi_directions_map_url": "https://maps.google.com/?cid=3908077527355582091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.1511991",
      "poi_longitude": "-80.8753318",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-288-7071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf2-72b2-983d-504cc09960e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf2-72b2-983d-504cc09960e2",
        "storage_key": "property/6767906449166947/019d02d4-5cf2-72b2-983d-504cc09960e2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHch3-ZWeVogRi2a3JM5HPDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_5b18eb98-ba44-4d8d-ae99-c41a6a40abec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "South Academy of International Languages",
      "poi_type": "Education",
      "poi_address": "8300 Nations Ford Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ba0a-774b-b2e2-43f1799f5756.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-ba0a-774b-b2e2-43f1799f5756",
        "storage_key": "property/6767906449166947/019d02d8-ba0a-774b-b2e2-43f1799f5756.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=918943510344833153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-academy-of-international-languages",
      "poi_latitude": "35.1404687",
      "poi_longitude": "-80.8950644",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-343-5815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ51Tn4EqZVogRgRjB_kC-wAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1dfa4933-edfa-495d-add9-b7a0d4e3e1e3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Metrolina Regional Scholars Academy",
      "poi_type": "Education",
      "poi_address": "5225 77 Center Dr, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-bab5-77ff-8704-35e0e5d4f657.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-bab5-77ff-8704-35e0e5d4f657",
        "storage_key": "property/6767906449166947/019d02d8-bab5-77ff-8704-35e0e5d4f657.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.scholarsacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13752208973426992636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metrolina-regional-scholars-academy",
      "poi_latitude": "35.1686165",
      "poi_longitude": "-80.8859597",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 704-503-1112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0XQ1wdqeVogR_CUO8jKp2b4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0d88e593-a58c-4dcc-a9f3-c2f08ad75d97",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Reid Park Academy",
      "poi_type": "Education",
      "poi_address": "4108 W Tyvola Rd, Charlotte, NC 28208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/reidparkES",
      "poi_directions_map_url": "https://maps.google.com/?cid=6678354170166522811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reid-park-academy",
      "poi_latitude": "35.204946",
      "poi_longitude": "-80.90523",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-343-5035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcXYpjLaYVogRuzMG_btHrlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1e454737-1085-4030-baba-7bb344369e7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Collinswood Language Academy",
      "poi_type": "Education",
      "poi_address": "5621 Flagstaff Dr, Charlotte, NC 28210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-bc6b-75a8-b375-f714fe196021.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-bc6b-75a8-b375-f714fe196021",
        "storage_key": "property/6767906449166947/019d02d8-bc6b-75a8-b375-f714fe196021.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://www.cmsk12.org/collinswoodMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=9500953928220775382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collinswood-language-academy",
      "poi_latitude": "35.1609662",
      "poi_longitude": "-80.8712102",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 980-343-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwUa_ZBmfVogR1pPzbkIr2oM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_433c5c76-3e1b-44ea-b5fe-37eade2e8e22",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "The John Crosland School",
      "poi_type": "Education",
      "poi_address": "5146 Parkway Plaza Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-bdb2-753b-a0a9-ea7f5f46d3c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-bdb2-753b-a0a9-ea7f5f46d3c0",
        "storage_key": "property/6767906449166947/019d02d8-bdb2-753b-a0a9-ea7f5f46d3c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.johncroslandschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11277064280411617961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-john-crosland-school",
      "poi_latitude": "35.179994",
      "poi_longitude": "-80.904944",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-365-5490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm6cuEtCfVogRqTou7zYugJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d7998b3a-55ba-4425-9296-f16b3df352fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "St Mark's Child Development Center",
      "poi_type": "Education",
      "poi_address": "917 Clanton Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-be2d-768d-b491-aa641d0c5815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-be2d-768d-b491-aa641d0c5815",
        "storage_key": "property/6767906449166947/019d02d8-be2d-768d-b491-aa641d0c5815.webp",
        "width": 432,
        "height": 288
      },
      "poi_business_url": "http://www.stmarksclt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16675663087583055174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-marks-child-development-center",
      "poi_latitude": "35.1987599",
      "poi_longitude": "-80.88789899999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-527-5433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3_ByijefVogRRk17CTrba-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_e5f77f58-64a5-4440-9342-42ab7f832969",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Central Piedmont Community College - Harper Campus",
      "poi_type": "Education",
      "poi_address": "315 W Hebron St building 4 room 300, Charlotte, NC 28273, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-bf2a-76b2-9fa2-ced2562966f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-bf2a-76b2-9fa2-ced2562966f3",
        "storage_key": "property/6767906449166947/019d02d8-bf2a-76b2-9fa2-ced2562966f3.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.cpcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12052302092538839268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-piedmont-community-college---harper-campus",
      "poi_latitude": "35.1295823",
      "poi_longitude": "-80.8956019",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-330-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsQEw1wacVogR5IB5t-VgQqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_08bc4410-0d13-40f8-9d17-d93c678d5175",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Queens University of Charlotte",
      "poi_type": "Education",
      "poi_address": "1900 Selwyn Ave, Charlotte, NC 28274, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-b5d5-77c8-aef5-e8af238dc0a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-b5d5-77c8-aef5-e8af238dc0a5",
        "storage_key": "property/6767906449166947/019d02d4-b5d5-77c8-aef5-e8af238dc0a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.queens.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7142315374379760541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "queens-university-of-charlotte",
      "poi_latitude": "35.188626",
      "poi_longitude": "-80.83297240000002",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-337-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuWwm87ifVogRnXu3y_2ZHmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_801a3c6b-048f-4b35-a48e-a12712be4f92",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Dogwood Lane Children’s Academy",
      "poi_type": "Education",
      "poi_address": "1551 Arrowpoint Ln, Charlotte, NC 28273, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-c16b-7454-93e4-7124a2d8a4fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-c16b-7454-93e4-7124a2d8a4fc",
        "storage_key": "property/6767906449166947/019d02d8-c16b-7454-93e4-7124a2d8a4fc.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://dogwoodlaneca.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6895816125114066963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dogwood-lane-childrens-academy",
      "poi_latitude": "35.1386489",
      "poi_longitude": "-80.9210762",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-282-0505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ2fUa2iZVogRE6jV7Trcsl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_64fc6380-7d93-4b91-8615-535494dafd4e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "AMC Carolina Pavilion 22",
      "poi_type": "Entertainment",
      "poi_address": "9541 South Blvd, Charlotte, NC 28273, USA",
      "poi_short_description": "Multiplex offering reclining armchairs, on-screen ads and stadium seating, as well as snacks and a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-0b89-7744-b9c0-bd789f1c9754.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0b89-7744-b9c0-bd789f1c9754",
        "storage_key": "property/6767906449166947/019d02d4-0b89-7744-b9c0-bd789f1c9754.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-carolina-pavilion-22?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13797956241145416126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-carolina-pavilion-22",
      "poi_latitude": "35.10838330000001",
      "poi_longitude": "-80.8745206",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-643-1507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63cc-75b6-9deb-b736730e46a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63cc-75b6-9deb-b736730e46a4",
        "storage_key": "property/6767906449166947/019d02d4-63cc-75b6-9deb-b736730e46a4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJVx1c42ucVogRvknbuxgwfL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0f0ecec6-f869-4ec3-aef2-1db8bce8cf6b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Ayrsley Grand Cinema",
      "poi_type": "Entertainment",
      "poi_address": "9110 Kings Parade Blvd, Charlotte, NC 28273, USA",
      "poi_short_description": "New releases from Hollywood in an independent movie theater, with a school program & venue rentals.",
      "poi_long_description": "New releases from Hollywood in an independent movie theater, with a school program & venue rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-c262-70d8-aaaf-e048aeb7de19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-c262-70d8-aaaf-e048aeb7de19",
        "storage_key": "property/6767906449166947/019d02d8-c262-70d8-aaaf-e048aeb7de19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ayrsleycinemas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2246405643920285797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ayrsley-grand-cinema",
      "poi_latitude": "35.1391667",
      "poi_longitude": "-80.9322222",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-297-7540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63cc-75b6-9deb-b736730e46a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63cc-75b6-9deb-b736730e46a4",
        "storage_key": "property/6767906449166947/019d02d4-63cc-75b6-9deb-b736730e46a4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40REUH2ZVogRZSBN-wfWLB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_45d869ff-7fed-4541-afc1-85f3b00017cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Regal Stonecrest at Piper Glen",
      "poi_type": "Entertainment",
      "poi_address": "7824 Rea Rd, Charlotte, NC 28277, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-c354-724b-8203-19de8c9a801c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-c354-724b-8203-19de8c9a801c",
        "storage_key": "property/6767906449166947/019d02d8-c354-724b-8203-19de8c9a801c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-stonecrest-piper-glen-0384?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12763181794764316193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-stonecrest-at-piper-glen",
      "poi_latitude": "35.06248000000001",
      "poi_longitude": "-80.81882999999999",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63cc-75b6-9deb-b736730e46a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63cc-75b6-9deb-b736730e46a4",
        "storage_key": "property/6767906449166947/019d02d4-63cc-75b6-9deb-b736730e46a4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUOsr12dVogRId6oWDjuH7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_21b307f3-0ebf-4bf8-8766-58eb03870821",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "U.S. National Whitewater Center",
      "poi_type": "Entertainment",
      "poi_address": "5000 Whitewater Center Pkwy, Charlotte, NC 28214, USA",
      "poi_short_description": "Recreation grounds with whitewater rafting, canoeing, kayaking, rappelling, rock climbing & more.",
      "poi_long_description": "Recreation grounds with whitewater rafting, canoeing, kayaking, rappelling, rock climbing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-fed7-74d5-88d2-7da781928dd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-fed7-74d5-88d2-7da781928dd0",
        "storage_key": "property/6767906449166947/019d02d3-fed7-74d5-88d2-7da781928dd0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.whitewater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500212967885119010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-national-whitewater-center",
      "poi_latitude": "35.2712966",
      "poi_longitude": "-81.00554029999999",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-391-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvd734yC9VogRIh4ieMP2mJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3d1a21ea-69ff-4e1e-a66f-7e012f98eb88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Carowinds",
      "poi_type": "Entertainment",
      "poi_address": "North Carolina, USA",
      "poi_short_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_long_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-0609-7309-acbe-8d276deaebb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0609-7309-acbe-8d276deaebb9",
        "storage_key": "property/6767906449166947/019d02d4-0609-7309-acbe-8d276deaebb9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carowinds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638331865982573054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carowinds",
      "poi_latitude": "35.1024013",
      "poi_longitude": "-80.9412735",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-588-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVWj3q-PVogR_hngLo7zfTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_99a1feb9-8f71-4455-8fbd-159f842a8104",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Discovery Place Science",
      "poi_type": "Entertainment",
      "poi_address": "168 W 6th St, Charlotte, NC 28202, USA",
      "poi_short_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_long_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-f837-7338-bc1c-b1d3b35096a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f837-7338-bc1c-b1d3b35096a0",
        "storage_key": "property/6767906449166947/019d02d3-f837-7338-bc1c-b1d3b35096a0.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://discoveryplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672994214166199027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-place-science",
      "poi_latitude": "35.229441",
      "poi_longitude": "-80.8409271",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-327-2189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5d0c-7062-8590-326d5bec5bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5d0c-7062-8590-326d5bec5bb0",
        "storage_key": "property/6767906449166947/019d02d4-5d0c-7062-8590-326d5bec5bb0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-LB1SSgVogR8_pkSkmqXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fbc61c77-30be-4ad1-bf20-a24d5a9b6f18",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Mint Museum Randolph",
      "poi_type": "Entertainment",
      "poi_address": "2730 Randolph Rd, Charlotte, NC 28207, USA",
      "poi_short_description": "Museum showcasing international art, plus live performances & educational programs for all ages.",
      "poi_long_description": "Museum showcasing international art, plus live performances & educational programs for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-f619-75e9-840f-2a7e1939215e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f619-75e9-840f-2a7e1939215e",
        "storage_key": "property/6767906449166947/019d02d3-f619-75e9-840f-2a7e1939215e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mintmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4712489646665483953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mint-museum-randolph",
      "poi_latitude": "35.1974615",
      "poi_longitude": "-80.8143212",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5d0c-7062-8590-326d5bec5bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5d0c-7062-8590-326d5bec5bb0",
        "storage_key": "property/6767906449166947/019d02d4-5d0c-7062-8590-326d5bec5bb0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbGWF-GfVogRscYzpV0gZkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_54db8d2b-e1b9-46c4-8c76-644223299d45",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Ray’s Splash Planet",
      "poi_type": "Entertainment",
      "poi_address": "215 N Sycamore St, Charlotte, NC 28202, USA",
      "poi_short_description": "Indoor water park featuring a lazy river, slides and a whirlpool, plus a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-c6dd-73de-ad8a-d4b111d76e7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-c6dd-73de-ad8a-d4b111d76e7a",
        "storage_key": "property/6767906449166947/019d02d8-c6dd-73de-ad8a-d4b111d76e7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Pools-Beaches-Spraygrounds/rays-splash-planet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13894266709005570455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rays-splash-planet",
      "poi_latitude": "35.2381165",
      "poi_longitude": "-80.8513028",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-314-4729",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr30fWgmhVogRlxHQ9PRZ0sA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_0a8e44bc-2039-4dc6-b007-9f1e96817d76",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Neighborhood Theatre",
      "poi_type": "Entertainment",
      "poi_address": "511 E 36th St, Charlotte, NC 28205, USA",
      "poi_short_description": "Live music venue hosting acts in a variety of genres & DJ-driven parties, with VIP seating & bar.",
      "poi_long_description": "Live music venue hosting acts in a variety of genres & DJ-driven parties, with VIP seating & bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-c6d2-73e4-b61e-d4433144689f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-c6d2-73e4-b61e-d4433144689f",
        "storage_key": "property/6767906449166947/019d02d8-c6d2-73e4-b61e-d4433144689f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.neighborhoodtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12242965911959922312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neighborhood-theatre",
      "poi_latitude": "35.24740930000001",
      "poi_longitude": "-80.8040699",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-942-7997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl94FGdofVIgRiGaWg6HA56k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_3857b270-1ab7-4739-a5d5-63e756437173",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Amos' Southend",
      "poi_type": "Entertainment",
      "poi_address": "1423 S Tryon St, Charlotte, NC 28203, USA",
      "poi_short_description": "Low-key music venue showcasing various genres from metal to pop, including cover & tribute bands.",
      "poi_long_description": "Low-key music venue showcasing various genres from metal to pop, including cover & tribute bands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-c7c6-729b-be04-14e65f45703f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-c7c6-729b-be04-14e65f45703f",
        "storage_key": "property/6767906449166947/019d02d8-c7c6-729b-be04-14e65f45703f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.amossouthend.com/?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16922833730016014348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amos-southend",
      "poi_latitude": "35.2167636",
      "poi_longitude": "-80.8552081",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-595-7585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy1-Tdn-fVogRDHCazp372eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_01f3caa6-103b-44e0-b035-7bd3bd3a75cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "AFC Urgent Care SW Charlotte",
      "poi_type": "Health and Wellness",
      "poi_address": "440 Tyvola Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-10d0-748e-ad40-c610a2893fc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-10d0-748e-ad40-c610a2893fc5",
        "storage_key": "property/6767906449166947/019d02d4-10d0-748e-ad40-c610a2893fc5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.afcurgentcare.com/sw-charlotte-nc/patient-services/walk-in-urgent-care-sw-charlotte-nc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5559303861317035366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-sw-charlotte",
      "poi_latitude": "35.16299420000001",
      "poi_longitude": "-80.8864423",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-228-1784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRQX0hVWfVogRZmVCTGidJk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_3219f15f-93eb-406e-befe-52af332539bb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "306 E Woodlawn Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-d76b-7298-b354-b9fa0a7e0fbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d76b-7298-b354-b9fa0a7e0fbe",
        "storage_key": "property/6767906449166947/019d02d3-d76b-7298-b354-b9fa0a7e0fbe.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/306-east-woodlawn-rd-charlotte-nc-28217/storeid=3526?WT.mc_id=LS_GOOGLE_RX_3526",
      "poi_directions_map_url": "https://maps.google.com/?cid=15293837258605279264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.176839",
      "poi_longitude": "-80.87837929999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-525-7291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5548-70bd-bfd5-6d056dda78e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5548-70bd-bfd5-6d056dda78e7",
        "storage_key": "property/6767906449166947/019d02d4-5548-70bd-bfd5-6d056dda78e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_PPlt-eVogRIDjN2_SfPtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3973e384-6ab6-4118-8347-1f5d98aa7f43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4701 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-d072-705b-b0b5-653f63581326.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d072-705b-b0b5-653f63581326",
        "storage_key": "property/6767906449166947/019d02d3-d072-705b-b0b5-653f63581326.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4701+south+blvd-charlotte-nc-28217/id=5761",
      "poi_directions_map_url": "https://maps.google.com/?cid=5266979944245267301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.17577929999999",
      "poi_longitude": "-80.8752322",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-523-3227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQVPaOCeVogRZYvYh1oSGEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_bbec5f2c-48ee-4f0f-81cd-6cb1590fb68a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Costco Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "500 Tyvola Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-13ff-713d-8642-95904aa6836e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-13ff-713d-8642-95904aa6836e",
        "storage_key": "property/6767906449166947/019d02d4-13ff-713d-8642-95904aa6836e.webp",
        "width": 1080,
        "height": 1021
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/charlotte-NC-359.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17699676192915215590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-pharmacy",
      "poi_latitude": "35.1609979",
      "poi_longitude": "-80.88449969999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-501-2402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5548-70bd-bfd5-6d056dda78e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5548-70bd-bfd5-6d056dda78e7",
        "storage_key": "property/6767906449166947/019d02d4-5548-70bd-bfd5-6d056dda78e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDa3Th8aeVogR5lQmdrjhofU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3ddecfe2-dcc5-47de-b3c6-9ff88bcf7602",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6025 South Blvd, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-cae9-74ec-a75c-c865edbf0793.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-cae9-74ec-a75c-c865edbf0793",
        "storage_key": "property/6767906449166947/019d02d8-cae9-74ec-a75c-c865edbf0793.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/charlotte-south-blvd-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=14648321995413862659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.1539525",
      "poi_longitude": "-80.8751841",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-965-3852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRUpBa5WeVogRAzkvpD5LScs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_58727761-1240-4710-9b06-646930c30c96",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2317 South Blvd, Charlotte, NC 28203, USA",
      "poi_short_description": "Chain fitness studio offering a full-body workout combining cardio and strength training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-cc92-769f-ba53-4d7c4cf98e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-cc92-769f-ba53-4d7c4cf98e34",
        "storage_key": "property/6767906449166947/019d02d8-cc92-769f-ba53-4d7c4cf98e34.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/charlotte-north-carolina-0289?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=4975221365238224244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.2049055",
      "poi_longitude": "-80.8628552",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-626-7322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwyQd3GfVogRdFX1yXiJC0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_80bea413-afa0-4993-b134-3cec78ea3784",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Sweat Method",
      "poi_type": "Health and Wellness",
      "poi_address": "3700 South Blvd Suite 125, Charlotte, NC 28209, USA",
      "poi_short_description": "Fitness center offering 30-minute strength, circuit, and interval training workouts, plus yoga.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ccb7-767b-8521-b163f8a5fa7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-ccb7-767b-8521-b163f8a5fa7c",
        "storage_key": "property/6767906449166947/019d02d8-ccb7-767b-8521-b163f8a5fa7c.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.sweatmethod.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18377658465054556951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweat-method",
      "poi_latitude": "35.1917644",
      "poi_longitude": "-80.87512129999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-335-1136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSAqrH-fVogRFwMHRQGPCv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_4412c218-9c52-45fc-a3af-d0718315ee77",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "CORE 704 - South End",
      "poi_type": "Health and Wellness",
      "poi_address": "2729 South Blvd Suite B, Charlotte, NC 28209, USA",
      "poi_short_description": "Fitness studio offering group classes utilizing a reformer machine for strength and toning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-cce4-77d3-a62d-1a0026432667.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-cce4-77d3-a62d-1a0026432667",
        "storage_key": "property/6767906449166947/019d02d8-cce4-77d3-a62d-1a0026432667.webp",
        "width": 1280,
        "height": 614
      },
      "poi_business_url": "http://www.core704.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1507421188051256258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "core-704---south-end",
      "poi_latitude": "35.2000703",
      "poi_longitude": "-80.8664785",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-726-8299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM57RYV2fVogRwkOxeJVv6xQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ba38b825-3a6a-4dd3-9710-025a242705ed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "CorePower Yoga - Park Road",
      "poi_type": "Health and Wellness",
      "poi_address": "540 Brandywine Rd Suite #420, Charlotte, NC 28209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-d017-7414-a99e-5ca912729b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-d017-7414-a99e-5ca912729b68",
        "storage_key": "property/6767906449166947/019d02d8-d017-7414-a99e-5ca912729b68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/nc/charlotte/park-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=18391714304133432555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---park-road",
      "poi_latitude": "35.1748525",
      "poi_longitude": "-80.8475222",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpc34PIufVogR6wRYVLd-PP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_482a8496-c6de-42cc-99ad-048656a9b756",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Little Sugar Creek Greenway: Tyvola Road to Huntingtowne Farm Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2524 Tyvola Rd, Charlotte, NC 28210, USA",
      "poi_short_description": "Kid-friendly, 7-mile, paved trail system along Little Sugar Creek, for walkers, cyclists and runners, with parking areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-2400-727b-872b-3a49853c751b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-2400-727b-872b-3a49853c751b",
        "storage_key": "property/6767906449166947/019d02d4-2400-727b-872b-3a49853c751b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carolinathreadtrailmap.org/trails/trail/little-sugar-creek-greenway-huntingtowne-farme-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15738483044589189617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-sugar-creek-greenway-tyvola-road-to-huntingtowne-farm-park",
      "poi_latitude": "35.1577799",
      "poi_longitude": "-80.8567515",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ18qgBbmfVogR8Tk_aPFSato",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6442b06-1e5f-4cea-8efe-9fda6a6a3ef3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Marion Diehl Recreation Center and Pool",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2219 Tyvola Rd, Charlotte, NC 28210, USA",
      "poi_short_description": "Year-round facility with wading & lap pools (with swimming lessons & teams), a gym & a playground.",
      "poi_long_description": "Year-round facility with wading & lap pools (with swimming lessons & teams), a gym & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-d0e7-72eb-88bd-1d2aa59b63fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-d0e7-72eb-88bd-1d2aa59b63fb",
        "storage_key": "property/6767906449166947/019d02d8-d0e7-72eb-88bd-1d2aa59b63fb.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/places-to-visit/rec-centers/marion-diehl-recreation-center-and-indoor-pool",
      "poi_directions_map_url": "https://maps.google.com/?cid=8356358109010783998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marion-diehl-recreation-center-and-pool",
      "poi_latitude": "35.160511",
      "poi_longitude": "-80.8576202",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-314-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkWxRsB2fVogR_u6KH22_93M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_0653ad1f-14ec-4f9d-aa5a-f83f002c4043",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Huntingtowne Farms Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2200 Ramblewood Ln, Charlotte, NC 28210, USA",
      "poi_short_description": "Public 23-acre park offering outdoor sports & recreation areas, tennis courts & a community garden.",
      "poi_long_description": "Public 23-acre park offering outdoor sports & recreation areas, tennis courts & a community garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-d14a-722a-b4dc-deb8ded04bc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-d14a-722a-b4dc-deb8ded04bc7",
        "storage_key": "property/6767906449166947/019d02d8-d14a-722a-b4dc-deb8ded04bc7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Parks/ParksByRegion/SouthRegion/Pages/Huntingtowne%20Farms.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10943115462445973739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huntingtowne-farms-park",
      "poi_latitude": "35.1275199",
      "poi_longitude": "-80.86334599999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-643-5725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwUaGSicVogR60Ats4jB3Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cfe4cb49-033a-4295-a70e-f6b65fd097f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Park Road Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6220 Park Rd, Charlotte, NC 28210, USA",
      "poi_short_description": "This recreational park provides basketball & tennis courts, baseball fields, a playground & paths.",
      "poi_long_description": "This recreational park provides basketball & tennis courts, baseball fields, a playground & paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-244f-713c-bb02-dba5c76ef67a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-244f-713c-bb02-dba5c76ef67a",
        "storage_key": "property/6767906449166947/019d02d4-244f-713c-bb02-dba5c76ef67a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/current-projects/facility-projects/park-road-park-pavilion",
      "poi_directions_map_url": "https://maps.google.com/?cid=10214930837132081889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-road-park",
      "poi_latitude": "35.1494037",
      "poi_longitude": "-80.8523208",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-314-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ1j07SifVogR4fpwsHm5wo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f0d1fe9c-cfca-4dd4-b633-d8374f0c4d88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Renaissance Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1536 W Tyvola Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "Outdoor space with bike trails & golf course, as well as facilities for tennis, soccer & volleyball.",
      "poi_long_description": "Outdoor space with bike trails & golf course, as well as facilities for tennis, soccer & volleyball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-d445-75a2-b877-2ece3cfa4c4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-d445-75a2-b877-2ece3cfa4c4a",
        "storage_key": "property/6767906449166947/019d02d8-d445-75a2-b877-2ece3cfa4c4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/current-projects/park-projects/renaissance-park-improvements",
      "poi_directions_map_url": "https://maps.google.com/?cid=5521768477332270947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renaissance-park",
      "poi_latitude": "35.1767526",
      "poi_longitude": "-80.9067544",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-314-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-KSICiZVogRY-9WryxDoUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7a96a0bc-e8da-4c00-b251-d4e0cfef5626",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "CLT Airport overlook",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5130 Airport Overlook Dr, Charlotte, NC 28208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-d48b-754f-b409-948a6bdf8f06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-d48b-754f-b409-948a6bdf8f06",
        "storage_key": "property/6767906449166947/019d02d8-d48b-754f-b409-948a6bdf8f06.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.cltairport.com/community/airport-overlook/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2571206169912590436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clt-airport-overlook",
      "poi_latitude": "35.2252055",
      "poi_longitude": "-80.9619799",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTS-eQCZVogRZMDugWPCriM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4bbcd84f-6d4e-42df-8078-2ae57ad39718",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "McAlpine Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8711 Monroe Rd, Charlotte, NC 28212, USA",
      "poi_short_description": "114-acre county park with a lake & fishing pier, soccer fields, hiking & bike trails, & a dog park.",
      "poi_long_description": "114-acre county park with a lake & fishing pier, soccer fields, hiking & bike trails, & a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-d5de-7144-a836-95c7347a684a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-d5de-7144-a836-95c7347a684a",
        "storage_key": "property/6767906449166947/019d02d8-d5de-7144-a836-95c7347a684a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.charlottesgotalot.com/things-to-do/outdoors-adventure/mcalpine-creek-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16208764795226960044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalpine-creek-park",
      "poi_latitude": "35.1499816",
      "poi_longitude": "-80.7409267",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 704-552-8213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZHiVRMhVIgRrDBcG7QZ8eA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7b3dff52-1409-484b-bdc0-41746dac8f31",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Freedom Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1908 East Blvd, Charlotte, NC 28203, USA",
      "poi_short_description": "A lakeside bandshell anchors this large park, which also has sports fields, a playground & trails.",
      "poi_long_description": "A lakeside bandshell anchors this large park, which also has sports fields, a playground & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-d671-7069-8cb8-fab50ace6ff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-d671-7069-8cb8-fab50ace6ff3",
        "storage_key": "property/6767906449166947/019d02d8-d671-7069-8cb8-fab50ace6ff3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.charlottesgotalot.com/things-to-do/outdoors-adventure/freedom-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17958176219168680732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freedom-park",
      "poi_latitude": "35.1914488",
      "poi_longitude": "-80.8434408",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8WXmaSfVogRHKtq9R9COPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3c7b4269-a488-4fc5-b2b0-db702630d712",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Wing Haven",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "248 Ridgewood Ave, Charlotte, NC 28209, USA",
      "poi_short_description": "Enclosed-brick gardens & bird sanctuary featuring quaint, ambling pathways & landscaped greens.",
      "poi_long_description": "Enclosed-brick gardens & bird sanctuary featuring quaint, ambling pathways & landscaped greens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-2c9e-7024-aa81-e3bbca3490d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-2c9e-7024-aa81-e3bbca3490d3",
        "storage_key": "property/6767906449166947/019d02d4-2c9e-7024-aa81-e3bbca3490d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://winghavengardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10341539006355915403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wing-haven",
      "poi_latitude": "35.178986",
      "poi_longitude": "-80.84087799999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-331-0664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdngNbKfVogRi8KwOO-GhI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_a8483b62-5421-41c9-a8b1-0cf50340a4dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Latta Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 E Park Ave, Charlotte, NC 28203, USA",
      "poi_short_description": "32-acre county park with sports facilities, hiking/biking trails, a playground & a picnic shelter.",
      "poi_long_description": "32-acre county park with sports facilities, hiking/biking trails, a playground & a picnic shelter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-d908-770d-9fc2-f671f6850bdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-d908-770d-9fc2-f671f6850bdd",
        "storage_key": "property/6767906449166947/019d02d8-d908-770d-9fc2-f671f6850bdd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://charmeck.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3427938813053311795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "latta-park",
      "poi_latitude": "35.2084877",
      "poi_longitude": "-80.84797089999999",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63ba-763b-903a-e9df858d7927",
        "storage_key": "property/6767906449166947/019d02d4-63ba-763b-903a-e9df858d7927.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxJJqYSfVogRMxvRPzB8ki8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9d1f3ccd-5e23-4d16-934f-fc606ab6858b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Tyvola",
      "poi_type": "Transportation & Transit",
      "poi_address": "5703 Old Pineville Rd, Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-32cc-76cf-a9a4-62dd0f1d08dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-32cc-76cf-a9a4-62dd0f1d08dc",
        "storage_key": "property/6767906449166947/019d02d4-32cc-76cf-a9a4-62dd0f1d08dc.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.lynxcharlotte.com/lynx-stations/tyvola-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13535797087723642227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyvola",
      "poi_latitude": "35.16296",
      "poi_longitude": "-80.87753909999999",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW7CabMKeVogRc92ITbzP2Ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_175c8444-89a2-4651-92b3-8ff5116c77d9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Archdale",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-33c8-74e9-a88c-ec36def97600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-33c8-74e9-a88c-ec36def97600",
        "storage_key": "property/6767906449166947/019d02d4-33c8-74e9-a88c-ec36def97600.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6965990069619877714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "archdale",
      "poi_latitude": "35.152897",
      "poi_longitude": "-80.877485",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF6NBMb6eVogRUmeXmA8rrGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_13314995-8e25-4a2f-8727-98538e769b93",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Woodlawn",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-33fd-7112-8527-f5278c5dd9d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-33fd-7112-8527-f5278c5dd9d9",
        "storage_key": "property/6767906449166947/019d02d4-33fd-7112-8527-f5278c5dd9d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9466075608414685374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodlawn",
      "poi_latitude": "35.1758832",
      "poi_longitude": "-80.8790655",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd4PlqN-eVogRvgiMyJxBXoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_b33b9834-ae02-4f6a-b75e-22c85e1ab158",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Scaleybark",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-3631-779a-9e46-c779b7be4d66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-3631-779a-9e46-c779b7be4d66",
        "storage_key": "property/6767906449166947/019d02d4-3631-779a-9e46-c779b7be4d66.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12646221790687690687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scaleybark",
      "poi_latitude": "35.1909212",
      "poi_longitude": "-80.8750282",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Uw5thefVogRv3--ULdngK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7a311485-7d00-47bc-95ef-beaf02820997",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Arrowood",
      "poi_type": "Transportation & Transit",
      "poi_address": "7717 England St, Charlotte, NC 28273, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-39c3-7299-b2f4-3a1fbfaf17fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-39c3-7299-b2f4-3a1fbfaf17fb",
        "storage_key": "property/6767906449166947/019d02d4-39c3-7299-b2f4-3a1fbfaf17fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14722700404858059672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arrowood",
      "poi_latitude": "35.1357077",
      "poi_longitude": "-80.8763881",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmyriip-eVogRmHsQlgOKUcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_78f032c2-62dc-48ac-b078-0d9dacd64e65",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "I-485/South Boulevard Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-dd34-722a-826d-f46e348f5e2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-dd34-722a-826d-f46e348f5e2d",
        "storage_key": "property/6767906449166947/019d02d8-dd34-722a-826d-f46e348f5e2d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8510204240825878000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "i-485south-boulevard-station",
      "poi_latitude": "35.107082",
      "poi_longitude": "-80.882919",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5yKpm6cVogR8AVzBKtRGnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_d000211e-705c-4b67-9b7a-7c6a9f3b9c20",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Sharon Road West Lynx Parking Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "8815 Crump Rd, Pineville, NC 28134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ddd4-7057-bef2-6138e3f900ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-ddd4-7057-bef2-6138e3f900ac",
        "storage_key": "property/6767906449166947/019d02d8-ddd4-7057-bef2-6138e3f900ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://usmaplocation.org/business/sharon-road-west-lynx-parking-lot-6sg1tm",
      "poi_directions_map_url": "https://maps.google.com/?cid=18268401843700240924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharon-road-west-lynx-parking-lot",
      "poi_latitude": "35.1200926",
      "poi_longitude": "-80.882401",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-eed1-71be-9b9e-f06602626d77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d8-eed1-71be-9b9e-f06602626d77",
        "storage_key": "property/6767906449166947/019d02d8-eed1-71be-9b9e-f06602626d77.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ452fMxGcVogRHBLYy69mhv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_a1df0e35-9112-4ab2-b19b-f8fe773a9618",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-3b87-76ac-b490-efc90a674110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-3b87-76ac-b490-efc90a674110",
        "storage_key": "property/6767906449166947/019d02d4-3b87-76ac-b490-efc90a674110.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.ridetransit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7843406414498383660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2243513",
      "poi_longitude": "-80.8413051",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-6931-759b-9b46-46047ec6b615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-6931-759b-9b46-46047ec6b615",
        "storage_key": "property/6767906449166947/019d02d4-6931-759b-9b46-46047ec6b615.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6xY9CWgVogRLEcy7ZNg2Ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_c59368ac-092a-4bf8-9dd9-5bd2756d46a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Amtrak Charlotte Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1914 N Tryon St, Charlotte, NC 28206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-ddbb-72a0-b5f9-849b11108dbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-ddbb-72a0-b5f9-849b11108dbe",
        "storage_key": "property/6767906449166947/019d02d8-ddbb-72a0-b5f9-849b11108dbe.webp",
        "width": 750,
        "height": 435
      },
      "poi_business_url": "http://www.amtrak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17371830586323027624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak-charlotte-station",
      "poi_latitude": "35.2412903",
      "poi_longitude": "-80.8226901",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 866-227-0296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZ3bklOhVogRqMYM3OAjFfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_9cb59860-2276-46d6-968c-8369c18479e3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Atrium Health Carolinas Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Blythe Blvd, Charlotte, NC 28203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-0e5b-70d7-8333-66f63b8736de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0e5b-70d7-8333-66f63b8736de",
        "storage_key": "property/6767906449166947/019d02d4-0e5b-70d7-8333-66f63b8736de.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/carolinas-medical-center?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=15333130286636265397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-carolinas-medical-center",
      "poi_latitude": "35.2037121",
      "poi_longitude": "-80.83882260000001",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-355-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-64ca-7770-8137-7b90b8a212d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-64ca-7770-8137-7b90b8a212d3",
        "storage_key": "property/6767906449166947/019d02d4-64ca-7770-8137-7b90b8a212d3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwD7bJGfVogRte-83cE4ytQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_655f9a7f-87aa-4958-a2dc-8788894dfe77",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Atrium Health Pineville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10628 Park Rd, Charlotte, NC 28210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-e118-707c-ba9a-667798014668.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-e118-707c-ba9a-667798014668",
        "storage_key": "property/6767906449166947/019d02d8-e118-707c-ba9a-667798014668.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-pineville?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=5577615577059717873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-pineville",
      "poi_latitude": "35.0918492",
      "poi_longitude": "-80.8713906",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-667-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-64ca-7770-8137-7b90b8a212d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-64ca-7770-8137-7b90b8a212d3",
        "storage_key": "property/6767906449166947/019d02d4-64ca-7770-8137-7b90b8a212d3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-mdN1-cVogR8XJU3NCrZ00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_74c2037f-10e2-47b6-9029-dd3f4d0b4182",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Novant Health Presbyterian Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Hawthorne Ln, Charlotte, NC 28204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-4477-722d-a38d-46984af8f023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-4477-722d-a38d-46984af8f023",
        "storage_key": "property/6767906449166947/019d02d4-4477-722d-a38d-46984af8f023.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/presbyterian-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-11",
      "poi_directions_map_url": "https://maps.google.com/?cid=10965927297486108609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-presbyterian-medical-center",
      "poi_latitude": "35.2117536",
      "poi_longitude": "-80.8244434",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-384-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-64ca-7770-8137-7b90b8a212d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-64ca-7770-8137-7b90b8a212d3",
        "storage_key": "property/6767906449166947/019d02d4-64ca-7770-8137-7b90b8a212d3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUij1PafVogRwTdr78bMLpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_938d6745-123f-442d-91dd-d3f137bc36c4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Bank of America Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 N Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Part of a chain, this financial institution offers services like accounts, credit cards, and deposits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-48a5-72ad-8fdc-ec0124f7e1dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-48a5-72ad-8fdc-ec0124f7e1dd",
        "storage_key": "property/6767906449166947/019d02d4-48a5-72ad-8fdc-ec0124f7e1dd.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.bankofamerica.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6278332633274031391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bank-of-america-corporate-center",
      "poi_latitude": "35.2275159",
      "poi_longitude": "-80.8421672",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-432-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3DKDCWgVogRH50KFEQeIVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_6ccaf770-4b47-4f6e-94f5-3276e7af38ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Truist Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "214 N Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-4b94-760a-87b2-54bd83d3b106.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-4b94-760a-87b2-54bd83d3b106",
        "storage_key": "property/6767906449166947/019d02d4-4b94-760a-87b2-54bd83d3b106.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.truist.com/branch/nc/charlotte/28202/214-n-tryon-st-ste-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=12412407560634313315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truist-center",
      "poi_latitude": "35.22824689999999",
      "poi_longitude": "-80.8413663",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-625-5821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVLqFyWgVogRYyr7oum6Qaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c052b156-6f91-4a4d-a872-08c5fda9650d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Duke Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "525 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-474d-7778-aef2-1c58bfe209be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-474d-7778-aef2-1c58bfe209be",
        "storage_key": "property/6767906449166947/019d02d4-474d-7778-aef2-1c58bfe209be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.duke-energy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3821899997112668324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duke-energy",
      "poi_latitude": "35.2232802",
      "poi_longitude": "-80.84799799999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-774-1226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeckepVqhVogRpJD3TswdCjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cce24416-9b89-411e-937e-996b873da05c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Three Wells Fargo Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-e399-71f2-a2f2-50a969ef325c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-e399-71f2-a2f2-50a969ef325c",
        "storage_key": "property/6767906449166947/019d02d8-e399-71f2-a2f2-50a969ef325c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wellsfargo.com/locator/bank/401__SOUTH__TRYON__STREET_CHARLOTTE_NC_28202/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18113253071806264623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-wells-fargo-center",
      "poi_latitude": "35.2246703",
      "poi_longitude": "-80.84626109999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-869-3557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-553a-7141-bbe3-c7ed908a71c2",
        "storage_key": "property/6767906449166947/019d02d4-553a-7141-bbe3-c7ed908a71c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UeN1C6gVogRL_XDX7MzX_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_20bb369d-aa92-4486-b5f3-fecfa29c6dbf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-e3b2-721c-b596-b8a525ed7b03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-e3b2-721c-b596-b8a525ed7b03",
        "storage_key": "property/6767906449166947/019d02d8-e3b2-721c-b596-b8a525ed7b03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-69f6-756e-a360-0a759aa2569d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-69f6-756e-a360-0a759aa2569d",
        "storage_key": "property/6767906449166947/019d02d4-69f6-756e-a360-0a759aa2569d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_250ed546-c750-43d4-9118-e6ad0aedb8a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-4e2d-739c-a868-86d8d0216ed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-4e2d-739c-a868-86d8d0216ed7",
        "storage_key": "property/6767906449166947/019d02d4-4e2d-739c-a868-86d8d0216ed7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "14.2",
      "poi_walking_minutes": "5 hours 17 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_56872cb4-0801-49b4-90b0-9fc3b89635d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Charlotte-Mecklenburg Government Center (CMGC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 E 4th St, Charlotte, NC 28202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d8-e625-760c-82d1-36cf731ac3a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d8-e625-760c-82d1-36cf731ac3a5",
        "storage_key": "property/6767906449166947/019d02d8-e625-760c-82d1-36cf731ac3a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://charlottenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8518659773066606155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-mecklenburg-government-center-cmgc",
      "poi_latitude": "35.2216474",
      "poi_longitude": "-80.8393449",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-336-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-63b8-7528-a8c7-a60ddf3baab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-63b8-7528-a8c7-a60ddf3baab5",
        "storage_key": "property/6767906449166947/019d02d4-63b8-7528-a8c7-a60ddf3baab5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9MQ3CagVogRS3YLCO5bOHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_80edda5c-211f-46e9-93e8-cb372f29cb2b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Steele Creek Elementary",
      "poi_type": "Education",
      "poi_address": "4100 Gallant Ln, Charlotte, NC 28273, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019f1e91-76e5-77ee-8c73-6b94fc9c536b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1e91-76e5-77ee-8c73-6b94fc9c536b",
        "storage_key": "property/6767906449166947/019f1e91-76e5-77ee-8c73-6b94fc9c536b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/steelecreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=2393977907005012583&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "steele-creek-elementary",
      "poi_latitude": "35.1571073",
      "poi_longitude": "-80.95570819999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-343-3810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOf2xMJeZVogRZ7oq-zgeOSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_abc0ee2e-982b-450f-8fa8-2838a95e243c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Kennedy Middle School",
      "poi_type": "Education",
      "poi_address": "4000 Gallant Ln, Charlotte, NC 28273, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019f1e91-7687-762e-97a0-5829de34e306.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1e91-7687-762e-97a0-5829de34e306",
        "storage_key": "property/6767906449166947/019f1e91-7687-762e-97a0-5829de34e306.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/kennedyMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=11663240217109609967&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kennedy-middle-school",
      "poi_latitude": "35.1534657",
      "poi_longitude": "-80.9559318",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-343-5540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ78qmeJCZVogR7z3e1i4n3KE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_97cf9f02-d7dc-4516-8c75-88c4fe18ba02",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "custom",
      "poi_name": "Olympic High School",
      "poi_type": "Education",
      "poi_address": "4301 Sandy Porter Rd, Charlotte, NC 28273, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/olympicHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=8873230618316850778&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olympic-high-school",
      "poi_latitude": "35.157963",
      "poi_longitude": "-80.95237600000002",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-343-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5cf4-7631-b45d-d6ba81544b2b",
        "storage_key": "property/6767906449166947/019d02d4-5cf4-7631-b45d-d6ba81544b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGxUmuZmZVogRWkblJjwMJHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    }
  ],
  "office_hours": [
    {
      "id": "ec_055b78b58de804dabb82108b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_75ca372d8d089d39cf2ee63f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_69eef5e71ca591f56775c172",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5181ab95484eafa64c0a46c3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c54801e286db870a5171e03a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_35e69be300c1db75a63a387a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_3b6ef276-ec58-4128-84a0-f5f636b6422a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "rating": "5.0",
      "name": "Crystal Bolling",
      "text": "On Saturday March 11, 2023 my daughter and I went for a tour of a 2br/2ba at Tapestry Tyvola. Imani was so kind and helpful. She took her time and helped us search for the perfect home for our relocation from New York. The brand new construction was amazing, from the amenities, to the details in the apartment. We instantly fell in love. I highly recommend this complex and asking for Imani Higgs when you go there!!",
      "date": "2023-03-14",
      "title": ""
    },
    {
      "id": "custom_4903f660-2e1b-47cd-8b63-dc421fe14615",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "rating": "5.0",
      "name": "Sai N",
      "text": "I give 5 stars because of the Location, Cleanliness, and Hospitality of the staffs at Tapestry Tyvola. This is my first time moving in the apartment after college and I appreciate that my leasing professional Imani Higgs has always been the most patient and has always come up with detail oriented solution to any concern I have had. I have always been wanting to bring my pets with me and  miss Jenny Kim is awesome at giving me suggestions in addition to the procedure.\nIn terms of location, I think it is very convenient because it is close to South Park Mall, brewery, train station and the airport which allign well with my priorities. The building itself is fairly new, and therefore, newer amentities such as the gym equipments, which I will be taking adventage more in the future.",
      "date": "2023-04-04",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_ceb7db476b9ce505ad4d49f6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-2ce7-7007-955c-3cb765234da0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and large windows.",
        "public_id": "019d02d7-2ce7-7007-955c-3cb765234da0",
        "storage_key": "property/6767906449166947/019d02d7-2ce7-7007-955c-3cb765234da0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR,2BA - Aramis",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LKFp1eCPjRM&play=1"
    },
    {
      "id": "ec_a3f79e67849abcd5913313c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-2cf5-743f-af74-d3d1ef9cc0d0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with large windows and natural light.",
        "public_id": "019d02d7-2cf5-743f-af74-d3d1ef9cc0d0",
        "storage_key": "property/6767906449166947/019d02d7-2cf5-743f-af74-d3d1ef9cc0d0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR,1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=q8vFuTakSZQ&play=1"
    },
    {
      "id": "ec_d5fa249787147242b26eb8c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-2d01-7272-aa00-43cec1461af3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a television, media console, and doors.",
        "public_id": "019d02d7-2d01-7272-aa00-43cec1461af3",
        "storage_key": "property/6767906449166947/019d02d7-2d01-7272-aa00-43cec1461af3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR,2BA - Aramis",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DehH1Eaza7m&play=1"
    },
    {
      "id": "ec_c99e90b88733f507cf3c2dab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-2ce9-7204-a32e-f5858f2d9328.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open-concept living area with large windows and a modern kitchen with stainless steel appliances.",
        "public_id": "019d02d7-2ce9-7204-a32e-f5858f2d9328",
        "storage_key": "property/6767906449166947/019d02d7-2ce9-7204-a32e-f5858f2d9328.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR,2BA - Aurora",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tedyMmKwvko&play=1"
    },
    {
      "id": "ec_5ac0d4baaa6b99c8fe8d0025",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-36b2-72bc-9bf8-94fffaeae580.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with hardwood floors and balcony access",
        "public_id": "019d02d7-36b2-72bc-9bf8-94fffaeae580",
        "storage_key": "property/6767906449166947/019d02d7-36b2-72bc-9bf8-94fffaeae580.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR,2BA - Meridian",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EQ5ieybF4kh&play=1"
    },
    {
      "id": "ec_f4259269541a3a369af30f85",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d7-375b-76da-bedd-4a3b71deb6f1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with wood floors, large windows, and a ceiling fan.",
        "public_id": "019d02d7-375b-76da-bedd-4a3b71deb6f1",
        "storage_key": "property/6767906449166947/019d02d7-375b-76da-bedd-4a3b71deb6f1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR,2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yKm2eu9yBpJ&play=1"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019b03ab-a46e-760e-b8be-6e87cae8d096",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-tapestry-tyvola",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947"
    },
    {
      "lead_collector_id": "019b049c-b254-7051-b2bc-8dd9b97fd63e",
      "lead_source": "LANDING_PAGE",
      "name": "amc-tapestry-tyvola-lp",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pools-charlotte-nc",
      "search_query": "luxury apartments with pools charlotte nc",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pools in Charlotte, NC",
      "h2_subtitle": "Discover luxury living at 1001 Tyvola, featuring opulent amenities like a sparkling pool. Elevate your lifestyle in beautiful Charlotte, NC.",
      "page_copy": "Welcome to 1001 Tyvola, where luxury apartments with pools in Charlotte, NC, redefine modern living. Nestled in the heart of Montclaire South, our vibrant community offers more than just stunning apartment layouts; it features high-end amenities designed to elevate your day-to-day experience. Whether you're taking a refreshing dip in our sparkling pool or catching rays on the sun deck, we provide a resort-like experience every day. \n\nBeyond the pool, 1001 Tyvola boasts EV charging stations, a state-of-the-art fitness center, and pet-friendly spaces that make it easy to bring along your furry friends. Our controlled access and conference rooms ensure you have everything you need right at your doorstep. Come discover why these luxury apartments with pools in Charlotte, NC are the perfect place to call home. Contact us today to schedule a tour!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pools Charlotte, NC",
      "seo_description": "Explore luxury apartments with pools in Charlotte, NC at 1001 Tyvola. Enjoy premium amenities in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-montclaire-south-charlotte",
      "search_query": "dog friendly apartments in montclaire south charlotte",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Montclaire South",
      "h2_subtitle": "Find the perfect space for you and your pet at 1001 Tyvola. Our pet-friendly community welcomes you in Montclaire South, Charlotte.",
      "page_copy": "At 1001 Tyvola, we understand that pets are family. That's why we offer dog friendly apartments in Montclaire South, Charlotte, perfect for you and your furry companion. Our community features designated pet-friendly spaces, allowing you and your dog to enjoy a comfortable and vibrant lifestyle. Located in the lively Montclaire South neighborhood, outdoor adventures and ample walking trails are just a step outside your door.\n\nIn addition to being a pet lover’s haven, our community boasts top-tier amenities that include a sparkling pool, fitness center, and EV charging stations. With our 24-hour conference rooms and controlled access entrances, you can enjoy a modern living experience tailored to your lifestyle. Discover a home that welcomes all members of your family, including your four-legged ones, at 1001 Tyvola.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Montclaire South",
      "seo_description": "Discover dog friendly apartments in Montclaire South. Enjoy pet-friendly living at 1001 Tyvola, a community in Charlotte tailored to you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-charlotte-28217",
      "search_query": "in unit laundry apartments charlotte 28217",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Charlotte, 28217",
      "h2_subtitle": "Experience the convenience of in-unit laundry at 1001 Tyvola. Located in the thriving 28217 area of Charlotte, this is modern living at its best.",
      "page_copy": "Imagine the convenience of in-unit laundry in your apartment at 1001 Tyvola, nestled in the vibrant 28217 area of Charlotte. Our modern floor plans offer this essential feature, making laundry days simple and stress-free. In a bustling city like Charlotte, NC, having an in-unit washer and dryer is more than a luxury—it's a necessity. \n\nBeyond convenience, 1001 Tyvola is home to a range of amenities designed to elevate your lifestyle. Enjoy our sparkling pool on sunny days, and stay active in our state-of-the-art fitness center. We also feature EV charging stations and pet-friendly spaces, ensuring our community caters to all aspects of contemporary life. Discover the ease of in-unit laundry and the many other perks of living at 1001 Tyvola, where comfort meets style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Charlotte, 28217",
      "seo_description": "Convenience meets luxury with in-unit laundry apartments at 1001 Tyvola in Charlotte, 28217. Elevate your lifestyle today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-mecklenburg-county",
      "search_query": "fitness center apartments mecklenburg county",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Mecklenburg County",
      "h2_subtitle": "Stay active at 1001 Tyvola with our modern fitness center. Explore apartment living in the heart of Mecklenburg County that prioritizes well-being.",
      "page_copy": "For those seeking fitness center apartments in Mecklenburg County, 1001 Tyvola offers modern living designed around your wellness goals. Our state-of-the-art fitness center ensures you have access to the best exercise equipment right at your doorstep. Whether you're an avid gym-goer or just starting out, you'll find everything you need to maintain an active lifestyle within our community.\n\nLocated in Charlotte's vibrant Montclaire South neighborhood, 1001 Tyvola provides not just fitness amenities but also a host of luxury features. Enjoy relaxing by the sparkling pool or taking advantage of our EV charging stations and pet-friendly spaces. With amenities like controlled access and conference rooms available 24/7, our community caters to a lifestyle that's both convenient and fulfilling. Come see what makes living here in Mecklenburg County inspiring by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Mecklenburg County",
      "seo_description": "Discover fitness center apartments at 1001 Tyvola in Mecklenburg County. Enjoy modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-charlotte-nc",
      "search_query": "apartments with air conditioning in charlotte nc",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Charlotte, NC",
      "h2_subtitle": "Beat the heat at 1001 Tyvola with air-conditioned apartments. Relish in comfort and luxury living in the heart of Charlotte, NC.",
      "page_copy": "At 1001 Tyvola, comfort is a priority, especially during Charlotte's warmest months. Our apartments with air conditioning provide the ideal sanctuary from the city heat, ensuring you enjoy a pleasant indoor atmosphere all year round. Located in vibrant Charlotte, NC, our community combines modern amenities with a prime location to enhance your everyday living experience.\n\nBeyond air-conditioned comfort, explore the variety of amenities available at 1001 Tyvola. Dive into our sparkling pool, get active in the fitness center, or unwind in pet-friendly spaces. With 24-hour conference rooms and convenient EV charging, our complex is designed to accommodate a dynamic lifestyle. Discover the perfect blend of convenience and luxury at 1001 Tyvola, where every apartment is equipped to provide ultimate comfort and ease.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in Charlotte, NC",
      "seo_description": "Stay cool at 1001 Tyvola with air-conditioned apartments in Charlotte, NC. Discover luxury living with premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "studio-apartments-montclaire-south",
      "search_query": "studio apartments Montclaire South",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Montclaire South",
      "h2_subtitle": "Explore modern studio living at 1001 Tyvola in Montclaire South. Experience a welcoming community with up-to-date amenities.",
      "page_copy": "Looking for stylish and comfortable studio apartments in Montclaire South? At 1001 Tyvola, we offer thoughtfully designed studio spaces that combine modern luxury with functionality. Each studio is outfitted with high-end amenities, creating an ideal environment for those seeking compact living with all the conveniences.\n\nNestled in the heart of Montclaire South, our community boasts more than just exceptional living spaces. Enjoy access to our fitness center, outdoor pool, and EV charging stations. Pet-friendly areas and 24-hour controlled access ensure that you have everything you need right at home. Embrace a lifestyle of convenience and comfort when you choose a studio apartment at 1001 Tyvola, where city living meets tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Montclaire South",
      "seo_description": "Discover modern studio apartments at 1001 Tyvola in Montclaire South. Enjoy luxury amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "1-bedroom-apartment-charlotte-nc",
      "search_query": "1 bedroom apartment Charlotte NC",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartment in Charlotte, NC",
      "h2_subtitle": "Discover spacious 1 bedroom apartments at 1001 Tyvola in Charlotte, NC. Experience modern living with luxurious amenities.",
      "page_copy": "If you're in search of a comfortable 1 bedroom apartment in Charlotte, NC, look no further than 1001 Tyvola. Our thoughtfully designed 1 bedroom layouts offer ample space and include modern features that cater to your lifestyle needs. Located in the vibrant Montclaire South neighborhood, these apartments are the perfect blend of comfort and style.\n\nResidents of 1001 Tyvola enjoy access to a variety of premium amenities including a fitness center, sparkling swimming pool, and pet-friendly areas. With 24-hour controlled access and conference rooms, life is convenient and secure. Experience the best of Charlotte living in our meticulously maintained community, designed to enhance your day-to-day with luxury and ease.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartment in Charlotte, NC",
      "seo_description": "Find spacious 1 bedroom apartments in Charlotte, NC at 1001 Tyvola. Enjoy comfort with stylish amenities and modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-28217",
      "search_query": "2 bedroom apartments 28217",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in 28217",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at 1001 Tyvola in the 28217 zip code. Luxurious amenities await you in Charlotte, NC.",
      "page_copy": "Discover the perfect home with our 2 bedroom apartments in the 28217 area at 1001 Tyvola. Our thoughtfully crafted floor plans provide ample living space ideally suited for families, roommates, or those who simply desire extra room. Situated in the heart of Charlotte, NC, this community caters to diverse lifestyle needs with a host of modern amenities designed for your comfort.\n\nResidents at 1001 Tyvola enjoy a wealth of community facilities including a sparkling pool, fitness center, and EV charging stations. Our pet-friendly policies and 24-hour access make life convenient and flexible. Experience upscale living where comfort meets style in our premier 2 bedroom apartments located in the sought-after 28217 zip code.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in 28217",
      "seo_description": "Find 2 bedroom apartments in the 28217 area at 1001 Tyvola, Charlotte, NC. Enjoy spacious living with luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "3-bedroom-apartment-mecklenburg-county",
      "search_query": "3 bedroom apartment Mecklenburg County",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartment in Mecklenburg County",
      "h2_subtitle": "Discover expansive 3 bedroom apartments at 1001 Tyvola in Mecklenburg County. Experience modern living in Charlotte, NC.",
      "page_copy": "Searching for an expansive and well-appointed 3 bedroom apartment in Mecklenburg County? Look no further than 1001 Tyvola, where spacious living meets modern luxury. Our 3 bedroom units are designed to provide ample room for families or individuals who value extra space, coupled with contemporary finishes and top-notch conveniences.\n\nLocated in Charlotte's vibrant Montclaire South neighborhood, residents of 1001 Tyvola enjoy access to a host of amenities. From our resort-style pool and state-of-the-art fitness center to pet-friendly areas and controlled access, every feature is crafted to enhance your lifestyle. Choose a home where comfort and community blend seamlessly, and experience the best of Mecklenburg County living at 1001 Tyvola.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartment in Mecklenburg County",
      "seo_description": "Explore spacious 3 bedroom apartments at 1001 Tyvola in Mecklenburg County. Discover luxury amenities in Charlotte, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-near-nations-ford-elementary-charlotte",
      "search_query": "apartments near Nations Ford Elementary Charlotte",
      "category": "School",
      "h1_title": "Apartments Near Nations Ford Elementary",
      "h2_subtitle": "Find ideal apartments near Nations Ford Elementary at 1001 Tyvola. Enjoy convenient living in Charlotte, NC with excellent amenities.",
      "page_copy": "Searching for apartments near Nations Ford Elementary in Charlotte? 1001 Tyvola offers the perfect location for families prioritizing both education and vibrant community living. Our modern apartments provide easy access to excellent schools, making them an ideal choice for those seeking proximity to Nations Ford Elementary.\n\nBeyond its prime location, 1001 Tyvola boasts a suite of amenities designed to cater to diverse lifestyles. With features like controlled access, a fitness center, and a pet-friendly atmosphere, our community ensures comfort and convenience for residents. Choose 1001 Tyvola for a seamless blend of educational advantage and luxurious living in the heart of Charlotte.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Nations Ford Elementary",
      "seo_description": "Discover apartments near Nations Ford Elementary at 1001 Tyvola, Charlotte. Enjoy amenities and convenient family living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "rentals-metrolina-regional-scholars-academy-nc",
      "search_query": "rentals by Metrolina Regional Scholars Academy NC",
      "category": "School",
      "h1_title": "Rentals by Metrolina Regional Scholars Academy",
      "h2_subtitle": "Explore ideal rentals by Metrolina Regional Scholars Academy at 1001 Tyvola. Experience modern living with easy access to education and amenities.",
      "page_copy": "Looking for rentals by Metrolina Regional Scholars Academy in NC? 1001 Tyvola offers expertly designed living spaces perfect for families prioritizing educational excellence and urban living. Located within convenient proximity to the Scholars Academy, our community provides an ideal setting for easy commutes.\n\nAt 1001 Tyvola, residents are welcomed with an array of high-end amenities, including a sparkling pool, fitness center, and EV charging facilities. With controlled access and a pet-friendly environment, we ensure a living experience that is both comfortable and secure. Choose our community for a harmonious blend of location, convenience, and modern living near Metrolina Regional Scholars Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Metrolina Regional Scholars Academy",
      "seo_description": "Find rentals near Metrolina Regional Scholars Academy at 1001 Tyvola, NC. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "student-housing-near-reid-park-academy-28217",
      "search_query": "student housing near Reid Park Academy 28217",
      "category": "School",
      "h1_title": "Student Housing Near Reid Park Academy",
      "h2_subtitle": "Discover student housing near Reid Park Academy at 1001 Tyvola, located in the 28217 area. Enjoy a vibrant community in Charlotte, NC.",
      "page_copy": "For those seeking student housing near Reid Park Academy in the 28217 area, 1001 Tyvola offers an unmatched living experience in Charlotte. Our residences are perfect for students and their families, providing both convenience and comfort close to the academy's educational facilities.\n\nLiving at 1001 Tyvola means enjoying an array of amenities like a modern fitness center, conference rooms, and a sparkling pool, all designed to balance study with leisure. Additionally, our pet-friendly and secure controlled access community ensures a safe and welcoming environment in the heart of Charlotte, NC. Embrace the ideal blend of education-focused living and vibrant amenities at 1001 Tyvola.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Student Housing Near Reid Park Academy",
      "seo_description": "Explore student housing options near Reid Park Academy at 1001 Tyvola. Enjoy modern amenities and convenience in the 28217 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "living-near-john-crosland-school-mecklenburg-county",
      "search_query": "living near The John Crosland School Mecklenburg County",
      "category": "School",
      "h1_title": "Living Near The John Crosland School",
      "h2_subtitle": "Experience living near The John Crosland School at 1001 Tyvola in Mecklenburg County. Enjoy modern amenities and a vibrant community.",
      "page_copy": "For families considering living near The John Crosland School in Mecklenburg County, 1001 Tyvola offers an exceptional living environment tailored to educational and lifestyle needs. Located in the heart of Charlotte, our community provides seamless access to the school, ensuring both convenience and a supportive living experience.\n\nAt 1001 Tyvola, residents benefit from an impressive array of amenities, including a relaxing pool, fitness center, and EV charging facilities. Our pet-friendly atmosphere and controlled access make it an ideal choice for families valuing both security and comfort. Choose 1001 Tyvola for a perfect blend of educational proximity and modern living in vibrant Mecklenburg County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near The John Crosland School",
      "seo_description": "Discover the benefits of living near The John Crosland School at 1001 Tyvola, Mecklenburg County. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-by-central-piedmont-community-college-harper-campus",
      "search_query": "apartments by Central Piedmont Community College Harper Campus",
      "category": "School",
      "h1_title": "Apartments by Central Piedmont Community College",
      "h2_subtitle": "Find ideal apartments by Central Piedmont Community College Harper Campus at 1001 Tyvola. Enjoy community living and modern conveniences.",
      "page_copy": "Searching for apartments by Central Piedmont Community College Harper Campus? Discover the perfect blend of comfort and convenience at 1001 Tyvola. Located just minutes away from Harper Campus, our community offers easy access to education alongside unrivaled amenities.\n\nAt 1001 Tyvola, residents can enjoy a vibrant lifestyle with top-notch facilities such as a sparkling pool, fitness center, and conference rooms. Our pet-friendly community incorporates EV charging stations and ensures safety with controlled access. Choose 1001 Tyvola and embrace modern living in an ideal location, close to one of Charlotte's educational hubs, Central Piedmont Community College Harper Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Central Piedmont Community College",
      "seo_description": "Find apartments near Central Piedmont Community College Harper Campus at 1001 Tyvola. Enjoy modern amenities and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-close-to-queens-university-of-charlotte-montclaire-south",
      "search_query": "apartments close to Queens University of Charlotte Montclaire South",
      "category": "School",
      "h1_title": "Apartments Close to Queens University",
      "h2_subtitle": "Discover apartments close to Queens University of Charlotte in Montclaire South. Enjoy a vibrant community with modern amenities at 1001 Tyvola.",
      "page_copy": "For students or professionals seeking apartments close to Queens University of Charlotte, 1001 Tyvola provides an exceptional choice in the Montclaire South neighborhood. With easy access to the university, our community offers both proximity to campus and a serene living environment.\n\n1001 Tyvola features an array of amenities including a refreshing pool, a state-of-the-art fitness center, and pet-friendly spaces, designed to enhance your lifestyle. Additionally, our community offers secure, controlled access and EV charging stations, making it a top choice for modern living. Experience the perfect combination of convenience and comfort at 1001 Tyvola, your next home near Queens University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Queens University",
      "seo_description": "Discover apartments near Queens University of Charlotte in Montclaire South at 1001 Tyvola. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-near-atrium-health-carolinas-medical-center-charlotte",
      "search_query": "apartments near Atrium Health Carolinas Medical Center Charlotte",
      "category": "Hospital",
      "h1_title": "Apartments Near Atrium Health Carolinas Medical",
      "h2_subtitle": "Explore living options near Atrium Health Carolinas Medical Center in Charlotte. Experience modern amenities at 1001 Tyvola.",
      "page_copy": "Looking for apartments near Atrium Health Carolinas Medical Center in Charlotte? Consider making 1001 Tyvola your new home, where convenience meets comfort. Situated with easy access to Carolinas Medical Center, 1001 Tyvola provides an ideal location for healthcare professionals and patients seeking nearby accommodations.\n\nResidents of 1001 Tyvola enjoy a host of amenities designed for modern living, including a sparkling pool, a well-equipped fitness center, and on-site conference rooms. Our pet-friendly community ensures peace of mind with controlled access and EV charging stations. Choose 1001 Tyvola for a seamless living experience close to Charlotte’s premier medical hub, Atrium Health Carolinas Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atrium Health Carolinas Medical",
      "seo_description": "Find apartments near Atrium Health Carolinas Medical Center at 1001 Tyvola in Charlotte. Enjoy modern living and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-near-little-sugar-creek-greenway-charlotte",
      "search_query": "apartments near Little Sugar Creek Greenway Charlotte",
      "category": "Park",
      "h1_title": "Apartments Near Little Sugar Creek Greenway",
      "h2_subtitle": "Discover apartments near Little Sugar Creek Greenway in Charlotte. Enjoy nature and modern comforts at 1001 Tyvola.",
      "page_copy": "If you're in search of apartments near Little Sugar Creek Greenway in Charlotte, 1001 Tyvola offers the perfect blend of urban convenience and natural beauty. Located near this picturesque greenway, our community provides residents with easy access to outdoor adventures and leisurely strolls along the lush paths of Little Sugar Creek.\n\nAt 1001 Tyvola, enjoy an array of modern amenities designed to enhance your lifestyle, including a shimmering pool, cutting-edge fitness center, and pet-friendly areas. We prioritize your security with controlled access and offer EV charging stations for eco-conscious living. Experience the vibrant community living at 1001 Tyvola, your home nestled near Charlotte’s charming Little Sugar Creek Greenway.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Little Sugar Creek Greenway",
      "seo_description": "Find modern apartments near Little Sugar Creek Greenway in Charlotte at 1001 Tyvola. Enjoy scenic nature and urban living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "huntingtowne-farms-park-nearby-apartments",
      "search_query": "Huntingtowne Farms Park nearby apartments",
      "category": "Park",
      "h1_title": "Huntingtowne Farms Park Nearby Apartments",
      "h2_subtitle": "Explore nearby apartments to Huntingtowne Farms Park in Charlotte. Embrace a lifestyle of comfort at 1001 Tyvola.",
      "page_copy": "For those seeking apartments near Huntingtowne Farms Park, 1001 Tyvola offers a prime location in the vibrant city of Charlotte. Enjoy the tranquil beauty of the park, ideal for outdoor relaxation and recreation, while residing in a community that prioritizes modern living and convenience.\n\nAt 1001 Tyvola, you'll find state-of-the-art amenities including a refreshing pool, well-equipped fitness center, and pet-friendly spaces. Our secure community features controlled access and eco-friendly EV charging stations. Choose 1001 Tyvola, where proximity to Huntingtowne Farms Park is paired with exceptional comfort and style, creating the perfect home base in Charlotte.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Huntingtowne Farms Park Nearby Apartments",
      "seo_description": "Discover nearby apartments to Huntingtowne Farms Park at 1001 Tyvola, Charlotte. Enjoy modern amenities and a park-side lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "park-road-park-charlotte-nc-living",
      "search_query": "Park Road Park Charlotte NC living",
      "category": "Park",
      "h1_title": "Park Road Park Charlotte NC Living",
      "h2_subtitle": "Experience vibrant living near Park Road Park in Charlotte. Discover the comfort of 1001 Tyvola.",
      "page_copy": "Embrace the opportunity of Park Road Park Charlotte NC living at 1001 Tyvola, where nature and modern elegance seamlessly blend. Located just minutes from the expansive Park Road Park, our community offers a unique living experience filled with outdoor activities and serene parkland views.\n\nResidents at 1001 Tyvola enjoy luxurious amenities such as a sparkling pool, advanced fitness center, and welcoming pet-friendly spaces. Our community ensures peace of mind with controlled access and sustainable living with EV charging stations. At 1001 Tyvola, you can revel in the beauty of Park Road Park while enjoying the convenience of contemporary living in Charlotte.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Road Park Charlotte NC Living",
      "seo_description": "Live near Park Road Park, Charlotte at 1001 Tyvola. Enjoy access to park life and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "renaissance-park-apartments-mecklenburg-county",
      "search_query": "Renaissance Park apartments in Mecklenburg County",
      "category": "Park",
      "h1_title": "Renaissance Park Apartments in Mecklenburg",
      "h2_subtitle": "Discover the lifestyle at Renaissance Park apartments in Mecklenburg County. Enjoy modern amenities at 1001 Tyvola.",
      "page_copy": "If you're seeking Renaissance Park apartments in Mecklenburg County, look no further than the contemporary living options at 1001 Tyvola. Enjoy a vibrant lifestyle in a prime location close to the lush landscapes and recreational offerings of Renaissance Park, creating a balanced blend of outdoor adventure and urban convenience.\n\nAt 1001 Tyvola, residents can take advantage of premium amenities like our refreshing pool, state-of-the-art fitness center, and pet-friendly environments. We prioritize security with controlled access and offer eco-friendly amenities such as EV charging stations. Choose 1001 Tyvola to experience the best of Renaissance Park living coupled with the comfort and convenience of a modern community in Charlotte, NC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Renaissance Park Apartments in Mecklenburg",
      "seo_description": "Explore Renaissance Park apartments in Mecklenburg County at 1001 Tyvola. Enjoy modern comforts and park-side living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "charlotte-apartments-near-clt-airport-overlook",
      "search_query": "Charlotte apartments near CLT Airport overlook",
      "category": "Park",
      "h1_title": "Charlotte Apartments Near CLT Airport Overlook",
      "h2_subtitle": "Find Charlotte apartments near the CLT Airport overlook. Discover convenience and style at 1001 Tyvola.",
      "page_copy": "Choosing Charlotte apartments near the CLT Airport overlook provides you with both convenience and modern comforts. Located just a short drive from the overlook, 1001 Tyvola offers an ideal home base for those who travel frequently or simply enjoy the unique sight of aviation activities at the airport.\n\nAt 1001 Tyvola, residents can enjoy an array of high-end amenities, including a refreshing swimming pool, a fully equipped fitness center, and pet-friendly spaces. The community also features controlled access and eco-friendly perks like EV charging stations, ensuring a sustainable lifestyle. Embrace the vibrant living experience at 1001 Tyvola, where the excitement of the CLT Airport overlook is just around the corner.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Charlotte Apartments Near CLT Airport Overlook",
      "seo_description": "Discover the convenience of Charlotte apartments near CLT Airport overlook at 1001 Tyvola. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "mcalpine-creek-park-montclaire-south-apartments",
      "search_query": "McAlpine Creek Park Montclaire South apartments",
      "category": "Park",
      "h1_title": "McAlpine Creek Park Montclaire South Apartments",
      "h2_subtitle": "Explore McAlpine Creek Park and Montclaire South apartments. Find your new home at 1001 Tyvola.",
      "page_copy": "Immerse yourself in nature and modern living with McAlpine Creek Park Montclaire South apartments, where you can find comfort and convenience at 1001 Tyvola. Situated close to the stunning McAlpine Creek Park, our community offers the perfect blend of peaceful natural trails and urban amenities.\n\nResidents at 1001 Tyvola enjoy access to luxurious features such as a glistening pool, a top-tier fitness center, and spacious pet-friendly areas. With controlled access and EV charging stations, we prioritize your safety and sustainability. Experience the charm of Montclaire South living with the added benefit of having McAlpine Creek Park as your extended backyard, all while enjoying the community spirit at 1001 Tyvola.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "McAlpine Creek Park Montclaire South Apartments",
      "seo_description": "Discover McAlpine Creek Park and Montclaire South living at 1001 Tyvola. Enjoy nature, comfort, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "freedom-park-nearby-living-charlotte-nc",
      "search_query": "Freedom Park nearby living Charlotte NC",
      "category": "Park",
      "h1_title": "Freedom Park Nearby Living in Charlotte, NC",
      "h2_subtitle": "Experience the charm of Freedom Park nearby living in Charlotte, NC. Discover life at 1001 Tyvola.",
      "page_copy": "For those seeking Freedom Park nearby living in Charlotte, NC, 1001 Tyvola presents an impeccable choice where comfort meets convenience. Just a short drive from the picturesque Freedom Park, our community offers residents easy access to serene picnic spots, walking trails, and playgrounds, making it an ideal location for nature lovers and families alike.\n\nAt 1001 Tyvola, you’ll enjoy a thriving community with amenities tailored to your lifestyle needs, including a refreshing pool, modern fitness facilities, and pet-friendly spaces. The convenience of controlled access and environmentally-conscious features like EV charging stations further enhance your living experience. Embrace the convenience of city life while enjoying the tranquility of nearby Freedom Park, all from your comfortable home at 1001 Tyvola.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Freedom Park Nearby Living in Charlotte, NC",
      "seo_description": "Enjoy Freedom Park nearby living in Charlotte, NC with modern amenities at 1001 Tyvola. Perfect blend of nature and urban comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "latta-park-close-to-apartments-in-28217",
      "search_query": "Latta Park close-to apartments in 28217",
      "category": "Park",
      "h1_title": "Latta Park Close-To Apartments in 28217",
      "h2_subtitle": "Discover Latta Park close-to apartments in the 28217 area. Explore life at 1001 Tyvola.",
      "page_copy": "For those in pursuit of Latta Park close-to apartments in 28217, 1001 Tyvola offers a unique blend of convenience and upscale living. Situated just a short distance from the charming Latta Park, our community provides easy access to lush green spaces, playgrounds, and picnic areas, creating an ideal retreat from city hustle.\n\nResidents at 1001 Tyvola enjoy an array of premium amenities, including a sparkling swimming pool, state-of-the-art fitness center, and pet-friendly zones. With features such as controlled access and EV charging, we prioritize both security and sustainability. Experience a vibrant community atmosphere while staying close to the natural beauty of Latta Park, all from the comfort of your luxurious apartment in the 28217 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Latta Park Close-To Apartments in 28217",
      "seo_description": "Explore Latta Park close-to apartments in 28217 at 1001 Tyvola. Enjoy nature and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-near-tyvola-station-charlotte",
      "search_query": "apartments near tyvola station charlotte",
      "category": "Transit",
      "h1_title": "Apartments Near Tyvola Station, Charlotte",
      "h2_subtitle": "Convenience meets comfort with apartments near Tyvola Station in Charlotte. Explore your new home at 1001 Tyvola.",
      "page_copy": "For those seeking the best of urban connectivity, apartments near Tyvola Station in Charlotte offer a superb lifestyle. Nestled close to this convenient transit hub, 1001 Tyvola provides effortless access to all that the city has to offer, from attractions and dining to shopping and entertainment, making daily commutes a breeze.\n\nThe 1001 Tyvola community boasts modern amenities designed to enhance your everyday living. Enjoy relaxing at our beautiful pool, stay active in our well-equipped fitness center, or take advantage of our pet-friendly spaces. With essentials like controlled access and EV charging readily available, life here is both convenient and sustainable. Discover a seamless urban lifestyle where connectivity and comfort coexist near Tyvola Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tyvola Station, Charlotte",
      "seo_description": "Find convenience at 1001 Tyvola, apartments near Tyvola Station, Charlotte. Enjoy modern amenities and easy commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-close-to-archdale-station-mecklenburg",
      "search_query": "apartments close to archdale station mecklenburg",
      "category": "Transit",
      "h1_title": "Apartments Close to Archdale Station, Mecklenburg",
      "h2_subtitle": "Looking for apartments close to Archdale Station in Mecklenburg? Discover unparalleled convenience at 1001 Tyvola.",
      "page_copy": "For those prioritizing connectivity, finding apartments close to Archdale Station in Mecklenburg is a top choice, and 1001 Tyvola fits the bill perfectly. Just a short distance from Archdale Station, our community ensures easy access to the light rail for hassle-free commuting throughout Charlotte and beyond.\n\nAt 1001 Tyvola, experience unmatched comfort with amenities designed around your lifestyle. Dive into our refreshing pool, maintain your fitness routine at the state-of-the-art gym, and enjoy pet-friendly spaces for your furry companions. With controlled access and eco-friendly EV charging stations, you’ll appreciate both convenience and sustainability. Embrace the blend of modern living with the ease of being close to Archdale Station right here in Mecklenburg.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Archdale Station, Mecklenburg",
      "seo_description": "Live at 1001 Tyvola, near Archdale Station, Mecklenburg. Enjoy easy commutes and modern amenities in your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-near-scaleybark-neighborhood-charlotte",
      "search_query": "apartments near scaleybark neighborhood charlotte",
      "category": "Transit",
      "h1_title": "Apartments Near Scaleybark Neighborhood, Charlotte",
      "h2_subtitle": "Discover apartments near Scaleybark neighborhood in Charlotte at 1001 Tyvola. A prime location for urban living.",
      "page_copy": "If you're looking for apartments near Scaleybark neighborhood in Charlotte, 1001 Tyvola offers the ideal location. Nestled close to the vibrant Scaleybark area, our community enables easy access to diverse dining, shopping, and entertainment options that make Charlotte living appealing.\n\nAt 1001 Tyvola, enjoy upscale amenities that cater to every aspect of your lifestyle. Relax by the luxurious pool, maintain your workout routine in our modern fitness center, and enjoy the convenience of pet-friendly spaces. With controlled access and EV charging stations, our community combines security with eco-friendly living. Experience the best of urban life near Scaleybark neighborhood, making your daily routines effortlessly enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Scaleybark Neighborhood, Charlotte",
      "seo_description": "Explore 1001 Tyvola, near Scaleybark neighborhood Charlotte. Enjoy modern amenities and vibrant city living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-close-to-arrowood-station-nc",
      "search_query": "apartments close to arrowood station nc",
      "category": "Transit",
      "h1_title": "Apartments Close to Arrowood Station, NC",
      "h2_subtitle": "Discover the convenience of living in apartments close to Arrowood Station, NC at 1001 Tyvola, where connectivity is key.",
      "page_copy": "Finding the perfect home means balancing location and lifestyle, and apartments close to Arrowood Station, NC offer just that at 1001 Tyvola. Situated near this key transit hub, our community ensures easy access to Charlotte's light rail, simplifying daily commutes and weekend adventures alike.\n\nAt 1001 Tyvola, luxury meets practicality with amenities crafted for modern living. Unwind by our sparkling pool, keep active in the comprehensive fitness center, and let your pets enjoy designated spaces designed just for them. Security and sustainability go hand-in-hand with features like controlled access and EV charging. Embrace a lifestyle where comfort meets convenience near Arrowood Station, ensuring every aspect of your life is catered for.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Arrowood Station, NC",
      "seo_description": "Live at 1001 Tyvola, near Arrowood Station, NC. Enjoy effortless commuting and modern amenities in your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166947",
      "source": "generator",
      "page_item_url": "apartments-near-charlotte-douglas-airport-28217",
      "search_query": "apartments near charlotte douglas airport 28217",
      "category": "Transit",
      "h1_title": "Apartments Near Charlotte Douglas Airport 28217",
      "h2_subtitle": "Looking for apartments near Charlotte Douglas Airport? Discover convenient living at 1001 Tyvola in the 28217 area.",
      "page_copy": "Located in the 28217 area, 1001 Tyvola offers the perfect blend of convenience and comfort for those seeking apartments near Charlotte Douglas Airport. Whether you're a frequent flier or part of the vibrant local workforce, living just a short drive from the airport provides unbeatable convenience.\n\n1001 Tyvola is not just about location; it's about lifestyle. Enjoy the luxury of high-end amenities, including a sparkling pool, modern fitness center, and pet-friendly spaces. Our community ensures security and sustainability with controlled access and EV charging stations. Embrace hassle-free living where the comfort of home meets the accessibility needed for travel and local exploration.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows on a clear day.",
        "public_id": "019d02d3-a869-77eb-ab57-9c55a9b6e3d8",
        "storage_key": "property/6767906449166947/019d02d3-a869-77eb-ab57-9c55a9b6e3d8.webp",
        "width": 2048,
        "height": 1235
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Charlotte Douglas Airport 28217",
      "seo_description": "Explore 1001 Tyvola, near Charlotte Douglas Airport in 28217. Enjoy modern living with amenities and easy access to the airport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5752"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10704897759"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PXMT6GKV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1134TYVO"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'><script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('ce5bVIZpqyOP89BJja')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "48561424543"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "273520"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC%20LLC/1001%20Tyvola/scheduletourwidget/ce5bVIZpqyOP89BJja/"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "980-467-2554"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjNjQ21maXA1aElmYTFNODNZUWtTZGc9PSIsInZhbHVlIjoiUGRiKy84ZFlNUjlCdHEvakU5bDF0UT09IiwibWFjIjoiYzIyZGMxZDI5Y2VjMGY3Y2JjOTZjOTNiMTczOTk0MWUxZTkxNzg4NmRkNDQ0YzFlYjQ2OWY0OGUxY2RhMTJjMiJ9"
    }
  ],
  "custom_qb_id": "5752",
  "custom_repli_id": "10704897759",
  "custom_google_gtm_id": "GTM-PXMT6GKV",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "1134TYVO",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'><script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('ce5bVIZpqyOP89BJja')</script>",
  "custom_hubspot_company_id": "48561424543",
  "custom_broker_license_number": "273520",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC%20LLC/1001%20Tyvola/scheduletourwidget/ce5bVIZpqyOP89BJja/",
  "custom_ppc_tracking_phone_number": "980-467-2554",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjNjQ21maXA1aElmYTFNODNZUWtTZGc9PSIsInZhbHVlIjoiUGRiKy84ZFlNUjlCdHEvakU5bDF0UT09IiwibWFjIjoiYzIyZGMxZDI5Y2VjMGY3Y2JjOTZjOTNiMTczOTk0MWUxZTkxNzg4NmRkNDQ0YzFlYjQ2OWY0OGUxY2RhMTJjMiJ9"
};

export const generatedAt = '2026-08-25T19:52:25.046Z';
